(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["404"]) return;
  try {
    
  /* Kurzadresse eines Rechtstexts (Liste oben aus snippets/rechtstexte):
     sofort weiter, ohne Eintrag im Verlauf. */
  (() => {
    const quelle = document.querySelector('script[data-rechtstexte]');
    if (!quelle) return;
    let karte;
    try {
      karte = JSON.parse(quelle.textContent);
    } catch {
      return;
    }
    const pfad = location.pathname.toLowerCase().replace(/\/+$/, '') || '/';
    const ziel = karte[pfad];
    if (typeof ziel === 'string' && ziel.startsWith('/')) location.replace(ziel);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["acl-formular"] && !Shopify.designMode) return;
  try {
    
  (() => {
    /* Höhe des ACL-Widgets übernehmen (siehe Kommentar oben in der Section).
       Angenommen wird nur, was aus genau diesem Rahmen und von seiner
       Herkunft kommt. Die Rahmen werden erst bei jeder Meldung gesucht —
       so greift das auch, wenn der Theme-Editor die Section neu zeichnet. */
    const finde = (quelle) => {
      for (const iframe of document.querySelectorAll('[data-acl-karte] > iframe')) {
        if (iframe.contentWindow === quelle) return iframe;
      }
      return null;
    };
    const herkunft = (iframe) => {
      try {
        return new URL(iframe.src).origin;
      } catch {
        return '';
      }
    };

    addEventListener('message', (event) => {
      const iframe = finde(event.source);
      if (!iframe || event.origin !== herkunft(iframe)) return;
      const daten = event.data;
      if (!daten || daten.event !== 'updateHeight') return;
      const hoehe = Math.ceil(Number.parseFloat(daten.data));
      if (!(hoehe > 0 && hoehe < 20000)) return;
      iframe.dataset.gemessen = '';
      delete iframe.parentElement.dataset.ohneHoehe;
      iframe.style.height = `${hoehe}px`;
    });

    /* Ohne Meldung nach dem Laden: feste Höhe, der Rahmen rollt selbst.
       load steigt nicht auf — darum in der Capture-Phase am Dokument. */
    document.addEventListener(
      'load',
      (event) => {
        const iframe = event.target;
        if (!(iframe instanceof HTMLIFrameElement) || !iframe.matches('[data-acl-karte] > iframe')) return;
        setTimeout(() => {
          if (!('gemessen' in iframe.dataset)) iframe.parentElement.dataset.ohneHoehe = '';
        }, 4000);
      },
      true,
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["adressen"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const wurzel = document.querySelector('[data-adressen]');
    const dialog = wurzel?.querySelector('[data-adresse-dialog]');
    if (!wurzel || !dialog) return;

    const lesen = (sel) => {
      try {
        return JSON.parse(wurzel.querySelector(sel)?.textContent || 'null');
      } catch {
        return null;
      }
    };
    const adressen = lesen('[data-adressen-daten]') || [];
    const T = lesen('[data-adressen-texte]') || { api: {} };
    const modus = wurzel.dataset.modus;
    const speicher = {
      lesen(k) {
        try {
          return JSON.parse(sessionStorage.getItem(k));
        } catch {
          return null;
        }
      },
      setzen(k, v) {
        try {
          if (v == null) sessionStorage.removeItem(k);
          else sessionStorage.setItem(k, JSON.stringify(v));
        } catch {}
      },
    };
    const K = {
      ohne: 'hervis:konto:ohne-editor',
      meldung: 'hervis:adressen:meldung',
    };
    const seite = location.origin + (wurzel.dataset.rueck || '/?view=adressen');

    /* Meldung nach dem Neuladen („Adresse gespeichert."). */
    const meldung = wurzel.querySelector('[data-adressen-meldung]');
    const melden = (text) => {
      if (meldung) meldung.textContent = text || '';
    };
    melden(speicher.lesen(K.meldung));
    speicher.setzen(K.meldung, null);

    /* --- Customer Account API: assets/kundenkonto-api.js ------------------ */
    // Nur im echten Modus geladen (layout/theme.liquid); in der Vorschau
    // speichert der Editor nichts und braucht keinen Client.
    const konto =
      modus === 'echt' && window.hervisKonto
        ? window.hervisKonto({
            client: wurzel.dataset.client,
            shop: wurzel.dataset.shop,
            kunde: wurzel.dataset.kunde,
            email: wurzel.dataset.email,
            rueck: seite,
          })
        : null;
    const tokenGueltig = () => konto?.tokenGueltig() || null;
    const erneuern = async () => (konto ? konto.erneuern() : null);
    const gql = async (query, variables) => {
      if (!konto) throw Object.assign(new Error('sitzung'), { sitzung: true });
      return konto.gql(query, variables);
    };

    /* Ohne Editor weiter: für den Rest der Sitzung führen die Zeilen wieder
       in Shopifys Kundenkonto — und diesmal gleich dorthin. */
    const ausweichen = () => {
      speicher.setzen(K.ohne, true);
      location.assign(wurzel.dataset.ziel);
    };

    const Q = {
      liste: 'query HervisAdressen { customer { addresses(first: 50) { nodes { id } } } }',
      neu: 'mutation HervisAdresseNeu($address: CustomerAddressInput!, $defaultAddress: Boolean) { customerAddressCreate(address: $address, defaultAddress: $defaultAddress) { customerAddress { id } userErrors { field message code } } }',
      aendern:
        'mutation HervisAdresseAendern($addressId: ID!, $address: CustomerAddressInput, $defaultAddress: Boolean) { customerAddressUpdate(addressId: $addressId, address: $address, defaultAddress: $defaultAddress) { customerAddress { id } userErrors { field message code } } }',
      loeschen:
        'mutation HervisAdresseLoeschen($addressId: ID!) { customerAddressDelete(addressId: $addressId) { deletedAddressId userErrors { field message code } } }',
    };
    const pruefen = (fehler) => {
      if (!fehler?.length) return;
      const f = fehler[0];
      const feld = Array.isArray(f.field) ? f.field[f.field.length - 1] : f.field;
      throw Object.assign(new Error(f.message || 'api'), { code: f.code, feld });
    };
    /* Liquid kennt die Adresse als Zahl, die API als gid — zugeordnet über
       die Zahl am Ende. */
    const gids = async () => {
      const d = await gql(Q.liste);
      const karte = new Map();
      (d?.customer?.addresses?.nodes || []).forEach((n) => {
        karte.set(String(n.id).split('?')[0].split('/').pop(), n.id);
      });
      return karte;
    };
    const gidVon = (karte, id) => {
      const gid = karte.get(String(id));
      if (!gid) throw Object.assign(new Error('weg'), { code: 'ADDRESS_ID_DOES_NOT_EXIST' });
      return gid;
    };

    /* --- Das Formular ------------------------------------------------------ */
    const form = dialog.querySelector('[data-adresse-form]');
    const feld = (name) => form.elements.namedItem(name);
    const titel = dialog.querySelector('[data-adresse-titel]');
    const landHinweis = dialog.querySelector('[data-land-hinweis]');
    const provinz = dialog.querySelector('[data-provinz]');
    const standardHinweis = dialog.querySelector('[data-standard-hinweis]');
    const loeschenBereich = dialog.querySelector('[data-loeschen-bereich]');
    const loeschenKnopf = dialog.querySelector('[data-loeschen]');
    const loeschenFrage = dialog.querySelector('[data-loeschen-frage]');
    const allgemein = dialog.querySelector('[data-allgemein]');
    const hausnummer = dialog.querySelector('[data-hinweis-fuer="address1"]');
    const REIHENFOLGE = ['zoneCode', 'firstName', 'lastName', 'address1', 'zip', 'city', 'phoneNumber'];
    const LIEFERLAENDER = ['AT', 'DE'];
    const VORWAHL = {
      AT: '43',
      DE: '49',
      BE: '32',
      BG: '359',
      CH: '41',
      CY: '357',
      CZ: '420',
      DK: '45',
      EE: '372',
      ES: '34',
      FI: '358',
      FR: '33',
      GR: '30',
      HR: '385',
      HU: '36',
      IE: '353',
      IS: '354',
      IT: '39',
      LI: '423',
      LT: '370',
      LU: '352',
      LV: '371',
      MT: '356',
      NL: '31',
      NO: '47',
      PL: '48',
      PT: '351',
      RO: '40',
      SE: '46',
      SI: '386',
      SK: '421',
    };
    const NACH_LAENGE = Object.entries(VORWAHL).sort((a, b) => b[1].length - a[1].length);

    let aktuell = null;
    let ausloeser = null;
    let wunschStandard = true;

    const fehlerSetzen = (name, text) => {
      const el = feld(name);
      const zeile = form.querySelector(`[data-fehler-fuer="${name}"]`);
      if (!el || !zeile) return;
      if (text) {
        el.setAttribute('aria-invalid', 'true');
        zeile.querySelector('[data-text]').textContent = text;
        zeile.hidden = false;
      } else {
        el.removeAttribute('aria-invalid');
        zeile.hidden = true;
      }
    };
    const alleFehlerWeg = () => {
      REIHENFOLGE.forEach((n) => fehlerSetzen(n, null));
      allgemein.textContent = '';
    };

    const plzProblem = (land, plz) => {
      const v = plz.trim();
      if (!v) return T.fehler_plz;
      if (land === 'AT' && !/^\d{4}$/.test(v)) return T.fehler_plz_at;
      if (land === 'DE' && !/^\d{5}$/.test(v)) return T.fehler_plz_de;
      return null;
    };

    /* Telefon wie apps/mobile/src/lib/phone.ts normalizePhoneInput: eine
       mitgetippte Vorwahl gewinnt, sonst gilt das Land der Adresse. */
    const telefon = (roh, land) => {
      const t = roh.trim();
      if (!t) return { e164: null };
      if (!/^[0-9+()/.\-\s]*$/.test(t)) return { problem: T.tel_zeichen };
      let code = VORWAHL[land] ? land : 'AT';
      let national = t;
      const rest = t.startsWith('+') ? t.slice(1) : t.startsWith('00') ? t.slice(2) : null;
      if (rest !== null) {
        const ziffern = rest.replace(/\D/g, '');
        const treffer = NACH_LAENGE.find(([, d]) => ziffern.startsWith(d));
        if (!treffer) return { problem: T.tel_vorwahl };
        let gesehen = 0;
        let i = 0;
        while (i < rest.length && gesehen < treffer[1].length) {
          if (/\d/.test(rest[i])) gesehen += 1;
          i += 1;
        }
        code = treffer[0];
        national = rest.slice(i).trim();
      }
      if (/^(\+|00)/.test(national)) return { problem: T.tel_format };
      let ziffern = national.replace(/\(0\)/g, '').replace(/\D/g, '');
      if (ziffern.length < 4) return { problem: T.tel_kurz };
      if (code !== 'IT') ziffern = ziffern.replace(/^0/, '');
      const e164 = `+${VORWAHL[code]}${ziffern}`;
      if (e164.length > 16) return { problem: T.tel_lang };
      if (!/^\+[1-9]\d{6,14}$/.test(e164)) return { problem: T.tel_format };
      return { e164 };
    };

    const landAnwenden = () => {
      const land = feld('territoryCode').value;
      const liefer = LIEFERLAENDER.includes(land);
      landHinweis.textContent = liefer ? T.liefern : T.nur_rechnung;
      provinz.hidden = land !== 'IT';
      if (land !== 'IT') {
        feld('zoneCode').value = '';
        fehlerSetzen('zoneCode', null);
      }
      const plz = feld('zip');
      plz.maxLength = land === 'AT' ? 4 : land === 'DE' ? 5 : 10;
      plz.inputMode = liefer ? 'numeric' : 'text';

      const schalter = feld('defaultAddress');
      const istStandard = Boolean(aktuell?.standard);
      schalter.disabled = !liefer || istStandard;
      schalter.checked = istStandard || (liefer && wunschStandard);
      standardHinweis.textContent = !liefer ? T.standard_gesperrt : istStandard ? T.standard_ist : '';
      standardHinweis.hidden = !standardHinweis.textContent;
    };

    const oeffnen = (zeile, knopf) => {
      aktuell = zeile === 'neu' ? null : adressen.find((a) => String(a.id) === String(zeile)) || null;
      if (zeile !== 'neu' && !aktuell) return;
      ausloeser = knopf || null;
      form.reset();
      form.removeAttribute('aria-busy');
      alleFehlerWeg();
      if (hausnummer) hausnummer.hidden = true;

      const w = aktuell || {
        vorname: wurzel.dataset.vorname || '',
        nachname: wurzel.dataset.nachname || '',
        land: 'AT',
      };
      const land = feld('territoryCode');
      // Ein Land außerhalb der Liste (alte Adresse) geht beim Bearbeiten
      // nicht verloren: es kommt als eigene Option dazu.
      if (w.land && ![...land.options].some((o) => o.value === w.land)) {
        land.add(new Option(w.land, w.land));
      }
      land.value = w.land || 'AT';
      feld('zoneCode').value = w.provinz || '';
      feld('firstName').value = w.vorname || '';
      feld('lastName').value = w.nachname || '';
      feld('address1').value = w.strasse || '';
      feld('address2').value = w.zusatz || '';
      feld('zip').value = w.plz || '';
      feld('city').value = w.ort || '';
      feld('phoneNumber').value = w.telefon || '';
      wunschStandard = aktuell ? Boolean(aktuell.standard) : true;

      titel.textContent = aktuell ? T.titel_bearbeiten : T.titel_neu;
      loeschenBereich.hidden = !aktuell;
      loeschenFrage.hidden = true;
      loeschenKnopf.hidden = false;
      landAnwenden();

      dialog.showModal();
      // Erstes leeres Pflichtfeld, sonst ganz oben das Land.
      form.querySelector('.adresse-form__inhalt').scrollTop = 0;
      const leer = ['firstName', 'lastName', 'address1', 'zip', 'city'].find((n) => !feld(n).value.trim());
      feld(leer || 'territoryCode').focus();
    };

    dialog.addEventListener('close', () => {
      if (ausloeser?.isConnected) ausloeser.focus({ preventScroll: true });
      ausloeser = null;
    });

    form.addEventListener('input', (e) => {
      const name = e.target.name;
      if (REIHENFOLGE.includes(name)) fehlerSetzen(name, null);
      if (name === 'address1' && hausnummer) hausnummer.hidden = true;
    });
    form.addEventListener('change', (e) => {
      if (e.target.name === 'territoryCode') landAnwenden();
      if (e.target.name === 'defaultAddress') wunschStandard = e.target.checked;
      if (e.target.name === 'zoneCode') fehlerSetzen('zoneCode', null);
    });
    form.addEventListener('focusout', (e) => {
      const name = e.target.name;
      const wert = e.target.value?.trim();
      if (name === 'address1' && hausnummer) hausnummer.hidden = !wert || /\d/.test(wert);
      if (name === 'zip' && wert) fehlerSetzen('zip', plzProblem(feld('territoryCode').value, wert));
      if (name === 'phoneNumber' && wert && wert !== aktuell?.telefon) {
        fehlerSetzen('phoneNumber', telefon(wert, feld('territoryCode').value).problem || null);
      }
    });

    const FELD_VON_API = {
      firstName: 'firstName',
      lastName: 'lastName',
      address1: 'address1',
      zip: 'zip',
      city: 'city',
      zoneCode: 'zoneCode',
      phoneNumber: 'phoneNumber',
    };
    const fehlerZeigen = (fehler, standard) => {
      let text = standard;
      if (fehler?.sitzung) text = T.fehler_sitzung;
      else if (fehler instanceof TypeError) text = T.fehler_verbindung;
      else if (fehler?.code && T.api[fehler.code]) {
        text = T.api[fehler.code];
        const name = FELD_VON_API[fehler.feld];
        if (name && !feld(name).closest('[hidden]')) {
          fehlerSetzen(name, text);
          feld(name).focus();
          return;
        }
      }
      allgemein.textContent = text;
    };

    const fertig = (text) => {
      if (modus === 'vorschau') {
        dialog.close();
        melden(T.vorschau_nichts);
        return;
      }
      speicher.setzen(K.meldung, text);
      location.replace(seite);
    };

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (form.getAttribute('aria-busy') === 'true') return;
      const land = feld('territoryCode').value;
      const wert = (n) => feld(n).value.trim();
      const fehler = {};
      if (land === 'IT' && !wert('zoneCode')) fehler.zoneCode = T.fehler_provinz;
      if (!wert('firstName')) fehler.firstName = T.fehler_vorname;
      if (!wert('lastName')) fehler.lastName = T.fehler_nachname;
      if (!wert('address1')) fehler.address1 = T.fehler_strasse;
      const plz = plzProblem(land, feld('zip').value);
      if (plz) fehler.zip = plz;
      if (!wert('city')) fehler.city = T.fehler_ort;
      // Eine gespeicherte, gültige Nummer, die niemand angefasst hat, geht
      // unverändert durch (App: address.tsx keepPhone).
      const getippt = wert('phoneNumber');
      const behalten = aktuell && getippt === aktuell.telefon && /^\+[1-9]\d{6,14}$/.test(getippt);
      const tel = behalten ? { e164: getippt } : telefon(getippt, land);
      if (tel.problem) fehler.phoneNumber = tel.problem;

      alleFehlerWeg();
      REIHENFOLGE.forEach((n) => fehlerSetzen(n, fehler[n] || null));
      const erster = REIHENFOLGE.find((n) => fehler[n]);
      if (erster) {
        feld(erster).focus();
        return;
      }

      const liefer = LIEFERLAENDER.includes(land);
      const eingabe = {
        firstName: wert('firstName'),
        lastName: wert('lastName'),
        address1: wert('address1'),
        zip: wert('zip'),
        city: wert('city'),
        territoryCode: land,
        phoneNumber: tel.e164,
      };
      if (wert('address2') || aktuell) eingabe.address2 = wert('address2') || null;
      if (land === 'IT') eingabe.zoneCode = wert('zoneCode');
      // Nie false senden: ein Edit darf den Standard nicht still wegnehmen.
      const standard = liefer && feld('defaultAddress').checked && !aktuell?.standard ? true : undefined;

      form.setAttribute('aria-busy', 'true');
      try {
        if (modus === 'echt') {
          if (aktuell) {
            const gid = gidVon(await gids(), aktuell.id);
            const d = await gql(Q.aendern, { addressId: gid, address: eingabe, defaultAddress: standard });
            pruefen(d.customerAddressUpdate.userErrors);
          } else {
            const d = await gql(Q.neu, { address: eingabe, defaultAddress: standard });
            pruefen(d.customerAddressCreate.userErrors);
          }
        }
        fertig(T.gespeichert);
      } catch (fehler) {
        fehlerZeigen(fehler, T.fehler_speichern);
      } finally {
        form.removeAttribute('aria-busy');
      }
    });

    loeschenKnopf.addEventListener('click', () => {
      loeschenKnopf.hidden = true;
      loeschenFrage.hidden = false;
      loeschenFrage.querySelector('[data-loeschen-nein]').focus();
    });
    loeschenFrage.querySelector('[data-loeschen-nein]').addEventListener('click', () => {
      loeschenFrage.hidden = true;
      loeschenKnopf.hidden = false;
      loeschenKnopf.focus();
    });
    loeschenFrage.querySelector('[data-loeschen-ja]').addEventListener('click', async () => {
      if (!aktuell || form.getAttribute('aria-busy') === 'true') return;
      form.setAttribute('aria-busy', 'true');
      allgemein.textContent = '';
      try {
        if (modus === 'echt') {
          const karte = await gids();
          const gid = gidVon(karte, aktuell.id);
          let d = await gql(Q.loeschen, { addressId: gid });
          const sperre = d.customerAddressDelete.userErrors?.find(
            (f) => f.code === 'DELETING_CUSTOMER_DEFAULT_ADDRESS_NOT_ALLOWED',
          );
          // Der Standard lässt sich erst löschen, wenn eine andere Adresse ihn
          // übernimmt — wie die App (auth-context-ca.tsx deleteAddress):
          // bevorzugt eine lieferbare.
          const andere = adressen.filter((a) => String(a.id) !== String(aktuell.id) && karte.has(String(a.id)));
          if (sperre && andere.length) {
            const nachfolger = andere.find((a) => LIEFERLAENDER.includes(a.land)) || andere[0];
            const u = await gql(Q.aendern, { addressId: gidVon(karte, nachfolger.id), defaultAddress: true });
            pruefen(u.customerAddressUpdate.userErrors);
            d = await gql(Q.loeschen, { addressId: gid });
          }
          pruefen(d.customerAddressDelete.userErrors);
        }
        fertig(T.geloescht);
      } catch (fehler) {
        fehlerZeigen(fehler, T.fehler_loeschen);
      } finally {
        form.removeAttribute('aria-busy');
      }
    });

    /* --- Zeilen öffnen den Editor ----------------------------------------- */
    wurzel.addEventListener('click', async (e) => {
      const link = e.target.closest('a[data-zeile]');
      if (!link) return;
      if (modus === 'vorschau') {
        e.preventDefault();
        oeffnen(link.dataset.zeile, link);
        return;
      }
      // Hat der stille Umweg schon einmal nicht geklappt: Link wie bisher.
      if (speicher.lesen(K.ohne)) return;
      e.preventDefault();
      try {
        if (!konto) throw new Error('kein-client');
        if (tokenGueltig() || (await erneuern())) oeffnen(link.dataset.zeile, link);
        else await konto.anmelden({ zeile: link.dataset.zeile });
      } catch {
        ausweichen();
      }
    });

    /* --- Rückkehr vom stillen Umweg ---------------------------------------- */
    const rueckkehr = async () => {
      try {
        const zurueck = await konto?.rueckkehr();
        if (!zurueck) return;
        const zeile = zurueck.absicht?.zeile || 'neu';
        oeffnen(zeile, wurzel.querySelector(`a[data-zeile="${CSS.escape(zeile)}"]`));
      } catch {
        ausweichen();
      }
    };
    if (modus === 'echt') rueckkehr();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["anmelden"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

    document.querySelectorAll('[data-anmelden-form]').forEach((form) => {
      const feld = form.querySelector('[data-anmelden-email]');
      const fehler = form.querySelector('[data-anmelden-fehler]');
      const gueltig = () => EMAIL.test(feld.value.trim());
      const zeigen = () => form.classList.toggle('ist-gueltig', gueltig());

      feld.addEventListener('input', () => {
        zeigen();
        if (feld.getAttribute('aria-invalid') === 'true') {
          feld.removeAttribute('aria-invalid');
          fehler.textContent = '';
        }
      });
      // Vom Browser vorausgefüllt: der Knopf soll gleich Lime tragen.
      requestAnimationFrame(zeigen);

      form.addEventListener('submit', (ereignis) => {
        if (form.getAttribute('aria-busy') === 'true') {
          ereignis.preventDefault();
          return;
        }
        feld.value = feld.value.trim();
        if (!gueltig()) {
          ereignis.preventDefault();
          feld.setAttribute('aria-invalid', 'true');
          fehler.textContent = fehler.dataset.tUngueltig;
          feld.focus();
          return;
        }
        form.setAttribute('aria-busy', 'true');
      });

      // Zurück aus Shopifys Code-Seite (bfcache): wieder bedienbar.
      window.addEventListener('pageshow', () => form.removeAttribute('aria-busy'));
    });

    document.querySelectorAll('.anmelden').forEach((buehne) => {
      const video = buehne.querySelector('[data-anmelden-video]');
      const knopf = buehne.querySelector('[data-anmelden-pause]');
      if (!video || !knopf) return;
      const ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const sparen = navigator.connection?.saveData === true;
      if (ruhig || sparen) return;

      const setzen = (pausiert) => {
        knopf.setAttribute('aria-pressed', String(pausiert));
        knopf.setAttribute('aria-label', pausiert ? knopf.dataset.tPlay : knopf.dataset.tPause);
      };
      video.addEventListener('playing', () => video.classList.add('ist-bereit'), { once: true });
      video.preload = 'auto';
      video
        .play()
        .then(() => {
          knopf.hidden = false;
        })
        .catch(() => {});

      knopf.addEventListener('click', () => {
        if (video.paused) {
          video.play().catch(() => {});
          setzen(false);
        } else {
          video.pause();
          setzen(true);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["app-vorstellung"] && !Shopify.designMode) return;
  try {
    
  (() => {
    /* Die Wischreihe ist nur fokussierbar, solange sie wirklich scrollt. */
    const beobachter = new Map();

    function init(scope) {
      scope.querySelectorAll('[data-app-vorstellung] [data-app-trio]').forEach((reihe) => {
        if (beobachter.has(reihe) || !('ResizeObserver' in window)) return;
        const pruefen = () => {
          if (reihe.scrollWidth > reihe.clientWidth + 1) reihe.setAttribute('tabindex', '0');
          else reihe.removeAttribute('tabindex');
        };
        const ro = new ResizeObserver(pruefen);
        ro.observe(reihe);
        beobachter.set(reihe, ro);
      });
    }
    init(document);
    document.addEventListener('shopify:section:load', (e) => init(e.target));
    document.addEventListener('shopify:section:unload', (e) =>
      beobachter.forEach((ro, reihe) => {
        if (e.target.contains(reihe)) {
          ro.disconnect();
          beobachter.delete(reihe);
        }
      }),
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bestellungen"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const wurzel = document.querySelector('[data-bestellungen]');
    if (!wurzel) return;
    const titelListe = document.title;
    const liste = wurzel.querySelector('.bestellungen__liste');
    const hinweis = wurzel.querySelector('[data-bestellung-fehlt]');
    const details = wurzel.querySelectorAll('[data-bestellung]');
    const mitTaste = (event) => event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey;

    // Anker lesen — ein kaputter (#bestellung-%) ließe decodeURIComponent werfen.
    const lesen = (hash) => {
      const roh = hash.replace(/^#/, '');
      try {
        return decodeURIComponent(roh);
      } catch {
        return roh;
      }
    };
    const detailZu = (anker) => {
      const el = anker.startsWith('bestellung-') ? document.getElementById(anker) : null;
      return el?.matches('[data-bestellung]') ? el : null;
    };

    // Fokus aufs Ziel. Hat inzwischen jemand selbst etwas fokussiert, bleibt
    // es dabei. Beim Laden mit Anker (Link aus Mein Konto, Lesezeichen, Neu
    // laden) verarbeitet Chrome den Anker erst um das load-Ereignis und setzt
    // dabei den Fokus selbst — aufs Dokument, das <article> ist nicht
    // fokussierbar. Darum danach noch einmal.
    const fokussieren = (ziel, beimLaden = false) => {
      if (!ziel) return;
      const vorher = document.activeElement;
      if (beimLaden) {
        // Auf frisch geladener Seite ohne Ring (snippets/konto-kopf.liquid),
        // bis jemand selbst eine Taste drückt oder zeigt.
        ziel.dataset.ohneRing = '';
        const aus = () => delete ziel.dataset.ohneRing;
        document.addEventListener('keydown', aus, { once: true, capture: true });
        document.addEventListener('pointerdown', aus, { once: true, capture: true });
      }
      const versuch = () => {
        const aktiv = document.activeElement;
        if (!ziel.isConnected || ![vorher, ziel, document.body, null].includes(aktiv)) return;
        if (ziel.getClientRects().length) ziel.focus({ preventScroll: true });
      };
      versuch();
      if (beimLaden && document.readyState !== 'complete') {
        window.addEventListener('load', () => requestAnimationFrame(versuch), { once: true });
      }
    };

    // Zeigt, was der Anker verlangt. Das Detail bekommt .is-offen, statt auf
    // :target zu warten: beim Aufruf mit Anker setzt Chrome :target erst um
    // das load-Ereignis — bis dahin stünde die Liste da und focus() ginge ins
    // Leere.
    const anzeigen = () => {
      const anker = lesen(location.hash);
      const offen = detailZu(anker);
      details.forEach((el) => el.classList.toggle('is-offen', el === offen));
      document.title = offen ? `${offen.dataset.titel} – ${titelListe}` : titelListe;
      if (hinweis) {
        const text = anker.startsWith('bestellung-') && !offen ? hinweis.dataset.text || '' : '';
        if (hinweis.textContent !== text) hinweis.textContent = text;
      }
      return offen;
    };

    window.addEventListener('hashchange', (event) => {
      const vorher = detailZu(lesen(new URL(event.oldURL).hash));
      const offen = anzeigen();
      if (offen) {
        // Kam der Weg aus der Liste, führt „Zu meinen Bestellungen" per
        // Verlauf zurück — an dieselbe Scroll-Stelle. Der Vermerk hängt am
        // Verlaufseintrag und gilt so auch nach Zurück und Vor.
        if (!vorher) {
          const stand = history.state && typeof history.state === 'object' ? history.state : {};
          history.replaceState({ ...stand, bestellungenListe: true }, '');
        }
        fokussieren(offen.querySelector('h1'));
      } else if (vorher) {
        // Zurück in der Liste: die Zeile der eben geschlossenen Bestellung
        // (auch nach Vor und Zurück im Verlauf), sonst die Überschrift.
        const zeile = liste?.querySelector(`a[href="#${CSS.escape(vorher.id)}"]`);
        fokussieren(zeile || liste?.querySelector('h1'));
      }
    });

    wurzel.addEventListener('click', (event) => {
      const zurueck = event.target.closest('[data-bestellungen-zurueck]');
      if (!zurueck || mitTaste(event) || !history.state?.bestellungenListe) return;
      event.preventDefault();
      history.back();
    });

    // Sprunglinks auf derselben Seite („Zum Inhalt springen" → #hauptinhalt)
    // ersetzten den Anker und schlössen so das offene Detail. Solange eines
    // offen ist, bleibt der Anker; der Fokus geht ans Ziel — liegt das Detail
    // darin (der Hauptinhalt), an die Überschrift des Details. „Nach oben"
    // (data-nach-oben) behält den Anker schon selbst (sections/footer.liquid).
    document.addEventListener('click', (event) => {
      if (event.defaultPrevented || mitTaste(event) || !(event.target instanceof Element)) return;
      const link = event.target.closest('a[href^="#"]');
      const href = link?.getAttribute('href') || '';
      if (href.length < 2 || href === '#bestellungen' || href.startsWith('#bestellung-')) return;
      if (link.hasAttribute('data-nach-oben')) return;
      const offen = detailZu(lesen(location.hash));
      if (!offen) return;
      event.preventDefault();
      const ziel = document.getElementById(lesen(href));
      if (!ziel || ziel.contains(offen)) {
        (ziel || offen).scrollIntoView({ block: 'start' });
        offen.querySelector('h1')?.focus({ preventScroll: true });
        return;
      }
      if (!ziel.matches('a[href], button, input, select, textarea, [tabindex]')) ziel.setAttribute('tabindex', '-1');
      ziel.scrollIntoView({ block: 'start' });
      ziel.focus({ preventScroll: true });
    });

    const offen = anzeigen();
    if (offen) fokussieren(offen.querySelector('h1'), true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bildbuehne"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bewegungArm = window.matchMedia('(prefers-reduced-motion: reduce)');
    // „Weniger Bewegung" im System oder Bewegungsstärke 0 im Theme: keine
    // Automatik (critical.css kürzt dann jede Animation auf 0,01 ms — der
    // Takt liefe sonst im Sekundenbruchteil durch).
    const ruhig = () =>
      bewegungArm.matches || getComputedStyle(document.documentElement).getPropertyValue('--motion').trim() === '0';

    const starte = (buehne) => {
      if (buehne.hasAttribute('data-bereit')) return;
      const spur = buehne.querySelector('[data-bildbuehne-spur]');
      const echte = spur ? [...spur.querySelectorAll(':scope > [data-bildbuehne-folie]')] : [];
      const steuerung = buehne.querySelector('[data-bildbuehne-steuerung]');
      const n = echte.length;
      if (n < 2 || !steuerung) return;
      const punkte = [...buehne.querySelectorAll('[data-bildbuehne-ziel]')];
      const lauf = buehne.querySelector('[data-bildbuehne-lauf]');

      // Endlos: je eine Kopie aller Folien davor und dahinter. Kopien tragen
      // keine Editor-Markierung und laden ihre Bilder erst bei Bedarf.
      const kopie = (folie) => {
        const k = folie.cloneNode(true);
        k.setAttribute('data-klon', '');
        k.removeAttribute('data-shopify-editor-block');
        k.querySelectorAll('img').forEach((img) => {
          img.loading = 'lazy';
          img.removeAttribute('fetchpriority');
        });
        return k;
      };
      const vorne = echte.map(kopie);
      const hinten = echte.map(kopie);
      spur.prepend(...vorne);
      spur.append(...hinten);
      const alle = [...vorne, ...echte, ...hinten];
      let stelle = n;

      const anfang = () => parseFloat(getComputedStyle(spur).scrollPaddingInlineStart) || 0;
      const satz = () => echte[0].offsetLeft - vorne[0].offsetLeft;
      const naechste = () => {
        let beste = 0;
        let abstand = Infinity;
        alle.forEach((folie, i) => {
          const d = Math.abs(folie.offsetLeft - anfang() - spur.scrollLeft);
          if (d < abstand) {
            abstand = d;
            beste = i;
          }
        });
        return beste;
      };
      const markieren = () => {
        stelle = naechste();
        const index = stelle % n;
        punkte.forEach((punkt, i) => punkt.setAttribute('aria-current', String(i === index)));
      };

      // Sichtbar heißt: mindestens zur Hälfte in der Spur. Nur sichtbare
      // Folien sind bedienbar (inert) — auch eine Kopie, wenn sie gerade
      // im Bild steht; ihr Original liegt dann außer Sicht.
      const markiereSicht = (folie, sichtbar) => {
        folie.inert = !sichtbar;
        folie.toggleAttribute('data-sichtbar', sichtbar);
      };
      const sichtNachMass = () => {
        const rahmen = spur.getBoundingClientRect();
        alle.forEach((folie) => {
          const r = folie.getBoundingClientRect();
          const ueberlapp = Math.min(r.right, rahmen.right) - Math.max(r.left, rahmen.left);
          markiereSicht(folie, ueberlapp >= r.width / 2);
        });
      };

      const zeigen = (i, sanft = true) => {
        const folie = alle[Math.max(0, Math.min(alle.length - 1, i))];
        spur.scrollTo({ left: folie.offsetLeft - anfang(), behavior: sanft && !ruhig() ? 'smooth' : 'auto' });
      };
      // Kürzester Weg zur Folie i (0 … n−1), vorwärts oder rückwärts.
      const zeigeFolie = (i, sanft = true) => {
        let schritte = (((i - (stelle % n)) % n) + n) % n;
        if (schritte > n / 2) schritte -= n;
        zeigen(stelle + schritte, sanft);
      };

      // Steht die Spur still auf einer Kopie: unsichtbar um einen Satz auf
      // die echte Folie springen.
      let finger = false;
      const zurRuhe = () => {
        if (finger) return;
        markieren();
        if (stelle >= n && stelle < 2 * n) return;
        buehne.toggleAttribute('data-springt', true);
        spur.scrollLeft += stelle < n ? satz() : -satz();
        sichtNachMass();
        markieren();
        requestAnimationFrame(() => requestAnimationFrame(() => buehne.removeAttribute('data-springt')));
      };

      const setzeLauf = (an) => {
        buehne.dataset.lauf = an ? 'an' : 'aus';
        // Läuft die Automatik, liest der Screenreader nicht jede Folie vor.
        spur.setAttribute('aria-live', an ? 'off' : 'polite');
        lauf?.setAttribute('aria-pressed', String(!an));
      };

      // Erst springen, dann zeichnen: die echte erste Folie steht am Rand.
      spur.scrollLeft = echte[0].offsetLeft - anfang();
      sichtNachMass();
      const sicht = new IntersectionObserver(
        (eintraege) => eintraege.forEach((e) => markiereSicht(e.target, e.intersectionRatio >= 0.5)),
        { root: spur, threshold: [0, 0.5] },
      );
      alle.forEach((folie) => sicht.observe(folie));

      let bild;
      spur.addEventListener(
        'scroll',
        () => {
          cancelAnimationFrame(bild);
          bild = requestAnimationFrame(markieren);
        },
        { passive: true },
      );
      // Ruhe erkennen: scrollend, wo es das gibt; sonst, sobald die Spur
      // einige Bilder lang stillsteht.
      if ('onscrollend' in window) {
        spur.addEventListener('scrollend', zurRuhe);
      } else {
        let letzte = null;
        let still = 0;
        const beobachte = () => {
          if (spur.scrollLeft === letzte) still += 1;
          else still = 0;
          letzte = spur.scrollLeft;
          if (still < 6) requestAnimationFrame(beobachte);
          else {
            letzte = null;
            zurRuhe();
          }
        };
        spur.addEventListener(
          'scroll',
          () => {
            if (letzte === null) {
              letzte = spur.scrollLeft;
              still = 0;
              requestAnimationFrame(beobachte);
            }
          },
          { passive: true },
        );
      }
      // Ein Finger auf der Spur hält die Automatik an; erst nach dem
      // Loslassen wird auf die echte Folie gesprungen.
      spur.addEventListener(
        'touchstart',
        () => {
          finger = true;
          buehne.toggleAttribute('data-halt', true);
        },
        { passive: true },
      );
      const loslassen = () => {
        finger = false;
        buehne.removeAttribute('data-halt');
      };
      spur.addEventListener('touchend', loslassen, { passive: true });
      spur.addEventListener('touchcancel', loslassen, { passive: true });

      buehne.addEventListener('animationend', (event) => {
        if (event.animationName === 'bildbuehne-takt') zeigen(stelle + 1);
      });
      punkte.forEach((punkt, i) => punkt.addEventListener('click', () => zeigeFolie(i)));
      buehne.querySelector('[data-bildbuehne-zurueck]')?.addEventListener('click', () => zeigen(stelle - 1));
      buehne.querySelector('[data-bildbuehne-vor]')?.addEventListener('click', () => zeigen(stelle + 1));
      lauf?.addEventListener('click', () => setzeLauf(buehne.dataset.lauf !== 'an'));

      // Tastatur in der Bühne: die Automatik hört auf und bleibt aus, bis
      // jemand den Pause-Knopf drückt (APG Carousel).
      buehne.addEventListener('focusin', (event) => {
        if (event.target.matches(':focus-visible')) setzeLauf(false);
      });
      new IntersectionObserver(([e]) => buehne.toggleAttribute('data-ausser-sicht', !e.isIntersecting), {
        threshold: 0.25,
      }).observe(buehne);
      document.addEventListener('visibilitychange', () => buehne.toggleAttribute('data-verborgen', document.hidden));
      bewegungArm.addEventListener('change', () => {
        if (lauf) lauf.hidden = ruhig();
        if (ruhig()) setzeLauf(false);
      });

      buehne.bildbuehne = {
        halten(folie) {
          setzeLauf(false);
          zeigeFolie(echte.indexOf(folie), false);
        },
      };

      if (lauf) lauf.hidden = ruhig();
      setzeLauf(!ruhig());
      markieren();
      steuerung.hidden = false;
      buehne.toggleAttribute('data-bereit', true);
    };

    document.querySelectorAll('[data-bildbuehne]').forEach(starte);
    // Theme-Editor: neu gerenderte Section starten; gewählte Folie zeigen.
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-bildbuehne]').forEach(starte);
    });
    document.addEventListener('shopify:block:select', (event) => {
      const folie = event.target.closest?.('[data-bildbuehne-folie]');
      folie?.closest('[data-bildbuehne]')?.bildbuehne?.halten(folie);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (!document.querySelector('[data-warenkorb]')) return;

    /* Wie lange nach dem letzten Klick gespeichert wird (App: 500 ms). */
    const WARTEZEIT = 500;
    /* Kurze Pause, damit die Statuszeile auch denselben Satz neu ansagt. */
    const ANSAGE_PAUSE = 60;

    const timer = new Map();
    let kette = Promise.resolve();
    let laufend = 0;
    let html = null;
    let neuLaden = false;
    let anzahl = null;
    let meldung = null;

    const wurzel = () => document.querySelector('[data-warenkorb]');
    const inhalt = () => wurzel()?.querySelector('[data-warenkorb-inhalt]');
    const basis = () => window.Shopify?.routes?.root || '/';

    const text = (name, werte = {}) =>
      Object.entries(werte).reduce(
        (satz, [schluessel, wert]) => satz.replaceAll(`%${schluessel}`, wert),
        wurzel()?.dataset[name] || '',
      );

    const euro = new Intl.NumberFormat('de-AT', { style: 'currency', currency: 'EUR' });
    const geld = (cent) => euro.format(cent / 100);

    const ansagen = (satz) => {
      const status = wurzel()?.querySelector('[data-warenkorb-status]');
      if (!status || !satz) return;
      status.textContent = '';
      setTimeout(() => {
        status.textContent = satz;
      }, ANSAGE_PAUSE);
    };

    /* Vorrechnen, bis Shopify antwortet: Zeilensummen immer (EUR), die
       Zusammenfassung nur ohne Rabatte — die rechnet Shopify. */
    const versandleiste = (bereich, summe) => {
      const leiste = bereich.querySelector('[data-versandleiste]');
      const schwelle = Number(bereich.dataset.schwelle);
      if (!leiste || !schwelle) return;
      const rest = schwelle - summe;
      const erreicht = rest <= 0;
      const satz = erreicht ? text('textErreicht') : text('textNochBis', { betrag: geld(rest) });
      leiste.dataset.erreicht = String(erreicht);
      const zeile = leiste.querySelector('[data-versand-text]');
      if (zeile) zeile.textContent = satz;
      const spur = leiste.querySelector('[role="progressbar"]');
      if (spur) {
        spur.setAttribute('aria-valuenow', (Math.min(summe, schwelle) / 100).toFixed(2));
        spur.setAttribute('aria-valuetext', satz);
        spur.style.setProperty('--fortschritt', String(Math.min(summe / schwelle, 1)));
      }
      const versand = bereich.querySelector('[data-versand-wert]');
      if (versand) versand.textContent = erreicht ? text('textVersandGratis') : text('textVersandKasse');
    };

    const vorrechnen = () => {
      const bereich = inhalt();
      if (!bereich || bereich.dataset.waehrung !== 'EUR') return;
      let summe = 0;
      let stueck = 0;
      bereich.querySelectorAll('[data-key]').forEach((zeile) => {
        const feld = zeile.querySelector('[data-rolle="menge"]');
        const menge = zeile.classList.contains('warenkorb-position--weg')
          ? 0
          : Math.max(0, Number.parseInt(feld?.value, 10) || 0);
        const zeilensumme = Number(zeile.dataset.stueckpreis) * menge;
        summe += zeilensumme;
        stueck += menge;
        const ziel = zeile.querySelector('[data-zeilensumme]');
        if (ziel && zeile.dataset.zeilenrabatt !== 'true') ziel.textContent = geld(zeilensumme);
      });
      // Gleich leer: die Kassenleiste geht schon jetzt, nicht erst nach dem Neuzeichnen.
      bereich.querySelector('.warenkorb-leiste')?.toggleAttribute('hidden', stueck === 0);
      if (bereich.dataset.rabatt === 'true') return;
      const summeText = geld(summe);
      bereich.querySelectorAll('[data-zwischensumme], [data-gesamt]').forEach((el) => {
        el.textContent = summeText;
      });
      // Zwei Beschriftungen: der Knopf in der Übersicht und die Kassenleiste.
      bereich.querySelectorAll('[data-kasse]').forEach((kasse) => {
        kasse.textContent = text('textKasse', { summe: summeText });
      });
      const zahl = bereich.querySelector('[data-warenkorb-zahl]');
      if (zahl) {
        zahl.textContent = text(stueck === 1 ? 'textArtikelEins' : 'textArtikel', { anzahl: stueck });
        zahl.hidden = stueck === 0;
      }
      versandleiste(bereich, summe);
    };

    /* Fokus über das Neuzeichnen retten: dieselbe Zeile, dieselbe Rolle —
       ist die Zeile weg, der Titel der nächsten, sonst die Überschrift.
       Lag der Fokus auf einer gesperrten Zeile selbst (siehe sperren) und
       kommt sie wieder (Fehler), landet er auf ihrem Titel. */
    const fokusMerken = (bereich) => {
      const aktiv = document.activeElement;
      if (!aktiv || !bereich.contains(aktiv)) return null;
      const zeile = aktiv.closest('[data-key]');
      const zeilen = [...bereich.querySelectorAll('[data-key]')];
      return { key: zeile?.dataset.key, rolle: aktiv.dataset.rolle, index: zeilen.indexOf(zeile) };
    };
    const fokusSetzen = (gemerkt, bereich) => {
      if (!gemerkt) return;
      const zeilen = [...bereich.querySelectorAll('[data-key]')];
      let ziel = null;
      if (gemerkt.key) {
        const zeile = zeilen.find((z) => z.dataset.key === gemerkt.key);
        if (zeile) {
          if (gemerkt.rolle) ziel = zeile.querySelector(`[data-rolle="${gemerkt.rolle}"]`);
          ziel ||= zeile.querySelector('[data-rolle="titel"]');
        } else {
          const nachbar = zeilen[gemerkt.index] || zeilen[gemerkt.index - 1];
          ziel = nachbar?.querySelector('[data-rolle="titel"]');
        }
      } else if (gemerkt.rolle) {
        ziel = bereich.querySelector(`[data-rolle="${gemerkt.rolle}"]`);
      }
      ziel ||= bereich.querySelector('[data-warenkorb-leer]') || bereich.querySelector('[data-warenkorb-titel]');
      ziel?.focus({ preventScroll: true });
    };

    const ersetzen = (quelle) => {
      const alt = inhalt();
      const neu = new DOMParser().parseFromString(quelle, 'text/html').querySelector('[data-warenkorb-inhalt]');
      if (!alt || !neu) return false;
      const gemerkt = fokusMerken(alt);
      alt.replaceWith(document.adoptNode(neu));
      fokusSetzen(gemerkt, neu);
      document.dispatchEvent(new CustomEvent('hervis:inhalt'));
      return true;
    };

    const ruhig = () => laufend === 0 && timer.size === 0;

    /* Erst wenn nichts mehr aussteht, wird neu gezeichnet — sonst spränge
       die Zahl unter dem Finger zurück. */
    const abschliessen = async () => {
      if (!ruhig()) return;
      let quelle = neuLaden ? null : html;
      html = null;
      neuLaden = false;
      if (!quelle) {
        try {
          const antwort = await fetch(
            `${window.location.pathname}?section_id=${encodeURIComponent(wurzel()?.dataset.sectionId || '')}`,
          );
          if (antwort.ok) quelle = await antwort.text();
        } catch {
          quelle = null;
        }
      }
      if (!ruhig()) return;
      if (quelle) ersetzen(quelle);
      wurzel()
        ?.querySelector('[data-warenkorb-inhalt]')
        ?.querySelector('.warenkorb__seite')
        ?.removeAttribute('aria-busy');
      document.dispatchEvent(
        new CustomEvent('hervis:warenkorb', Number.isFinite(anzahl) ? { detail: { item_count: anzahl } } : {}),
      );
      anzahl = null;
      if (meldung) {
        const { art, titel, menge, fehler } = meldung;
        meldung = null;
        if (fehler) {
          ansagen(fehler);
        } else if (art === 'menge') {
          const summe = inhalt()?.querySelector('[data-gesamt]')?.textContent.trim() || '';
          ansagen(text('textMenge', { titel, menge, summe }));
        } else {
          const leer = inhalt()?.querySelector('[data-warenkorb-leer]') ? ` ${text('textLeer')}` : '';
          ansagen(text(art === 'merken' ? 'textGemerkt' : 'textEntfernt', { titel }) + leer);
        }
      }
    };

    const senden = (key, menge, art, titel) => {
      laufend += 1;
      inhalt()?.querySelector('.warenkorb__seite')?.setAttribute('aria-busy', 'true');
      const abschnitt = wurzel()?.dataset.sectionId;
      kette = kette
        .then(async () => {
          try {
            const antwort = await fetch(`${basis()}cart/change.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({
                id: key,
                quantity: menge,
                sections: abschnitt ? [abschnitt] : [],
                sections_url: window.location.pathname,
              }),
            });
            const daten = await antwort.json().catch(() => null);
            if (antwort.ok && daten) {
              html = daten.sections?.[abschnitt] || null;
              anzahl = daten.item_count;
              if (!meldung?.fehler) meldung = { art, titel, menge };
            } else {
              neuLaden = true;
              meldung = { fehler: text(antwort.status === 422 ? 'textFehlerBestand' : 'textFehler') };
            }
          } catch {
            neuLaden = true;
            meldung = { fehler: text('textFehler') };
          }
        })
        .finally(() => {
          laufend -= 1;
          return abschliessen();
        });
    };

    /* Eine Zeile, die gerade entfernt oder gemerkt wird, ist gesperrt: sie
       bleibt blass stehen, bis Shopify bestätigt, aber nichts darin lässt
       sich ein zweites Mal auslösen — auch nicht per Tastatur (inert). Das
       Herz verliert data-merken, sonst trüge die Merkliste der Kopfzeile den
       Artikel beim zweiten Druck wieder aus. Der Fokus parkt auf der Karte
       selbst (Enter tut dort nichts) und geht erst nach dem Neuzeichnen zum
       Titel der Nachbarzeile — sofort dorthin, und ein doppeltes Enter
       öffnete das Nachbarprodukt. */
    const gesperrt = (zeile) => zeile.classList.contains('warenkorb-position--weg');
    const sperren = (zeile) => {
      if (gesperrt(zeile)) return false;
      const hatteFokus = zeile.contains(document.activeElement);
      zeile.classList.add('warenkorb-position--weg');
      zeile.querySelector('[data-warenkorb-merken]')?.removeAttribute('data-merken');
      zeile.setAttribute('aria-busy', 'true');
      zeile.setAttribute('aria-label', text('textGesperrt', { titel: zeile.dataset.titel || '' }));
      zeile.tabIndex = -1;
      if (hatteFokus) zeile.focus({ preventScroll: true });
      [...zeile.children].forEach((kind) => {
        kind.inert = true;
      });
      return true;
    };

    const planen = (zeile, menge, art, sofort = false) => {
      const key = zeile.dataset.key;
      const titel = zeile.dataset.titel || '';
      clearTimeout(timer.get(key));
      timer.delete(key);
      /* Geht 0 an Shopify, ist die Zeile ab da gesperrt — ein weiterer
         Klick schickte sonst eine Menge für eine Position, die es nicht
         mehr gibt. */
      const los = () => {
        if (menge === 0) sperren(zeile);
        senden(key, menge, art, titel);
      };
      if (sofort) {
        los();
        return;
      }
      timer.set(
        key,
        setTimeout(() => {
          timer.delete(key);
          los();
        }, WARTEZEIT),
      );
    };

    const wegnehmen = (zeile, art) => {
      if (!sperren(zeile)) return;
      const feld = zeile.querySelector('[data-rolle="menge"]');
      if (feld) feld.value = '0';
      vorrechnen();
      planen(zeile, 0, art, true);
    };

    const gemerkt = (handle) => {
      try {
        const liste = JSON.parse(localStorage.getItem('hervis-shop-merkliste') || '[]');
        return Array.isArray(liste) && liste.includes(handle);
      } catch {
        return false;
      }
    };

    /* Läuft vor allen anderen Klick-Empfängern (auch vor der Merkliste der
       Kopfzeile): in einer gesperrten Zeile zählt kein Klick mehr. Und ist
       der Artikel schon gemerkt, gibt es nichts hinzuzufügen — die Kopfzeile
       würde ihn sonst austragen (data-merken-modus="hinzu"); er verlässt
       nur den Warenkorb. */
    document.addEventListener(
      'click',
      (e) => {
        const zeile = e.target.closest?.('[data-warenkorb] [data-key]');
        if (!zeile) return;
        if (gesperrt(zeile)) {
          e.preventDefault();
          e.stopImmediatePropagation();
          return;
        }
        const merken = e.target.closest('[data-warenkorb-merken]');
        if (merken && gemerkt(merken.dataset.handle)) {
          e.stopImmediatePropagation();
          wegnehmen(zeile, 'merken');
        }
      },
      true,
    );

    /* Menge: −/+ (snippets/menge.liquid) oder getippt — beides kommt als „change". */
    document.addEventListener('change', (e) => {
      const feld = e.target;
      if (!(feld instanceof HTMLInputElement) || feld.dataset.rolle !== 'menge') return;
      const zeile = feld.closest('[data-warenkorb] [data-key]');
      if (!zeile || gesperrt(zeile)) return;
      let menge = Number.parseInt(feld.value, 10);
      if (!Number.isFinite(menge) || menge < 0) {
        menge = Number(zeile.dataset.mengeServer) || 0;
        feld.value = String(menge);
      }
      vorrechnen();
      planen(zeile, menge, menge === 0 ? 'entfernen' : 'menge');
    });

    /* Enter im Mengenfeld speichert sofort — und schickt nicht das Formular
       (dessen erster Knopf wäre „Zur Kasse"). */
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Enter') return;
      const feld = e.target;
      if (!(feld instanceof HTMLInputElement) || feld.dataset.rolle !== 'menge') return;
      const zeile = feld.closest('[data-warenkorb] [data-key]');
      if (!zeile) return;
      e.preventDefault();
      if (gesperrt(zeile)) return;
      const menge = Math.max(0, Number.parseInt(feld.value, 10) || 0);
      feld.value = String(menge);
      if (menge === 0) {
        wegnehmen(zeile, 'entfernen');
        return;
      }
      vorrechnen();
      planen(zeile, menge, 'menge', true);
    });

    document.addEventListener('click', (e) => {
      const entfernen = e.target.closest('[data-warenkorb] [data-warenkorb-entfernen]');
      if (entfernen) {
        e.preventDefault();
        const zeile = entfernen.closest('[data-key]');
        if (zeile) wegnehmen(zeile, 'entfernen');
        return;
      }
      /* Merken: die Merkliste (Kopfzeile) nimmt den Artikel per
         data-merken auf. Erst wenn er dort angekommen ist, verlässt er den
         Warenkorb — sonst wäre er an beiden Orten weg. */
      const merken = e.target.closest('[data-warenkorb] [data-warenkorb-merken]');
      if (merken) {
        const zeile = merken.closest('[data-key]');
        if (!zeile || gesperrt(zeile)) return;
        const handle = merken.dataset.handle;
        setTimeout(() => {
          if (gesperrt(zeile)) return;
          if (gemerkt(handle)) wegnehmen(zeile, 'merken');
          else ansagen(text('textFehlerMerken'));
        });
      }
    });

    /* Zurück aus dem Verlauf: der Warenkorb kann sich woanders geändert haben. */
    window.addEventListener('pageshow', (e) => {
      if (!e.persisted || !inhalt()) return;
      neuLaden = true;
      abschliessen();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const wurzel = document.querySelector('[data-countdown]');
    if (!wurzel) return;

    // Fenster: öffnen per [data-countdown-oeffnet], schließen per ✕, Esc
    // (nativ) oder Klick auf den Schleier.
    wurzel.querySelectorAll('[data-countdown-oeffnet]').forEach((knopf) => {
      const fenster = document.getElementById(knopf.dataset.countdownOeffnet);
      if (!fenster) return;
      knopf.addEventListener('click', () => {
        fenster.showModal();
        const text = fenster.querySelector('.countdown__text');
        if (text) text.scrollTop = 0;
      });
    });
    wurzel.querySelectorAll('dialog').forEach((fenster) => {
      fenster.querySelector('[data-countdown-schliesst]')?.addEventListener('click', () => fenster.close());
      fenster.addEventListener('click', (ereignis) => {
        if (ereignis.target === fenster) fenster.close();
      });
    });

    // Shop-Zugang: ?zugang=<passwort> meldet an, ?zugang allein öffnet das Feld.
    const zugang = document.getElementById('countdown-zugangsformular');
    const parameter = new URLSearchParams(location.search);
    if (zugang && parameter.has('zugang')) {
      const code = parameter.get('zugang');
      parameter.delete('zugang');
      const rest = parameter.toString();
      history.replaceState(null, '', location.pathname + (rest ? '?' + rest : '') + location.hash);
      const feld = zugang.querySelector('[data-zugang-passwort]');
      if (code) {
        feld.value = code;
        HTMLFormElement.prototype.submit.call(zugang);
      } else {
        zugang.querySelector('dialog').showModal();
        feld.focus();
      }
    }

    wurzel.querySelectorAll('dialog[data-gleich-offen]').forEach((fenster) => {
      fenster.showModal();
      fenster.querySelector('.countdown__erfolg')?.focus();
    });

    // Countdown; nach Ablauf (oder mit ?ende) „Hervis ist zurück" und die
    // App-Knöpfe, sofern beide Store-Adressen gesetzt sind.
    const ziel = new Date(wurzel.dataset.ziel).getTime();
    const ende = /[?&]ende\b/.test(location.search);
    const appLinks = wurzel.dataset.appLinks === 'true';
    const felder = ['tage', 'stunden', 'minuten', 'sekunden'].map((e) => wurzel.querySelector(`[data-einheit="${e}"]`));
    const zwei = (n) => String(n).padStart(2, '0');
    let uhr;
    const ticken = () => {
      const rest = ende || Number.isNaN(ziel) ? 0 : Math.max(0, Math.floor((ziel - Date.now()) / 1000));
      [Math.floor(rest / 86400), Math.floor(rest / 3600) % 24, Math.floor(rest / 60) % 60, rest % 60].forEach(
        (wert, i) => {
          felder[i].textContent = zwei(wert);
        },
      );
      if (rest === 0 && (appLinks || ende)) {
        clearInterval(uhr);
        wurzel.querySelector('[data-titel]').textContent = wurzel.dataset.endeTitel;
        wurzel.querySelector('[data-unterzeile]').textContent = wurzel.dataset.endeUnterzeile;
        wurzel.querySelector('[data-uhr]').hidden = true;
        const knoepfe = wurzel.querySelector('[data-app-knoepfe]');
        if (knoepfe) knoepfe.hidden = false;
      }
    };
    uhr = setInterval(ticken, 1000);
    ticken();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["erlebnis-portal"] && !Shopify.designMode) return;
  try {
    
  (() => {
    /* Alte geteilte Links aus der Zeit der Demo-Bereiche: alles Soziale
       öffnet nur noch das App-Blatt (Thema „standard"), ein Beitrag mit
       gültiger Metaobjekt-gid öffnet ihn in der App. */
    const SOZIAL = ['community', 'challenge', 'event', 'profil'];
    const BEITRAG_GID = /^gid:\/\/shopify\/Metaobject\/\d+$/;
    const WELT_ALIAS = { winter: 'ski', laufen: 'running', racketsport: 'tennis-padel' };
    /* /?view=app#loyalty: „In der App öffnen" führt dann dorthin. */
    const APP_ZIEL =
      /^(?:shop|browse|brands|cart|wishlist|loyalty|orders|addresses|settings|legal|account|stores|foot-scan|consents)$/;
    const controllers = new Map();

    const hashTeile = () => {
      let h = '';
      try {
        h = decodeURIComponent(location.hash.slice(1));
      } catch {}
      const i = h.indexOf('=');
      return i < 0 ? [h, ''] : [h.slice(0, i), h.slice(i + 1)];
    };

    /* Das App-Blatt ist ein Snippet — sein Skript läuft nach den Sections.
       Darum erst nach dem Laden aller Skripte fragen. */
    const nachDemStart = (fn) => {
      let erledigt = false;
      const los = () => {
        if (erledigt) return;
        erledigt = true;
        fn();
      };
      if (document.readyState === 'complete') los();
      else {
        document.addEventListener('DOMContentLoaded', los, { once: true });
        window.addEventListener('load', los, { once: true });
      }
    };
    const einladen = (detail) =>
      nachDemStart(() => document.dispatchEvent(new CustomEvent('hervis:app-einladung', { detail })));

    function hashFolgen(root) {
      const [route, id] = hashTeile();
      if (route === 'welt') {
        let ziele = {};
        try {
          ziele = JSON.parse(root.querySelector('[data-welt-ziele]')?.textContent || '{}');
        } catch {}
        const welt = id.toLowerCase().replace(/^world[-:]/, '');
        const ziel = ziele[WELT_ALIAS[welt] || welt];
        if (typeof ziel === 'string' && ziel.startsWith('/')) location.replace(ziel);
        return;
      }
      if (route === 'beitrag') {
        if (BEITRAG_GID.test(id)) einladen({ thema: 'beitrag', pfad: '/live?post=' + encodeURIComponent(id) });
        else if (id) einladen({ thema: 'standard' });
        return;
      }
      if (SOZIAL.includes(route) && id) {
        einladen({ thema: 'standard' });
        return;
      }
      if (root.dataset.kind === 'app' && APP_ZIEL.test(route)) {
        root.querySelectorAll('[data-app-oeffnen]').forEach((a) => {
          a.dataset.appPfad = '/' + route;
        });
      }
    }

    /* Die Wischreihe ist nur fokussierbar, solange sie wirklich scrollt. */
    function reiheBeobachten(root, signal) {
      const reihe = root.querySelector('[data-app-trio]');
      if (!reihe || !('ResizeObserver' in window)) return;
      const pruefen = () => {
        if (reihe.scrollWidth > reihe.clientWidth + 1) reihe.setAttribute('tabindex', '0');
        else reihe.removeAttribute('tabindex');
      };
      const beobachter = new ResizeObserver(pruefen);
      beobachter.observe(reihe);
      signal.addEventListener('abort', () => beobachter.disconnect());
    }

    function init(scope) {
      scope.querySelectorAll('[data-app-portal]').forEach((root) => {
        if (controllers.has(root)) return;
        const controller = new AbortController();
        controllers.set(root, controller);
        hashFolgen(root);
        reiheBeobachten(root, controller.signal);
        window.addEventListener('hashchange', () => hashFolgen(root), { signal: controller.signal });
      });
    }
    init(document);
    document.addEventListener('shopify:section:load', (e) => init(e.target));
    document.addEventListener('shopify:section:unload', (e) =>
      controllers.forEach((c, r) => {
        if (e.target.contains(r)) {
          c.abort();
          controllers.delete(r);
        }
      }),
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["filialfinder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const wurzel = document.querySelector('[data-filialfinder]');
    if (!wurzel) return;

    /* --- Feste Daten aus der App (lib/stores.ts, main @ 2f4e31e) ------------ */
    const GRUPPEN = [
      [
        'bike',
        [
          'werkstatt-reparatur',
          'bikeservice-montage',
          'bike-service-online-termin',
          'e-bike-service',
          'bikecheck',
          'bikevermessung',
          'bike-rent',
          'bike-verkauf',
          'e-bike-verkauf',
          'bike-leasing',
          'e-ladestation-bike',
        ],
      ],
      [
        'ski',
        [
          'ski-rent',
          'kinder-ski-miete',
          'skitouren-rent',
          'skidepot',
          'skiservice',
          'skimontage',
          'ski-touren-montage',
          'ski-boot-fitting',
          'skibindung-sicherheitscheck',
          'eislauf-schleifservice',
        ],
      ],
      ['fitting', ['fussanalyse-3d', 'sohlenanpassung', 'tennisbespannservice']],
      [
        'einkauf',
        [
          'click-collect',
          'reservierung-im-store',
          'order-pay-in-store',
          'verfuegbarkeitscheck',
          'kundenberatung',
          'ratenzahlung',
          'shop-return',
          'umtausch-garantie',
          'rechnungsnachbuchung-app',
        ],
      ],
      ['anreise', ['parkplaetze', 'e-tankstelle-auto', 'barrierefrei', 'barrierefreier-zugang', 'lift']],
    ];
    const HIGHLIGHTS = [
      'ski-rent',
      'skidepot',
      'werkstatt-reparatur',
      'bike-rent',
      'ski-boot-fitting',
      'fussanalyse-3d',
      'bikevermessung',
      'tennisbespannservice',
      'e-tankstelle-auto',
      'click-collect',
    ];
    const NAEHE_KM = 20;
    const SPEICHER = 'hervis:my-store:v1';
    const ALT_SPEICHER = 'hervis-shop-filiale';
    const HINWEIS_MS = 3200;

    /* Karte: Maßstab s = Bildschirm-px je Karteneinheit (1 Einheit ≈ 1,1 km).
       Pixelmaße (Punkt, Abstände, Trefferradien, Ränder) misst die Karte aus
       den Tokens, siehe miss() in baueKarte. */
    const S_MAX = 40; // nächster Zoom: Wiener Filialen liegen ~80 px auseinander
    const S_DETAIL = 8; // eine gewählte Filiale (Umkreis ~50 km, Wien noch getrennt)
    const S_EINZEL = 3; // ein einzelner Treffer: Bundesland mit Umland, Ländernamen im Bild
    const S_KOMPAKT = 2; // dasselbe in der kleinen Karte (Handy, Detail): mehr Umland
    const S_WEIT = 1.2; // darunter (Handy, ganz Österreich) kleinere Punkte
    const S_NAMEN = 5; // ab hier stehen Filialnamen an den Pins, wo Platz ist
    const S_EINPASSEN = 6; // Einpassen zoomt höchstens so nah (Nachbarorte bleiben im Bild)
    const NAH = 6; // Ortssuche/Standort: der Ort und die nächsten n Filialen
    const TIPP_PAUSE = 260; // ms: die Karte folgt dem Tippen erst danach
    const HINWEIS_KARTE_MS = 1800;

    /* --- Texte (t liefert maskiertes HTML → hier wieder Klartext) ----------- */
    const entschluessler = document.createElement('textarea');
    const klar = (wert) => {
      if (typeof wert === 'string') {
        entschluessler.innerHTML = wert;
        return entschluessler.value;
      }
      if (Array.isArray(wert)) return wert.map(klar);
      if (wert && typeof wert === 'object') {
        return Object.fromEntries(Object.entries(wert).map(([k, v]) => [k, klar(v)]));
      }
      return wert;
    };
    const T = klar(JSON.parse(wurzel.querySelector('[data-ff-texte]').textContent));
    const fuelle = (text, werte) => text.replace(/%(\w+)%/g, (_, k) => (k in werte ? werte[k] : ''));

    const icons = wurzel.querySelector('[data-ff-icons]').content;
    const icon = (name, klasse) => {
      const svg = icons.querySelector(`[data-icon="${name}"] svg`)?.cloneNode(true);
      if (svg && klasse) svg.classList.add(klasse);
      return svg ?? document.createTextNode('');
    };
    const el = (tag, klasse, text) => {
      const knoten = document.createElement(tag);
      if (klasse) knoten.className = klasse;
      if (text != null) knoten.textContent = text;
      return knoten;
    };
    const klemme = (wert, min, max) => Math.min(max, Math.max(min, wert));

    /* --- Elemente ------------------------------------------------------------ */
    const $ = (sel) => wurzel.querySelector(sel);
    const eingabe = $('[data-ff-suche]');
    const ortenKnopf = $('[data-ff-orten]');
    const offenChip = $('[data-ff-offen]');
    const alleChip = $('[data-ff-alle]');
    const zahlAbzeichen = $('[data-ff-zahl]');
    const aktivChip = $('[data-ff-aktiv]');
    const aktivName = $('[data-ff-aktiv-name]');
    const schnellChips = [...wurzel.querySelectorAll('[data-ff-schnell]')];
    const schnellwahl = $('[data-ff-schnellwahl]');
    const statusZeile = $('[data-ff-status]');
    const links = $('[data-ff-links]');
    const listenSpalte = $('[data-ff-liste-spalte]');
    const meinFeld = $('[data-ff-mein]');
    const liste = $('[data-ff-liste]');
    const leer = $('[data-ff-leer]');
    const detail = $('[data-ff-detail]');
    const kartenSpalte = $('[data-ff-karte-spalte]');
    const flaeche = $('[data-ff-flaeche]');
    const wahlFeld = $('[data-ff-kartenwahl]');
    const karteEl = $('[data-ff-karte]');
    const vollbild = $('[data-ff-vollbild]');
    const dialog = $('dialog.filialfinder__dialog');
    const dialogForm = $('[data-ff-dialog-form]');
    const serviceSuche = $('[data-ff-service-suche]');
    const resetKnopf = $('[data-ff-reset]');
    const serviceLeer = $('[data-ff-service-leer]');
    const gruppenFeld = $('[data-ff-gruppen]');
    const toast = $('[data-ff-toast]');
    const werkzeug = $('[data-ff-werkzeug]');
    const breit = window.matchMedia('(min-width: 64rem)');
    const ruhig = window.matchMedia('(prefers-reduced-motion: reduce)');
    const basisTitel = document.title;

    /* --- Zustand ------------------------------------------------------------- */
    let filialen = [];
    let zaehler = {};
    let orte = null;
    let orteLaden = null;
    let service = null;
    let nurOffen = false;
    let geraet = null;
    let meldung = null;
    let gewaehlt = null;
    let ausListe = false;
    let angezeigt = '';
    let modus = 'liste';
    let kartenWahl = null;
    let listenScroll = null;
    let kartenSchluessel = null;
    let kartenUhr = null;
    let vorDetail = null; // Kartenansicht vor dem Detail (zum Zurückkehren)
    let detailAusKarte = false; // Detail kam von einem Pin (Fokus danach: Karte)
    let zurueckLaeuft = false; // history.back() beim Verlassen per Filter läuft
    let jetzt = wienJetzt();

    /* --- Suche: Faltung, Orte, Entfernung (lib/store-nearby.ts) ------------- */
    const falte = (s) =>
      String(s)
        .toLowerCase()
        .replace(/ä/g, 'ae')
        .replace(/ö/g, 'oe')
        .replace(/ü/g, 'ue')
        .replace(/ß/g, 'ss')
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '');
    const falteOrt = (s) =>
      falte(String(s).trim())
        .replace(/\bst\.\s*/g, 'sankt ')
        .replace(/\bst\s+/g, 'sankt ')
        .replace(/\s+/g, ' ');

    function entfernungKm(a, b) {
      const rad = Math.PI / 180;
      const dLat = (b.lat - a.lat) * rad;
      const dLng = (b.lng - a.lng) * rad;
      const s = Math.sin(dLat / 2) ** 2 + Math.cos(a.lat * rad) * Math.cos(b.lat * rad) * Math.sin(dLng / 2) ** 2;
      return 2 * 6371 * Math.asin(Math.sqrt(s));
    }
    const nachNaehe = (punkt, auswahl) =>
      auswahl
        .map((f) => [f, entfernungKm(punkt, f)])
        .sort((a, b) => a[1] - b[1])
        .map(([f]) => f);
    function entfernung(km) {
      if (km < 1) return fuelle(T.meter, { wert: Math.max(50, Math.round((km * 1000) / 50) * 50) });
      return fuelle(T.kilometer, { wert: km < 10 ? km.toFixed(1).replace('.', ',') : Math.round(km) });
    }

    function ladeOrte() {
      orteLaden ??= fetch(wurzel.dataset.orte)
        .then((antwort) => (antwort.ok ? antwort.json() : Promise.reject(new Error(antwort.status))))
        .then((daten) => {
          const plz = new Map();
          const index = new Map();
          for (const [name, lat, lng] of daten.orte) index.set(falteOrt(name), { label: name, lat, lng });
          for (const [nummer, ort, lat, lng] of daten.plz) {
            plz.set(nummer, { label: `${nummer} ${ort}`, lat, lng });
            const schluessel = falteOrt(ort);
            if (!index.has(schluessel)) index.set(schluessel, { label: ort, lat, lng });
          }
          orte = { plz, index };
        })
        .catch(() => {
          orte = { plz: new Map(), index: new Map() };
        })
        .finally(() => zeichne());
      return orteLaden;
    }

    const OFFEN = Symbol('orte');
    // Erst die Länge prüfen: ein, zwei Zeichen laden keine Ortsdaten.
    function ortExakt(f) {
      if (f.length < 3) return null;
      if (!orte) throw OFFEN;
      return orte.index.get(f) ?? null;
    }
    function ortAnfang(f) {
      if (f.length < 4) return null;
      if (!orte) throw OFFEN;
      let bester = null;
      for (const schluessel of orte.index.keys()) {
        if (schluessel.startsWith(f) && (bester === null || schluessel.length < bester.length)) bester = schluessel;
      }
      return bester ? orte.index.get(bester) : null;
    }

    /* Deutung der Eingabe — wie searchNearby der App:
       1. volle PLZ → alle nach Nähe; 2. Treffer in Name/Ort/PLZ; 3. bekannter
       Ort → nach Nähe; 4. Treffer nur in der Straße; 5. Ortsanfang ab vier
       Zeichen; 6. unter vier Zeichen ohne Treffer bleibt die volle Liste.
       (3 vor 4: „Linz" meint den Ort, nicht die Linzerstraße in Vöcklabruck.) */
    function deute(roh, auswahl) {
      const mitGeraet = (treffer) => ({
        stores: geraet ? nachNaehe(geraet, treffer) : treffer,
        ursprung: geraet,
        naehe: null,
      });
      const naheZu = (ort) => ({ stores: nachNaehe(ort, auswahl), ursprung: ort, naehe: ort });
      const q = roh.trim();
      if (!q) return mitGeraet(auswahl);
      if (/^\d{4}$/.test(q)) {
        if (!orte) throw OFFEN;
        const plz = orte.plz.get(q);
        if (plz) return naheZu(plz);
      }
      const f = falteOrt(q);
      const stark = auswahl.filter((s) => s.suchtext.includes(f));
      if (stark.length) return mitGeraet(stark);
      const exakt = ortExakt(f);
      if (exakt) return naheZu(exakt);
      const strasse = auswahl.filter((s) => s.strasse.includes(f));
      if (strasse.length) return mitGeraet(strasse);
      const anfang = ortAnfang(f);
      if (anfang) return naheZu(anfang);
      if (f.length < 4) return { ...mitGeraet(auswahl), wartend: true };
      return mitGeraet([]);
    }

    /* --- Öffnungsstatus in Wiener Zeit (lib/stores.ts openStatus/hoursTable) - */
    function wienJetzt() {
      const teile = {};
      const format = new Intl.DateTimeFormat('en-US', {
        timeZone: 'Europe/Vienna',
        weekday: 'short',
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23',
      });
      for (const teil of format.formatToParts(new Date())) teile[teil.type] = teil.value;
      const tag = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].indexOf(teile.weekday);
      return { tag, min: (Number(teile.hour) % 24) * 60 + Number(teile.minute) };
    }
    const zuMin = (zeit) => Number(zeit.slice(0, 2)) * 60 + Number(zeit.slice(3, 5));
    const fuerTag = (f, tag) =>
      f.openingHours.filter((iv) => iv.days.includes(tag)).sort((a, b) => zuMin(a.open) - zuMin(b.open));

    function oeffnung(f) {
      if (!f.openingHours?.length) return null;
      const { tag, min } = jetzt;
      const heute = fuerTag(f, tag);
      const jetztOffen = heute.find((iv) => min >= zuMin(iv.open) && min < zuMin(iv.close));
      if (jetztOffen) return { offen: true, detail: fuelle(T.bis, { zeit: jetztOffen.close }) };
      const spaeter = heute.find((iv) => min < zuMin(iv.open));
      if (spaeter) return { offen: false, detail: fuelle(T.oeffnet_um, { zeit: spaeter.open }) };
      for (let vor = 1; vor <= 7; vor++) {
        const d = (tag + vor) % 7;
        const erstes = fuerTag(f, d)[0];
        if (erstes) {
          return {
            offen: false,
            detail:
              vor === 1
                ? fuelle(T.oeffnet_morgen, { zeit: erstes.open })
                : fuelle(T.oeffnet_tag, { tag: T.tage[d], zeit: erstes.open }),
          };
        }
      }
      return null;
    }

    function zeitenTabelle(f) {
      if (!f.openingHours?.length) return null;
      const proTag = [];
      for (let d = 0; d < 7; d++) {
        proTag.push(
          fuerTag(f, d)
            .map((iv) => fuelle(T.zeitspanne, { von: iv.open, bis: iv.close }))
            .join(' / '),
        );
      }
      const zeilen = [];
      let start = 0;
      for (let d = 1; d <= 7; d++) {
        if (d === 7 || proTag[d] !== proTag[start]) {
          const ende = d - 1;
          zeilen.push({
            label: start === ende ? T.tage[start] : `${T.tage[start]} – ${T.tage[ende]}`,
            zeit: proTag[start] || T.ganztags_geschlossen,
            heute: jetzt.tag >= start && jetzt.tag <= ende,
          });
          start = d;
        }
      }
      return zeilen;
    }

    function statusText(st) {
      const zeile = el('span', 'ff-status');
      zeile.dataset.ffOeffnung = '';
      zeile.append(
        el(
          'span',
          `ff-status__wort ff-status__wort--${st.offen ? 'offen' : 'zu'}`,
          st.offen ? T.geoeffnet : T.geschlossen,
        ),
        ` · ${st.detail}`,
      );
      return zeile;
    }

    // Höchstens zwei Highlights je Zeile — keine Kette.
    const highlights = (f) =>
      HIGHLIGHTS.filter((k) => f.services.includes(k))
        .slice(0, 2)
        .map((k) => T.service[k]);

    /* --- Mein Store ---------------------------------------------------------- */
    function leseMein() {
      try {
        let id = localStorage.getItem(SPEICHER);
        if (id === null) {
          const alt = localStorage.getItem(ALT_SPEICHER);
          if (alt) {
            localStorage.setItem(SPEICHER, alt);
            id = alt;
          }
        }
        localStorage.removeItem(ALT_SPEICHER);
        return id;
      } catch {
        return null;
      }
    }
    let meinId = leseMein();
    const meinStore = () => filialen.find((f) => f.id === meinId) ?? null;

    let toastUhr = null;
    function zeigeHinweis(text) {
      clearTimeout(toastUhr);
      toast.textContent = text;
      toast.dataset.sichtbar = '';
      toastUhr = setTimeout(() => delete toast.dataset.sichtbar, HINWEIS_MS);
    }

    function setzeMein(id) {
      const f = filialen.find((x) => x.id === id);
      try {
        if (id) localStorage.setItem(SPEICHER, id);
        else localStorage.removeItem(SPEICHER);
      } catch {
        /* Privater Modus: gilt dann nur bis zum Neuladen. */
      }
      meinId = id;
      document.dispatchEvent(new CustomEvent('hervis:mein-store', { detail: { id } }));
      zeigeHinweis(id && f ? fuelle(T.mein_store_gesetzt, { name: f.name }) : T.mein_store_entfernt);
      zeichne({ detailNeu: true });
    }

    /* =========================================================================
       Karte: Umriss aus snippets/oesterreich-karte.liquid (SVG, Ausschnitt über
       viewBox), darüber Pins als HTML-Schicht in Bildschirm-px — so bleiben
       Punkte und Namensschilder bei jedem Zoom gleich groß.
       Drei Arten (data-art an .ff-karte, setzt platziereKarte): „seite" ab
       64rem, „kompakt" (starr, ein Tipp ruft rueckruf.gross) und „voll".
       ========================================================================= */
    function baueKarte(rueckruf) {
      const svg = flaeche.querySelector('svg');
      const ebene = flaeche.querySelector('[data-ff-pins]');
      const steuerung = karteEl.querySelector('.ff-karte__steuerung');
      const legende = karteEl.querySelector('.ff-karte__legende');
      const hinweis = $('[data-ff-zoomhinweis]');
      const sonde = $('[data-ff-sonde]');
      const zoomRein = karteEl.querySelector('[data-ff-zoom="rein"]');
      const zoomRaus = karteEl.querySelector('[data-ff-zoom="raus"]');
      const namen = [...flaeche.querySelectorAll('.oesterreich-karte__namen > span')].map((n) => ({
        el: n,
        x: Number(n.dataset.x),
        y: Number(n.dataset.y),
        platz: Number(n.dataset.platz),
        ab: Number(n.dataset.ab ?? 0),
        breite: 0,
        hoehe: 0,
      }));
      // Projektion wie im Snippet dokumentiert (data-Attribute am <svg>).
      const lon0 = Number(svg.dataset.lon0);
      const lat1 = Number(svg.dataset.lat1);
      const k = Number(svg.dataset.k);
      const cosLat = Math.cos((Number(svg.dataset.lat0) * Math.PI) / 180);
      const projiziere = (p) => ({ x: (p.lng - lon0) * cosLat * k, y: (lat1 - p.lat) * k });
      const vb = svg.viewBox.baseVal;
      const land = { x0: vb.x, y0: vb.y, x1: vb.x + vb.width, y1: vb.y + vb.height };
      const art = () => karteEl.dataset.art;

      let W = 0;
      let H = 0;
      let sicht = { cx: (land.x0 + land.x1) / 2, cy: (land.y0 + land.y1) / 2, s: 1 };
      let fahrt = 0;
      let manuell = false; // der Mensch hat verschoben/gezoomt
      let einpassung = null; // letzter Auftrag — wird bei neuer Größe wiederholt
      let nachholen = null; // Auftrag, solange die Karte keine Größe hat
      let schwebeId = null;
      let hebeId = null;
      let wahlId = null;
      let reihenfolge = []; // sichtbare Pins in Listenreihenfolge (Vorrang für Namen)
      let namenHoehe = 0;
      let hindernisse = null; // Knöpfe, Legende, Filialkarte (px in der Fläche)
      const pins = new Map();
      const marken = {};

      for (const markenArt of ['ort', 'geraet']) {
        const m = el('span', `ff-marke ff-marke--${markenArt}`);
        m.hidden = true;
        if (markenArt === 'ort') {
          m.append(el('span', 'ff-marke__name'));
          m.dataset.name = 'unten';
        }
        ebene.append(m);
        marken[markenArt] = { el: m, x: 0, y: 0, breite: 0 };
      }

      // Pixelmaße aus den Tokens (Regel 2): die Sonde nimmt den Wert als
      // Breite an, das Skript liest px zurück. Neu, sobald die Schrift steht.
      const M = {};
      function miss() {
        const px = (wert) => {
          sonde.style.width = wert;
          return sonde.getBoundingClientRect().width;
        };
        M.pinR = px('var(--ff-pin)') / 2;
        M.abstand = px('var(--ff-name-abstand)');
        M.abstandGross = px('var(--ff-name-abstand-gross)');
        M.abstandOrt = px('var(--ff-ort-abstand)');
        M.zielMaus = px('calc(var(--ff-pin) * 0.75)'); // Trefferradius mit Maus …
        M.zielFinger = px('var(--control)') / 2; // … und mit dem Finger
        M.schwelle = px('var(--space-2xs)'); // ab so viel Weg ist ein Tipp ein Ziehen
        M.rand = px('var(--space-2xl)'); // Rand beim Einpassen …
        M.randKlein = px('var(--space-lg)'); // … auf schmaler Karte
        M.randLand = px('var(--space-md)'); // „Ganz Österreich"
        M.randLandKlein = px('var(--space-xs)');
        M.schmal = px('30rem');
        sonde.style.width = '';
      }
      miss();

      // Zoomfahrt: Dauer und Kurve aus den Tokens (--dur-slow, --ease-standard).
      const takt = () => {
        if (ruhig.matches) return 0;
        return (parseFloat(getComputedStyle(flaeche).transitionDuration) || 0) * 1000;
      };
      const kurve = (() => {
        const roh = getComputedStyle(document.documentElement).getPropertyValue('--ease-standard');
        const z = roh.match(/-?[\d.]+/g)?.map(Number);
        if (!z || z.length !== 4) return (t) => 1 - (1 - t) ** 3;
        const [x1, y1, x2, y2] = z;
        const bez = (t, a, b) => 3 * a * t * (1 - t) ** 2 + 3 * b * t * t * (1 - t) + t ** 3;
        const steig = (t, a, b) => 3 * a * (1 - t) ** 2 + 6 * (b - a) * t * (1 - t) + 3 * (1 - b) * t * t;
        return (x) => {
          let t = x;
          for (let i = 0; i < 8; i++) {
            const d = steig(t, x1, x2);
            if (Math.abs(d) < 1e-6) break;
            t = klemme(t - (bez(t, x1, x2) - x) / d, 0, 1);
          }
          return bez(t, y1, y2);
        };
      })();

      const sGanz = (rand) => Math.min((W - 2 * rand) / (land.x1 - land.x0), (H - 2 * rand) / (land.y1 - land.y0));
      const sMin = () => sGanz(0) * 0.6;
      const begrenze = (z) => ({
        s: klemme(z.s, sMin(), S_MAX),
        cx: klemme(z.cx, land.x0, land.x1),
        cy: klemme(z.cy, land.y0, land.y1),
      });
      const aufSchirm = (p) => ({ x: (p.x - sicht.cx) * sicht.s + W / 2, y: (p.y - sicht.cy) * sicht.s + H / 2 });
      const setze = (knoten, p) => {
        const q = aufSchirm(p);
        knoten.style.translate = `${q.x.toFixed(1)}px ${q.y.toFixed(1)}px`;
      };
      // Platz, den die Filialkarte unten belegt (nur in der großen Karte).
      const unterKarte = () => (wahlFeld.hidden || !karteEl.contains(wahlFeld) ? 0 : H - wahlFeld.offsetTop);

      function zeichneKarte() {
        if (!W || !H) return;
        if (!M.pinR) miss();
        const { cx, cy, s } = sicht;
        svg.setAttribute('viewBox', `${cx - W / 2 / s} ${cy - H / 2 / s} ${W / s} ${H / s}`);
        ebene.toggleAttribute('data-weit', s < S_WEIT);
        for (const p of pins.values()) if (!p.el.hidden) setze(p.el, p);
        for (const m of Object.values(marken)) if (!m.el.hidden) setze(m.el, m);
        setzeNamen();
        // Am Zoom-Ende sagen +/−, dass sie nichts mehr tun.
        const rein = String(s >= S_MAX * 0.999);
        const raus = String(s <= sMin() * 1.001);
        if (zoomRein.getAttribute('aria-disabled') !== rein) zoomRein.setAttribute('aria-disabled', rein);
        if (zoomRaus.getAttribute('aria-disabled') !== raus) zoomRaus.setAttribute('aria-disabled', raus);
      }

      function leseHindernisse() {
        const r0 = flaeche.getBoundingClientRect();
        const liste = [];
        for (const knoten of [...steuerung.children, legende, wahlFeld]) {
          if (!knoten || knoten.hidden || !karteEl.contains(knoten)) continue;
          const r = knoten.getBoundingClientRect();
          if (!r.width || !r.height) continue;
          liste.push({ x0: r.left - r0.left, x1: r.right - r0.left, y0: r.top - r0.top, y1: r.bottom - r0.top });
        }
        return liste;
      }

      // Schild an einem Punkt: Kasten je Lage (CSS: [data-name=oben|unten|…]).
      const LAGEN = ['oben', 'unten', 'rechts', 'links'];
      function kiste(x, y, breite, lage, abstand) {
        const h = namenHoehe;
        if (lage === 'oben') return { x0: x - breite / 2, x1: x + breite / 2, y0: y - abstand - h, y1: y - abstand };
        if (lage === 'unten') return { x0: x - breite / 2, x1: x + breite / 2, y0: y + abstand, y1: y + abstand + h };
        if (lage === 'rechts') return { x0: x + abstand, x1: x + abstand + breite, y0: y - h / 2, y1: y + h / 2 };
        return { x0: x - abstand - breite, x1: x - abstand, y0: y - h / 2, y1: y + h / 2 };
      }

      // Beschriftung in Vorrang-Reihenfolge, jede nur, wo sie nichts verdeckt:
      // 1. gewählte/überfahrene Filiale (immer, an der Seite mit den wenigsten
      // Konflikten), 2. der gesuchte Ort (ebenso), 3. Ländernamen, 4. Filial-
      // namen in Listenreihenfolge — weit draußen mit vielen Treffern keine.
      // Knöpfe, Legende und Filialkarte gelten als belegt.
      function setzeNamen() {
        const ortMarke = marken.ort;
        const fehlen = reihenfolge.filter((p) => !p.breite);
        const ortFehlt = !ortMarke.el.hidden && !ortMarke.breite;
        if (fehlen.length || ortFehlt) {
          ebene.dataset.messen = '';
          for (const p of fehlen) p.breite = p.el.lastChild.offsetWidth;
          if (ortFehlt) ortMarke.breite = ortMarke.el.firstChild.offsetWidth;
          namenHoehe ||= (fehlen[0]?.el.lastChild ?? ortMarke.el.firstChild).offsetHeight;
          delete ebene.dataset.messen;
        }
        hindernisse ??= leseHindernisse();
        const R = M.pinR;
        const punkte = reihenfolge.map((p) => ({ p, ...aufSchirm(p) }));
        const belegt = [...hindernisse];
        for (const m of Object.values(marken)) {
          if (m.el.hidden) continue;
          const q = aufSchirm(m);
          belegt.push({ x0: q.x - R, x1: q.x + R, y0: q.y - R, y1: q.y + R });
        }
        const ueber = (b, a) => b.x0 < a.x1 && b.x1 > a.x0 && b.y0 < a.y1 && b.y1 > a.y0;
        const drin = (b) => b.x0 >= 0 && b.x1 <= W && b.y0 >= 0 && b.y1 <= H;
        const gedeckt = (b, selbst) => {
          let n = 0;
          for (const q of punkte) {
            if (q.p !== selbst && q.x + R > b.x0 && q.x - R < b.x1 && q.y + R > b.y0 && q.y - R < b.y1) n++;
          }
          return n;
        };
        const beste = (x, y, breite, abstand, selbst) => {
          let wahl = null;
          for (const lage of LAGEN) {
            const b = kiste(x, y, breite, lage, abstand);
            const kosten = (drin(b) ? 0 : 100) + belegt.filter((a) => ueber(b, a)).length * 10 + gedeckt(b, selbst);
            if (!wahl || kosten < wahl.kosten) wahl = { lage, b, kosten };
            if (!kosten) break;
          }
          belegt.push(wahl.b);
          return wahl.lage;
        };

        const lagen = new Map();
        for (const id of new Set([wahlId, schwebeId, hebeId])) {
          const p = pins.get(id);
          if (!p || p.el.hidden) continue;
          const q = aufSchirm(p);
          lagen.set(p, beste(q.x, q.y, p.breite, M.abstandGross, p));
        }
        if (!ortMarke.el.hidden) {
          const q = aufSchirm(ortMarke);
          const lage = beste(q.x, q.y, ortMarke.breite, M.abstandOrt, null);
          if (ortMarke.el.dataset.name !== lage) ortMarke.el.dataset.name = lage;
        }
        // Ländernamen nur, wo sie in ihr Land und ganz ins Bild passen und nichts verdecken.
        for (const n of namen) {
          if (!n.breite) {
            n.el.hidden = false;
            n.breite = n.el.offsetWidth;
            n.hoehe = n.el.offsetHeight;
          }
          let passt = sicht.s >= n.ab && n.breite <= n.platz * sicht.s * 0.9;
          if (passt) {
            const q = aufSchirm(n);
            const b = { x0: q.x - n.breite / 2, x1: q.x + n.breite / 2, y0: q.y - n.hoehe / 2, y1: q.y + n.hoehe / 2 };
            passt = drin(b) && !belegt.some((a) => ueber(b, a)) && !gedeckt(b, null);
            if (passt) {
              belegt.push(b);
              setze(n.el, n);
            }
          }
          n.el.hidden = !passt;
        }
        const viele = reihenfolge.length > 4 && sicht.s < S_NAMEN;
        for (const { p, x, y } of punkte) {
          let lage = lagen.get(p) ?? null;
          if (!lage && !viele) {
            for (const l of LAGEN) {
              const b = kiste(x, y, p.breite, l, M.abstand);
              if (drin(b) && !belegt.some((a) => ueber(b, a)) && !gedeckt(b, p)) {
                belegt.push(b);
                lage = l;
                break;
              }
            }
          }
          if ((p.el.dataset.name ?? null) !== lage) {
            if (lage) p.el.dataset.name = lage;
            else delete p.el.dataset.name;
          }
        }
      }

      function fliege(ziel, sofort) {
        cancelAnimationFrame(fahrt);
        ziel = begrenze(ziel);
        const dauer = sofort ? 0 : takt();
        if (!dauer) {
          sicht = ziel;
          zeichneKarte();
          return;
        }
        const von = sicht;
        const t0 = performance.now();
        const lv = Math.log(von.s);
        const lz = Math.log(ziel.s);
        const reinerZug = Math.abs(lz - lv) < 0.01;
        const schritt = (t) => {
          const p = Math.min(1, (t - t0) / dauer);
          const e = kurve(p);
          const s = Math.exp(lv + (lz - lv) * e);
          // Mitte linear in 1/s: Zoomen um einen festen Punkt statt Schlenker.
          const w = reinerZug ? e : (1 / s - 1 / von.s) / (1 / ziel.s - 1 / von.s);
          sicht = { s, cx: von.cx + (ziel.cx - von.cx) * w, cy: von.cy + (ziel.cy - von.cy) * w };
          zeichneKarte();
          if (p < 1) fahrt = requestAnimationFrame(schritt);
        };
        fahrt = requestAnimationFrame(schritt);
      }

      // Punkte einpassen: { punkte: [{x,y}], s?: fester Maßstab, rand?, sMax?, versatz? }
      function fuehreAus(auftrag, sofort) {
        if (!W || !H) {
          nachholen = auftrag;
          return;
        }
        richteAus(sofort);
      }
      // Ziel eines Auftrags in der jetzigen Größe (ohne zu fliegen).
      function zielVon(auftrag) {
        const { punkte } = auftrag;
        if (!punkte.length) return null;
        let x0 = Infinity;
        let y0 = Infinity;
        let x1 = -Infinity;
        let y1 = -Infinity;
        for (const p of punkte) {
          x0 = Math.min(x0, p.x);
          y0 = Math.min(y0, p.y);
          x1 = Math.max(x1, p.x);
          y1 = Math.max(y1, p.y);
        }
        // Ab 64rem zählt nur der sichtbare Teil: oben auf der Seite ragt die
        // Karte unten aus dem Fenster, bis sie beim Rollen klebt.
        let oben = 0;
        let frei = H;
        if (art() === 'seite') {
          const r = flaeche.getBoundingClientRect();
          oben = klemme(-r.top, 0, H);
          frei = H - oben - klemme(r.bottom - innerHeight, 0, H);
          if (frei < H * 0.4) {
            oben = 0;
            frei = H;
          }
        }
        const rand = auftrag.rand ?? (W < M.schmal ? M.randKlein : M.rand);
        // Oben liegt die Steuerreihe — darunter beginnt der Platz. (In der
        // kleinen Karte sitzt nur „Vergrößern" in der leeren Ecke über
        // Tschechien.) Unten hält die Filialkarte ihren Platz frei.
        const obenFrei =
          art() === 'kompakt'
            ? oben + rand
            : Math.max(oben + rand, steuerung.offsetTop + steuerung.offsetHeight + M.pinR * 2);
        const unten = unterKarte();
        const untenFrei = oben + frei - Math.max(rand, unten ? unten + M.pinR * 4 : 0);
        const hoehe = Math.max(untenFrei - obenFrei, frei / 3);
        let s = auftrag.s;
        if (!s) {
          const bw = x1 - x0;
          const bh = y1 - y0;
          s =
            bw < 0.5 && bh < 0.5
              ? art() === 'kompakt'
                ? S_KOMPAKT
                : S_EINZEL
              : Math.min((W - 2 * rand) / Math.max(bw, 0.5), hoehe / Math.max(bh, 0.5), auftrag.sMax ?? S_EINPASSEN);
        }
        const mitte = (obenFrei + untenFrei) / 2 + (auftrag.versatz ?? 0);
        return begrenze({ cx: (x0 + x1) / 2, cy: (y0 + y1) / 2 + (H / 2 - mitte) / s, s });
      }
      // Der Pin mit offener Filialkarte bleibt zwischen Steuerreihe und Karte.
      function halteSichtbar(z, p) {
        const x = (p.x - z.cx) * z.s + W / 2;
        const y = (p.y - z.cy) * z.s + H / 2;
        const rand = M.pinR * 4;
        const oben = steuerung.offsetTop + steuerung.offsetHeight + rand;
        const unten = H - unterKarte() - rand;
        const dx = x < rand ? x - rand : x > W - rand ? x - (W - rand) : 0;
        const dy = y < oben ? y - oben : y > unten ? y - unten : 0;
        return dx || dy ? begrenze({ s: z.s, cx: z.cx + dx / z.s, cy: z.cy + dy / z.s }) : z;
      }
      // Ausschnitt nach Auftrag (solange niemand selbst gezoomt hat), Filial-
      // karte und Größe: der Bestand rückt über die Filialkarte, die gewählte
      // Filiale bleibt sichtbar.
      function richteAus(sofort) {
        let z = (einpassung && !manuell ? zielVon(einpassung) : null) ?? begrenze(sicht);
        const p = unterKarte() ? pins.get(wahlId) : null;
        if (p) z = halteSichtbar(z, p);
        fliege(z, sofort);
      }
      function auftrag(a, sofort) {
        einpassung = a;
        manuell = false;
        nachholen = null;
        fuehreAus(a, sofort);
      }

      function zoomeUm(p, faktor, sofort) {
        const s = klemme(sicht.s * faktor, sMin(), S_MAX);
        const ux = sicht.cx + (p.x - W / 2) / sicht.s;
        const uy = sicht.cy + (p.y - H / 2) / sicht.s;
        manuell = true;
        fliege({ s, cx: ux - (p.x - W / 2) / s, cy: uy - (p.y - H / 2) / s }, sofort);
      }

      const ganz = (sofort) =>
        auftrag(
          {
            punkte: [
              { x: land.x0, y: land.y0 },
              { x: land.x1, y: land.y1 },
            ],
            rand: W < M.schmal ? M.randLandKlein : M.randLand,
            sMax: S_MAX,
          },
          sofort,
        );

      /* --- Treffer unter dem Zeiger ----------------------------------------- */
      function bei(p, radius) {
        const funde = [];
        for (const pin of pins.values()) {
          if (pin.el.hidden) continue;
          const q = aufSchirm(pin);
          const d = Math.hypot(q.x - p.x, q.y - p.y);
          if (d <= radius) funde.push({ pin, d });
        }
        return funde.sort((a, b) => a.d - b.d);
      }

      function tippe(p, zeigerArt) {
        const fein = zeigerArt === 'mouse';
        const funde = bei(p, fein ? M.zielMaus : M.zielFinger);
        if (!funde.length) {
          rueckruf.leer();
          return;
        }
        const [a, b] = funde;
        const eindeutig = !b || (fein && a.d <= M.pinR && b.d > a.d + M.pinR) || sicht.s >= S_MAX * 0.95;
        if (eindeutig) {
          rueckruf.wahl(a.pin.f.id);
          return;
        }
        // Mehrere Pins übereinander (Wien): hinein, bis sie auseinanderliegen.
        let naechste = Infinity;
        let x0 = Infinity;
        let y0 = Infinity;
        let x1 = -Infinity;
        let y1 = -Infinity;
        funde.forEach(({ pin }, i) => {
          x0 = Math.min(x0, pin.x);
          y0 = Math.min(y0, pin.y);
          x1 = Math.max(x1, pin.x);
          y1 = Math.max(y1, pin.y);
          for (const { pin: andere } of funde.slice(i + 1)) {
            naechste = Math.min(naechste, Math.hypot(pin.x - andere.x, pin.y - andere.y));
          }
        });
        const trennen = naechste > 0 ? (M.pinR * 6) / naechste : S_MAX;
        const passen = Math.min((W * 0.7) / Math.max(x1 - x0, 0.5), (H * 0.7) / Math.max(y1 - y0, 0.5));
        manuell = true;
        fliege({ cx: (x0 + x1) / 2, cy: (y0 + y1) / 2, s: Math.max(sicht.s * 2, Math.min(trennen, passen)) });
      }

      function schwebe(p) {
        const fund = p ? bei(p, M.zielMaus)[0] : null;
        const id = fund ? fund.pin.f.id : null;
        flaeche.toggleAttribute('data-ueber-pin', Boolean(id));
        if (id === schwebeId) return;
        schwebeId = id;
        markiereHover();
        rueckruf.schwebe(id);
      }
      function markiereHover() {
        for (const [id, p] of pins) p.el.toggleAttribute('data-hover', id === schwebeId || id === hebeId);
        if (W && H) setzeNamen();
      }

      /* --- Zeiger: Ziehen, Pinch, Tipp --------------------------------------- */
      const zeiger = new Map();
      let geste = null;
      const ort = (e) => {
        const r = flaeche.getBoundingClientRect();
        return { x: e.clientX - r.left, y: e.clientY - r.top };
      };
      function starteGeste(bewegt) {
        const punkte = [...zeiger.values()];
        if (punkte.length === 1) {
          geste = { art: 'ziehen', a: punkte[0], sicht: { ...sicht }, bewegt };
        } else if (punkte.length >= 2) {
          const [a, b] = punkte;
          geste = {
            art: 'pinch',
            abstand: Math.hypot(b.x - a.x, b.y - a.y) || 1,
            mitte: { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 },
            sicht: { ...sicht },
            bewegt: true,
          };
        }
      }
      // Die kleine Karte ist starr: kein Ziehen, kein Zoomen — der Tipp
      // (click) öffnet die große Karte, auf einem Pin gleich mit seiner Filiale.
      flaeche.addEventListener('click', (e) => {
        if (art() !== 'kompakt') return;
        const funde = bei(ort(e), e.pointerType === 'mouse' ? M.zielMaus : M.zielFinger);
        const [a, b] = funde;
        rueckruf.gross(a && (!b || b.d > a.d + M.pinR) ? a.pin.f.id : null);
      });
      flaeche.addEventListener('pointerdown', (e) => {
        if (art() === 'kompakt') return;
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        zeiger.set(e.pointerId, ort(e));
        try {
          flaeche.setPointerCapture(e.pointerId);
        } catch {
          /* ohne Capture endet das Ziehen am Rand */
        }
        cancelAnimationFrame(fahrt);
        starteGeste(zeiger.size > 1);
      });
      flaeche.addEventListener('pointermove', (e) => {
        const p = ort(e);
        if (!zeiger.has(e.pointerId)) {
          if (e.pointerType === 'mouse') schwebe(p);
          return;
        }
        zeiger.set(e.pointerId, p);
        if (!geste) return;
        if (geste.art === 'ziehen') {
          const dx = p.x - geste.a.x;
          const dy = p.y - geste.a.y;
          if (!geste.bewegt && Math.hypot(dx, dy) < M.schwelle) return;
          geste.bewegt = true;
          manuell = true;
          flaeche.dataset.zieht = '';
          const g = geste.sicht;
          sicht = begrenze({ s: g.s, cx: g.cx - dx / g.s, cy: g.cy - dy / g.s });
        } else {
          const [a, b] = [...zeiger.values()];
          const g = geste.sicht;
          const mitte = { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 };
          const s = klemme((g.s * Math.hypot(b.x - a.x, b.y - a.y)) / geste.abstand, sMin(), S_MAX);
          // Der Punkt unter der Start-Mitte bleibt unter den Fingern.
          const ux = g.cx + (geste.mitte.x - W / 2) / g.s;
          const uy = g.cy + (geste.mitte.y - H / 2) / g.s;
          manuell = true;
          sicht = begrenze({ s, cx: ux - (mitte.x - W / 2) / s, cy: uy - (mitte.y - H / 2) / s });
        }
        zeichneKarte();
      });
      const ende = (e) => {
        if (!zeiger.has(e.pointerId)) return;
        const p = ort(e);
        zeiger.delete(e.pointerId);
        const war = geste;
        if (zeiger.size) {
          // Vom Pinch bleibt ein Finger: weiterziehen, ohne zu springen.
          starteGeste(true);
          return;
        }
        geste = null;
        delete flaeche.dataset.zieht;
        if (e.type === 'pointerup' && war && !war.bewegt) tippe(p, e.pointerType);
      };
      flaeche.addEventListener('pointerup', ende);
      flaeche.addEventListener('pointercancel', ende);
      flaeche.addEventListener('pointerleave', (e) => {
        if (e.pointerType === 'mouse' && !zeiger.size) schwebe(null);
      });
      flaeche.addEventListener('dblclick', (e) => {
        if (art() === 'kompakt') return;
        const p = ort(e);
        if (!bei(p, M.zielMaus).length) zoomeUm(p, 2);
      });

      // Mausrad ab 64rem nur mit Strg/⌘ (auch Pinch am Trackpad) — sonst
      // rollt die Seite. In der großen Karte rollt nichts: dort zoomt das Rad.
      let hinweisGezeigt = false;
      flaeche.addEventListener(
        'wheel',
        (e) => {
          if (art() === 'kompakt') return;
          if (art() !== 'voll' && !(e.ctrlKey || e.metaKey)) {
            if (!hinweisGezeigt) {
              hinweisGezeigt = true;
              hinweis.dataset.sichtbar = '';
              setTimeout(() => delete hinweis.dataset.sichtbar, HINWEIS_KARTE_MS);
            }
            return;
          }
          e.preventDefault();
          const d = e.deltaMode === 1 ? e.deltaY * 16 : e.deltaY;
          zoomeUm(ort(e), Math.exp(-klemme(d, -60, 60) / 120), true);
        },
        { passive: false },
      );

      karteEl.querySelectorAll('[data-ff-zoom]').forEach((knopf) =>
        knopf.addEventListener('click', () => {
          if (knopf.getAttribute('aria-disabled') === 'true') return;
          const zoom = knopf.dataset.ffZoom;
          if (zoom === 'ganz') ganz(false);
          else zoomeUm({ x: W / 2, y: H / 2 }, zoom === 'rein' ? 2 : 0.5);
        }),
      );

      // Neue Größe (Fenster, Umhängen, große Karte): Auftrag wiederholen,
      // solange niemand selbst verschoben hat. Ab 64rem ändert der Seitenkopf
      // beim Ein- und Ausblenden nur die Höhe — dann bleibt der Ausschnitt
      // oben stehen, statt neu einzupassen und zu springen.
      new ResizeObserver(() => {
        const w = flaeche.clientWidth;
        const h = flaeche.clientHeight;
        if (w === W && h === H) return;
        const nurHoehe = art() === 'seite' && w === W && H > 0;
        const hVorher = H;
        W = w;
        H = h;
        hindernisse = null;
        if (!W || !H) return;
        if (nachholen) {
          nachholen = null;
          richteAus(true);
        } else if (nurHoehe) {
          sicht = begrenze({ ...sicht, cy: sicht.cy + (H - hVorher) / 2 / sicht.s });
          zeichneKarte();
        } else {
          richteAus(true);
        }
      }).observe(flaeche);
      document.fonts?.ready.then(() => {
        miss();
        namen.forEach((n) => (n.breite = 0));
        pins.forEach((p) => (p.breite = 0));
        marken.ort.breite = 0;
        namenHoehe = 0;
        zeichneKarte();
      });

      return {
        setzeFilialen(liste) {
          for (const f of liste) {
            const knoten = el('span', 'ff-pin');
            knoten.append(el('span', 'ff-pin__punkt'), el('span', 'ff-pin__name', f.name));
            ebene.append(knoten);
            pins.set(f.id, { f, el: knoten, ...projiziere(f) });
          }
        },
        // ids in Listenreihenfolge — die vorderen bekommen zuerst einen Namen.
        zeige(ids) {
          const menge = new Set(ids);
          for (const [id, p] of pins) p.el.hidden = !menge.has(id);
          reihenfolge = ids.map((id) => pins.get(id)).filter(Boolean);
          zeichneKarte();
        },
        // stand(f): true = geöffnet, false = geschlossen, undefined = ohne Zeiten.
        status(stand) {
          for (const p of pins.values()) {
            const st = stand(p.f);
            p.el.toggleAttribute('data-zu', st === false);
            p.el.toggleAttribute('data-unbekannt', st === undefined);
          }
        },
        markiere(id) {
          if (id === wahlId) return;
          pins.get(wahlId)?.el.removeAttribute('data-gewaehlt');
          wahlId = id;
          pins.get(id)?.el.setAttribute('data-gewaehlt', '');
          if (W && H) setzeNamen();
        },
        hebe(id) {
          if (id === hebeId) return;
          hebeId = id;
          markiereHover();
        },
        orte(suchort, standort) {
          for (const [markenArt, punkt] of [
            ['ort', suchort],
            ['geraet', standort],
          ]) {
            const m = marken[markenArt];
            m.el.hidden = !punkt;
            if (punkt) Object.assign(m, projiziere(punkt));
            if (punkt?.label && m.el.firstChild.textContent !== punkt.label) {
              m.el.firstChild.textContent = punkt.label;
              m.breite = 0;
            }
          }
          zeichneKarte();
        },
        // Treffer zeigen: ganz Österreich, Ort + nächste, oder alle Treffer.
        passeEin(geoPunkte, { sofort = false, ganzesLand = false } = {}) {
          if (ganzesLand) ganz(sofort);
          else if (geoPunkte.length) auftrag({ punkte: geoPunkte.map(projiziere) }, sofort);
        },
        // Eine Filiale: in der kleinen Karte mit Umland (wo liegt sie?),
        // sonst nah genug, dass die Nachbarn getrennt stehen.
        zuFiliale(id, { sofort = false } = {}) {
          const p = pins.get(id);
          if (!p) return;
          let s = S_DETAIL;
          if (art() === 'kompakt') s = S_KOMPAKT;
          else if (W && H) s = Math.max(sicht.s, S_DETAIL);
          auftrag({ punkte: [p], s }, sofort);
        },
        // Die Filialkarte ging auf oder zu: der Bestand rückt über sie
        // (bzw. wieder zurück); hat der Mensch selbst gezoomt, nur der Pin.
        wahlGeaendert() {
          hindernisse = null;
          if (W && H) richteAus(false);
        },
        // Ansicht merken (vor dem Detail) und wiederherstellen (danach).
        merke() {
          return { sicht: { ...sicht }, einpassung, manuell };
        },
        stelleHer(m, sofort) {
          einpassung = m.einpassung;
          manuell = m.manuell;
          nachholen = null;
          if (m.manuell || !m.einpassung) fliege(m.sicht, sofort);
          else fuehreAus(m.einpassung, sofort);
        },
        // Nach der großen Karte: die kleine zeigt wieder den Auftrag.
        neuEinpassen(sofort) {
          manuell = false;
          if (einpassung) fuehreAus(einpassung, sofort);
        },
        // Umgehängt (andere Art): Knöpfe liegen anders.
        umgehaengt() {
          hindernisse = null;
          zeichneKarte();
        },
        beschrifte(text) {
          flaeche.setAttribute('aria-label', text);
        },
      };
    }

    /* --- Liste ---------------------------------------------------------------- */
    function zeile(f, ursprung) {
      const li = el('li', 'ff-zeile');
      const a = el('a', 'ff-zeile__link');
      a.href = `#filiale=${encodeURIComponent(f.id)}`;
      a.dataset.ffFokus = `zeile:${f.id}`;
      if (f.id === gewaehlt) a.setAttribute('aria-current', 'true');
      const text = el('span', 'ff-zeile__text');
      const kopf = el('span', 'ff-zeile__kopf');
      kopf.append(el('h3', 'ff-zeile__name', f.name));
      if (ursprung) kopf.append(el('span', 'ff-zeile__distanz', entfernung(entfernungKm(ursprung, f))));
      text.append(kopf);
      const st = oeffnung(f);
      if (st) text.append(statusText(st));
      text.append(el('span', 'ff-zeile__adresse', `${f.street} · ${f.zip} ${f.city}`));
      const hl = highlights(f);
      if (hl.length) text.append(el('span', 'ff-zeile__highlights', hl.join(' · ')));
      a.append(text, icon('chevron', 'ff-pfeil'));
      li.append(a);
      return li;
    }

    function meinKarte(f, ursprung) {
      const a = el('a', 'ff-mein');
      a.href = `#filiale=${encodeURIComponent(f.id)}`;
      a.dataset.ffFokus = `zeile:${f.id}`;
      if (f.id === gewaehlt) a.setAttribute('aria-current', 'true');
      const abzeichen = el('span', 'ff-mein__abzeichen');
      abzeichen.append(icon('check'));
      const text = el('span', 'ff-mein__text');
      text.append(el('span', 't-overline', T.mein_store), el('h3', 'ff-mein__name', f.name));
      const st = oeffnung(f);
      const unten = el('span', 'ff-mein__zeile');
      if (st) unten.append(statusText(st));
      else unten.append(`${f.zip} ${f.city}`);
      if (ursprung) unten.append(` · ${entfernung(entfernungKm(ursprung, f))}`);
      text.append(unten);
      a.append(abzeichen, text, icon('chevron', 'ff-pfeil'));
      return a;
    }

    function setzeStatus(text, fehler, istLeer) {
      if (statusZeile.textContent !== text) statusZeile.textContent = text;
      statusZeile.toggleAttribute('data-fehler', Boolean(fehler));
      statusZeile.toggleAttribute('data-leer', Boolean(istLeer));
    }

    const anzahl = (n) => (n === 1 ? T.anzahl_eins : fuelle(T.anzahl_mehr, { n }));

    function zuruecksetzen() {
      eingabe.value = '';
      service = null;
      nurOffen = false;
      meldung = null;
      merkeFilter();
      zeichne();
      eingabe.focus();
    }

    function zeigeLeer(q, katalog) {
      leer.replaceChildren();
      if (katalog) {
        setzeStatus(fuelle(T.kein_ort, { begriff: q }), false, true);
        const gruppe = el('ul', 'gruppe');
        gruppe.setAttribute('role', 'list');
        const li = el('li');
        const a = el('a', 'gruppe__zeile');
        a.href = `${wurzel.dataset.suche}?type=product&q=${encodeURIComponent(q)}`;
        const ic = el('span', 'gruppe__icon');
        ic.append(icon('suche'));
        const text = el('span', 'gruppe__text', T.im_sortiment);
        text.append(el('small', '', fuelle(T.im_sortiment_text, { begriff: q })));
        a.append(ic, text, icon('chevron', 'gruppe__pfeil'));
        li.append(a);
        gruppe.append(li);
        leer.append(gruppe);
      } else {
        let text = nurOffen ? T.leer_offen : T.leer;
        if (q) text = fuelle(nurOffen ? T.leer_suche_offen : T.leer_suche, { begriff: q });
        setzeStatus(text, false, true);
        const knopf = el('button', 'btn btn--ghost', T.filter_zuruecksetzen);
        knopf.type = 'button';
        knopf.addEventListener('click', zuruecksetzen);
        leer.append(knopf);
      }
      leer.hidden = false;
    }

    /* --- Filialkarte in der großen Karte (Tipp auf einen Pin) ---------------- */
    // Gibt zurück, ob die Filialkarte auf- oder zugegangen ist.
    function zeigeKartenwahl() {
      const f = kartenWahl && modus === 'karte' ? filialen.find((x) => x.id === kartenWahl) : null;
      const vorher = !wahlFeld.hidden;
      if (!f) {
        wahlFeld.hidden = true;
        wahlFeld.replaceChildren();
        return vorher;
      }
      const text = el('div', 'ff-karte__wahl-text');
      text.append(el('p', 'ff-karte__wahl-name', f.name));
      const st = oeffnung(f);
      if (st) text.append(statusText(st));
      const ursprung = aktuellerUrsprung();
      let adresse = `${f.street} · ${f.city}`;
      if (ursprung) adresse += ` · ${entfernung(entfernungKm(ursprung, f))}`;
      text.append(el('p', 'ff-karte__wahl-adresse', adresse));
      const zu = el('button', 'icon-knopf');
      zu.type = 'button';
      zu.setAttribute('aria-label', T.schliessen);
      zu.dataset.ffFokus = 'karte:zu';
      zu.append(icon('schliessen'));
      zu.addEventListener('click', () => schliesseKartenwahl(true));
      const mehr = el('a', 'btn');
      mehr.href = `#filiale=${encodeURIComponent(f.id)}`;
      mehr.dataset.ffFokus = 'karte:details';
      mehr.append(el('span', '', T.details), icon('chevron'));
      wahlFeld.replaceChildren(text, zu, mehr);
      wahlFeld.hidden = false;
      return !vorher;
    }
    function schliesseKartenwahl(fokus) {
      if (!kartenWahl) return;
      kartenWahl = null;
      zeigeKartenwahl();
      karte.markiere(gewaehlt);
      karte.wahlGeaendert();
      if (fokus) flaeche.focus({ preventScroll: true });
    }

    function waehleAufKarte(id) {
      if (breit.matches) {
        detailAusKarte = true;
        oeffneFiliale(id);
        return;
      }
      kartenWahl = id;
      karte.markiere(id);
      zeigeKartenwahl();
      karte.wahlGeaendert();
    }

    function oeffneFiliale(id) {
      rollModus('manual');
      if (!gewaehlt) listenScroll = window.scrollY;
      const url = `${location.pathname}${location.search}#filiale=${encodeURIComponent(id)}`;
      if (gewaehlt) history.replaceState(history.state, '', url);
      else history.pushState(history.state, '', url);
      folge(true);
    }

    /* --- Wo die Karte steht ---------------------------------------------------
       Ab 64rem rechts neben der Liste („seite"). Darunter klein über der Liste
       bzw. im Detail-Kopf („kompakt") oder groß im Vollbild-Dialog („voll"). */
    function platziereKarte() {
      const voll = modus === 'karte' && !breit.matches;
      const platz = !voll && !breit.matches && gewaehlt ? detail.querySelector('[data-ff-kartenplatz]') : null;
      const ziel = voll ? vollbild : (platz ?? kartenSpalte);
      const art = breit.matches ? 'seite' : voll ? 'voll' : 'kompakt';
      if (karteEl.parentElement !== ziel) ziel.append(karteEl);
      if (karteEl.dataset.art !== art) {
        karteEl.dataset.art = art;
        karte.umgehaengt();
      }
    }

    let vollOeffner = null;
    function oeffneVoll(id) {
      if (breit.matches || modus === 'karte') return;
      vollOeffner = document.activeElement instanceof HTMLElement ? document.activeElement : null;
      modus = 'karte';
      wurzel.dataset.modus = 'karte';
      platziereKarte();
      vollbild.showModal();
      karteEl.querySelector('[data-ff-voll-zu]')?.focus();
      if (id && id !== gewaehlt) waehleAufKarte(id);
    }
    // Schließt die große Karte; die kleine zeigt wieder den Auftrag.
    function schliesseVoll(fokusZurueck) {
      if (modus !== 'karte') return;
      modus = 'liste';
      wurzel.dataset.modus = 'liste';
      kartenWahl = null;
      zeigeKartenwahl();
      if (vollbild.open) vollbild.close();
      platziereKarte();
      karte.markiere(gewaehlt);
      karte.neuEinpassen(true);
      const oeffner = vollOeffner;
      vollOeffner = null;
      if (fokusZurueck && oeffner?.isConnected) oeffner.focus({ preventScroll: true });
    }
    // Esc schließt erst die Filialkarte, dann die Karte.
    vollbild.addEventListener('cancel', (e) => {
      if (!kartenWahl) return;
      e.preventDefault();
      schliesseKartenwahl(true);
    });
    vollbild.addEventListener('close', () => schliesseVoll(true));
    wurzel
      .querySelectorAll('[data-ff-voll]')
      .forEach((knopf) => knopf.addEventListener('click', () => oeffneVoll(null)));
    karteEl.querySelector('[data-ff-voll-zu]')?.addEventListener('click', () => schliesseVoll(true));

    const karte = baueKarte({
      wahl: waehleAufKarte,
      gross: oeffneVoll,
      leer: () => schliesseKartenwahl(false),
      schwebe: (id) => {
        listenSpalte.querySelectorAll('[data-ff-hover]').forEach((z) => z.removeAttribute('data-ff-hover'));
        if (id)
          listenSpalte.querySelector(`[data-ff-fokus="zeile:${CSS.escape(id)}"]`)?.setAttribute('data-ff-hover', '');
      },
    });

    platziereKarte();

    // Zeile überfahren oder fokussiert → ihr Pin hebt sich ab.
    const zeilenId = (ziel) => ziel?.closest?.('[data-ff-fokus^="zeile:"]')?.dataset.ffFokus.slice(6) ?? null;
    listenSpalte.addEventListener('pointerover', (e) => karte.hebe(zeilenId(e.target)));
    listenSpalte.addEventListener('pointerleave', () => karte.hebe(null));
    listenSpalte.addEventListener('focusin', (e) => karte.hebe(zeilenId(e.target)));
    listenSpalte.addEventListener('focusout', () => karte.hebe(null));

    let letzterUrsprung = null;
    const aktuellerUrsprung = () => letzterUrsprung;

    /* --- Zeichnen ------------------------------------------------------------- */
    function zeichne({ detailNeu = false, getippt = false } = {}) {
      if (!filialen.length) return;
      const fokus = document.activeElement?.closest?.('[data-ff-fokus]')?.dataset.ffFokus;

      let auswahl = filialen;
      if (service) auswahl = auswahl.filter((f) => f.services.includes(service));
      if (nurOffen) auswahl = auswahl.filter((f) => oeffnung(f)?.offen === true);

      const q = eingabe.value.trim();
      let erg;
      try {
        erg = deute(q, auswahl);
      } catch (fehler) {
        if (fehler !== OFFEN) throw fehler;
        setzeStatus(T.ort_suchen);
        ladeOrte();
        return;
      }
      const treffer = erg.stores;
      const ursprung = erg.ursprung;
      letzterUrsprung = ursprung;
      ortenKnopf.setAttribute('aria-pressed', String(Boolean(geraet && !erg.naehe)));

      // „Mein Store" oben angeheftet — nur ohne Suche und nur, wenn er die
      // Filter erfüllt (stores.tsx: sonst wäre die Anheftung gelogen).
      const angeheftet = !q && meinId ? (treffer.find((f) => f.id === meinId) ?? null) : null;
      const rest = angeheftet ? treffer.filter((f) => f !== angeheftet) : treffer;
      meinFeld.replaceChildren(...(angeheftet ? [meinKarte(angeheftet, ursprung)] : []));
      liste.replaceChildren(...rest.map((f) => zeile(f, ursprung)));
      leer.hidden = true;

      if (!treffer.length) {
        // Weder Filiale noch Ort, auch ohne Filter: dann ist es eine
        // Produktsuche („Laufschuhe") — Übergang ins Sortiment.
        let katalog = false;
        if (q.length >= 4) {
          try {
            const ohneFilter = deute(q, filialen);
            katalog = !ohneFilter.wartend && ohneFilter.stores.length === 0;
          } catch {
            katalog = false;
          }
        }
        zeigeLeer(q, katalog);
      } else if (meldung) {
        setzeStatus(meldung.text, meldung.fehler);
      } else if (erg.naehe) {
        const naechste = entfernungKm(erg.naehe, treffer[0]);
        setzeStatus(
          naechste > NAEHE_KM
            ? fuelle(T.keine_in_naehe, { ort: erg.naehe.label, entfernung: entfernung(naechste) })
            : fuelle(T.nach_naehe, { ort: erg.naehe.label }),
        );
      } else {
        const zahl = anzahl(treffer.length);
        setzeStatus(ursprung ? fuelle(T.nach_entfernung, { anzahl: zahl }) : zahl);
      }

      // Bedienelemente spiegeln den Zustand.
      offenChip.setAttribute('aria-pressed', String(nurOffen));
      zahlAbzeichen.hidden = !service;
      aktivChip.hidden = !service;
      if (service) {
        aktivName.textContent = T.service[service];
        aktivChip.title = T.service[service];
        aktivChip.setAttribute('aria-label', fuelle(T.filter_entfernen, { name: T.service[service] }));
      }
      schnellChips.forEach((chip) => chip.setAttribute('aria-pressed', String(chip.dataset.ffSchnell === service)));
      gruppenFeld.querySelectorAll('input').forEach((r) => (r.checked = r.value === service));
      resetKnopf.hidden = !service || Boolean(serviceSuche.value.trim());

      // Karte: dieselben Filialen wie die Liste; die gewählte bleibt sichtbar.
      const sichtbar = treffer.map((f) => f.id);
      if (gewaehlt && !sichtbar.includes(gewaehlt)) sichtbar.push(gewaehlt);
      if (kartenWahl && !sichtbar.includes(kartenWahl)) kartenWahl = null;
      karte.zeige(sichtbar);
      karte.status((f) => oeffnung(f)?.offen);
      karte.markiere(kartenWahl ?? gewaehlt);
      karte.orte(erg.naehe, geraet);
      karte.beschrifte(fuelle(T.karte, { anzahl: anzahl(treffer.length) }));
      if (zeigeKartenwahl()) karte.wahlGeaendert();
      const schluessel = `${treffer.map((f) => f.id).join()}|${ursprung ? `${ursprung.lat},${ursprung.lng}` : ''}`;
      if (schluessel !== kartenSchluessel) {
        const erstes = kartenSchluessel === null;
        kartenSchluessel = schluessel;
        clearTimeout(kartenUhr);
        // Bei 0 Treffern bleibt die Karte stehen (App: die Suche springt nicht).
        if (!gewaehlt && treffer.length) {
          const einpassen = () => {
            // Inzwischen eine Filiale geöffnet? Dann gilt deren Ausschnitt.
            if (gewaehlt) return;
            const ganzesLand = treffer.length === filialen.length && !ursprung;
            const punkte = ursprung ? [ursprung, ...treffer.slice(0, NAH)] : treffer;
            karte.passeEin(punkte, { sofort: erstes, ganzesLand });
          };
          if (getippt) kartenUhr = setTimeout(einpassen, TIPP_PAUSE);
          else einpassen();
        }
      }

      // Detail
      const detailSchluessel = `${gewaehlt}|${ursprung ? `${ursprung.lat},${ursprung.lng}` : ''}|${meinId}|${breit.matches}|${jetzt.tag}`;
      if (detailNeu || detailSchluessel !== angezeigt) {
        angezeigt = detailSchluessel;
        zeigeDetail(gewaehlt, ursprung);
      } else {
        aktualisiereStatus(detail, gewaehlt);
      }
      platziereKarte();

      if (fokus && (!document.activeElement || document.activeElement === document.body)) {
        wurzel.querySelector(`[data-ff-fokus="${CSS.escape(fokus)}"]`)?.focus({ preventScroll: true });
      }
    }

    // Minütlich: nur die Statuszeilen neu schreiben (Fokus bleibt, wo er ist).
    function aktualisiereStatus(bereich, id) {
      bereich.querySelectorAll('[data-ff-oeffnung]').forEach((span) => {
        const f = filialen.find((x) => x.id === (id ?? span.closest('[data-ff-fokus]')?.dataset.ffFokus?.slice(6)));
        const st = f && oeffnung(f);
        if (st) span.replaceWith(statusText(st));
      });
    }

    /* --- Detail (app/stores/[id].tsx) ----------------------------------------- */
    function zeigeDetail(id, ursprung) {
      detail.hidden = !id;
      if (!id) {
        detail.replaceChildren();
        return;
      }
      const f = filialen.find((x) => x.id === id);
      // Breit steht die Seiten-h1 darüber; schmal ist das Detail die Seite.
      const stufe = breit.matches ? 'h2' : 'h1';
      const stufe2 = breit.matches ? 'h3' : 'h2';
      const stufe3 = breit.matches ? 'h4' : 'h3';
      const artikel = el('article', 'ff-detail');
      artikel.setAttribute('aria-labelledby', 'ff-detail-titel');

      const zurueck = el('a', 'btn btn--text ff-detail__zurueck');
      zurueck.href = location.pathname + location.search + listenHash();
      zurueck.dataset.ffZurueck = '';
      zurueck.append(icon('zurueck'), T.alle_filialen);
      artikel.append(zurueck);

      if (!f) {
        const kopf = el('div', 'ff-detail__leer');
        const titel = el(stufe, 'ff-detail__titel', T.nicht_gefunden);
        titel.id = 'ff-detail-titel';
        titel.tabIndex = -1;
        kopf.append(titel);
        artikel.append(kopf);
        detail.replaceChildren(artikel);
        return;
      }

      const kopf = el('header', 'ff-detail__kopf');
      const titel = el(stufe, 'ff-detail__titel', f.name);
      titel.id = 'ff-detail-titel';
      titel.tabIndex = -1;
      kopf.append(el('p', 't-overline', T.hervis_store), titel);
      const st = oeffnung(f);
      if (st) kopf.append(statusText(st));
      const adresse = el('p', 'ff-detail__adresse');
      let adressText = `${f.street} · ${f.zip} ${f.city}`;
      if (ursprung) adressText += ` · ${fuelle(T.entfernt, { entfernung: entfernung(entfernungKm(ursprung, f)) })}`;
      adresse.append(icon('ort'), el('span', '', adressText));
      kopf.append(adresse);
      artikel.append(kopf);
      // Schmal: die kleine Karte gleich unter dem Kopf (App: stores/[id].tsx).
      if (!breit.matches) {
        const platz = el('div', 'ff-detail__karte');
        platz.dataset.ffKartenplatz = '';
        artikel.append(platz);
      }

      // Aktionen
      const aktionen = el('div', 'ff-detail__aktionen');
      const route = el('a', 'btn');
      route.href = `https://www.google.com/maps/dir/?api=1&destination=${f.lat},${f.lng}`;
      route.target = '_blank';
      route.rel = 'noopener';
      route.dataset.ffFokus = 'detail:route';
      route.append(icon('route'), el('span', '', T.route), el('span', 'visually-hidden', ` ${T.neues_fenster}`));
      aktionen.append(route);
      if (f.phone) {
        const tel = el('a', 'btn btn--ghost');
        tel.href = `tel:${f.phone.replace(/[^+\d]/g, '')}`;
        tel.dataset.ffFokus = 'detail:tel';
        tel.setAttribute('aria-label', `${T.anrufen}: ${f.phone}`);
        tel.append(icon('telefon'), el('span', 'ff-tel__wort', T.anrufen), el('span', 'ff-tel__nummer', f.phone));
        aktionen.append(tel);
      }
      const istMein = meinId === f.id;
      // Wie die App ([id].tsx): sichtbar „Mein Store", vorgelesen die Handlung
      // „Nicht mehr mein Store" — kein aria-pressed, weil die Beschriftung wechselt.
      const meinKnopf = el('button', 'btn btn--ghost');
      meinKnopf.type = 'button';
      meinKnopf.dataset.ffFokus = 'detail:mein';
      meinKnopf.toggleAttribute('data-ff-mein-aktiv', istMein);
      if (istMein) meinKnopf.setAttribute('aria-label', T.mein_store_loesen);
      meinKnopf.setAttribute('aria-describedby', 'ff-mein-hinweis');
      meinKnopf.append(icon('check'), el('span', '', istMein ? T.mein_store : T.als_mein_store));
      meinKnopf.addEventListener('click', () => setzeMein(istMein ? null : f.id));
      aktionen.append(meinKnopf);
      const hinweis = el('p', 'ff-detail__hinweis', T.mein_store_hinweis);
      hinweis.id = 'ff-mein-hinweis';
      artikel.append(aktionen, hinweis);

      // Öffnungszeiten: kompakte Tabelle, heute hervorgehoben.
      if (f.hours.length || f.openingHours?.length) {
        const zeiten = el('section', 'ff-abschnitt ff-zeiten');
        zeiten.setAttribute('aria-labelledby', 'ff-zeiten-titel');
        const zTitel = el(stufe2, 'ff-abschnitt__titel', T.oeffnungszeiten);
        zTitel.id = 'ff-zeiten-titel';
        zeiten.append(zTitel);
        const tabelle = zeitenTabelle(f);
        if (tabelle) {
          const t = el('table', 'ff-zeiten__tabelle');
          const koerper = el('tbody');
          for (const z of tabelle) {
            const tr = el('tr');
            if (z.heute) tr.setAttribute('aria-current', 'date');
            const th = el('th', '', z.label);
            th.scope = 'row';
            tr.append(th, el('td', '', z.zeit));
            koerper.append(tr);
          }
          t.append(koerper);
          zeiten.append(t);
        } else {
          const roh = el('ul', 'ff-zeiten__roh');
          roh.setAttribute('role', 'list');
          f.hours.forEach((z) => roh.append(el('li', '', z)));
          zeiten.append(roh);
        }
        artikel.append(zeiten);
      }

      // Services vor Ort: Gruppenüberschrift + Etiketten.
      const services = el('section', 'ff-abschnitt');
      services.setAttribute('aria-labelledby', 'ff-services-vor-ort');
      const sTitel = el(stufe2, 'ff-abschnitt__titel');
      sTitel.id = 'ff-services-vor-ort';
      sTitel.append(el('span', '', T.services_vor_ort), el('span', '', String(f.services.length)));
      services.append(sTitel);
      const gruppenListe = el('div', 'ff-gruppen');
      for (const [gruppe, keys] of GRUPPEN) {
        const angeboten = keys.filter((k) => f.services.includes(k));
        if (!angeboten.length) continue;
        const block = el('div', 'ff-gruppe');
        const gTitel = el(stufe3, 'ff-gruppe__titel');
        gTitel.append(icon(gruppe), el('span', '', T.gruppe[gruppe]));
        const ul = el('ul', 'ff-tags');
        ul.setAttribute('role', 'list');
        for (const key of angeboten) ul.append(el('li', 'ff-tag', T.service[key]));
        block.append(gTitel, ul);
        gruppenListe.append(block);
      }
      services.append(gruppenListe);
      artikel.append(services);

      // Die Filiale in der App (stores/[id]): EINE kompakte Zeile.
      const appListe = el('ul', 'gruppe ff-app');
      appListe.setAttribute('role', 'list');
      const appZeile = el('button', 'gruppe__zeile');
      appZeile.type = 'button';
      appZeile.dataset.appInvite = 'filialen';
      appZeile.dataset.appPfad = `/stores/${f.id}`;
      appZeile.dataset.ffFokus = 'detail:app';
      appZeile.setAttribute('aria-haspopup', 'dialog');
      const appSymbol = icons.querySelector('[data-icon="app"] .app-symbol')?.cloneNode(true);
      const appText = el('span', 'gruppe__text', T.in_app);
      appText.append(el('small', '', T.in_app_text));
      if (appSymbol) appZeile.append(appSymbol);
      appZeile.append(appText, icon('chevron', 'gruppe__pfeil'));
      const appEintrag = el('li');
      appEintrag.append(appZeile);
      appListe.append(appEintrag);
      artikel.append(appListe);

      detail.replaceChildren(artikel);
    }

    /* --- Blatt „Nach Service finden" (store-service-sheet.tsx) ---------------- */
    function baueDialog() {
      const name = `ff-service-${wurzel.dataset.sid}`;
      const teile = [];
      for (const [gruppe, keys] of GRUPPEN) {
        const angeboten = keys.filter((k) => zaehler[k] > 0);
        if (!angeboten.length) continue;
        const feld = el('fieldset', 'ff-wahlgruppe');
        feld.dataset.gruppe = gruppe;
        const legende = el('legend', 'ff-wahlgruppe__legende');
        legende.append(icon(gruppe), el('span', '', T.gruppe[gruppe]));
        feld.append(legende);
        for (const k of angeboten) {
          const label = el('label', 'ff-wahl');
          label.dataset.suchtext = falte(T.service[k]);
          const radio = el('input');
          radio.type = 'radio';
          radio.name = name;
          radio.value = k;
          label.append(
            radio,
            el('span', '', T.service[k]),
            el('span', 'ff-wahl__zahl', String(zaehler[k])),
            icon('check'),
          );
          feld.append(label);
        }
        teile.push(feld);
      }
      gruppenFeld.replaceChildren(...teile);
    }

    function filtereDialog() {
      const q = falte(serviceSuche.value.trim());
      let sichtbar = 0;
      gruppenFeld.querySelectorAll('fieldset').forEach((feld) => {
        let inGruppe = 0;
        feld.querySelectorAll('.ff-wahl').forEach((label) => {
          const passt = !q || label.dataset.suchtext.includes(q);
          label.hidden = !passt;
          if (passt) inGruppe++;
        });
        feld.hidden = inGruppe === 0;
        sichtbar += inGruppe;
      });
      schnellwahl.hidden = Boolean(q);
      serviceLeer.hidden = sichtbar > 0;
      serviceLeer.textContent = sichtbar ? '' : fuelle(T.kein_service, { begriff: serviceSuche.value.trim() });
      resetKnopf.hidden = !service || Boolean(q);
    }

    // Mit Maus/Finger schließt die Wahl das Blatt (wie in der App). Mit den
    // Pfeiltasten wandert man durch die Liste (der Filter folgt sofort) und
    // schließt mit Enter oder Esc.
    let perZeiger = false;
    gruppenFeld.addEventListener('pointerdown', () => (perZeiger = true));
    gruppenFeld.addEventListener('keydown', (e) => {
      perZeiger = false;
      if (e.key !== 'Enter' || !(e.target instanceof HTMLInputElement)) return;
      e.preventDefault();
      if (!e.target.checked) {
        e.target.checked = true;
        waehleService(e.target.value);
      }
      dialog.close();
    });
    gruppenFeld.addEventListener('change', (e) => {
      if (e.target instanceof HTMLInputElement) waehleService(e.target.value);
    });
    gruppenFeld.addEventListener('click', (e) => {
      if (perZeiger && e.target instanceof HTMLInputElement) dialog.close();
    });
    // Schnellwahl oben im Blatt: ein Tipp wählt (oder löst) und schließt.
    schnellChips.forEach((chip) =>
      chip.addEventListener('click', () => {
        waehleService(service === chip.dataset.ffSchnell ? null : chip.dataset.ffSchnell);
        dialog.close();
      }),
    );
    serviceSuche.addEventListener('input', filtereDialog);
    dialogForm.addEventListener('submit', (e) => e.preventDefault());
    resetKnopf.addEventListener('click', () => {
      waehleService(null);
      dialog.close();
    });
    dialog.addEventListener('close', () => {
      serviceSuche.value = '';
      filtereDialog();
    });

    /* --- Bedienung ------------------------------------------------------------- */
    const listenHash = () => (service ? `#service=${encodeURIComponent(service)}` : '');
    function merkeFilter() {
      if (gewaehlt || zurueckLaeuft) return;
      history.replaceState(history.state, '', location.pathname + location.search + listenHash());
    }
    // Neue Suche oder neuer Filter: eine gewählte Filiale gibt den Platz frei.
    // Kam das Detail aus der Liste, ist sein Eintrag im Verlauf überflüssig:
    // ein Schritt zurück, danach schreibt merkeFilter den neuen Filter in den
    // Listeneintrag (sonst täte der erste Browser-Zurück-Schritt nichts).
    function vergissWahl() {
      if (!gewaehlt) return;
      const zurueck = ausListe;
      gewaehlt = null;
      ausListe = false;
      listenScroll = null;
      vorDetail = null;
      detailAusKarte = false;
      kartenSchluessel = null; // die Treffer neu einpassen
      wurzel.dataset.ansicht = 'liste';
      document.title = basisTitel;
      if (zurueck) {
        zurueckLaeuft = true;
        history.back();
      }
    }
    window.addEventListener('popstate', () => {
      if (!zurueckLaeuft) return;
      zurueckLaeuft = false;
      merkeFilter();
    });

    function waehleService(key) {
      service = key && T.service[key] ? key : null;
      meldung = null;
      vergissWahl();
      merkeFilter();
      zeichne();
    }

    eingabe.addEventListener('input', () => {
      meldung = null;
      vergissWahl();
      merkeFilter();
      zeichne({ getippt: true });
    });
    offenChip.addEventListener('click', () => {
      nurOffen = !nurOffen;
      meldung = null;
      jetzt = wienJetzt();
      vergissWahl();
      merkeFilter();
      zeichne();
    });
    aktivChip.addEventListener('click', () => {
      waehleService(null);
      alleChip.focus();
    });

    // Unter 64rem schwebt „Karte", sobald die kleine Karte aus dem Bild ist.
    const kartenSicht = () => {
      const r = kartenSpalte.getBoundingClientRect();
      return r.height > 0 && r.bottom > r.height * 0.3 && r.top < innerHeight - r.height * 0.3;
    };
    new IntersectionObserver(() => wurzel.toggleAttribute('data-karte-im-bild', kartenSicht()), {
      threshold: [0, 0.3, 0.7, 1],
    }).observe(kartenSpalte);

    ortenKnopf.addEventListener('click', () => {
      if (ortenKnopf.getAttribute('aria-pressed') === 'true') {
        geraet = null;
        meldung = null;
        zeichne();
        return;
      }
      if (!('geolocation' in navigator)) {
        meldung = { text: T.standort_fehler, fehler: true };
        zeichne();
        return;
      }
      meldung = { text: T.standort_laeuft };
      setzeStatus(T.standort_laeuft);
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          geraet = { lat: pos.coords.latitude, lng: pos.coords.longitude };
          meldung = null;
          // Der Standort löst eine PLZ-/Ortssuche ab (stores.tsx locate()).
          try {
            if (eingabe.value.trim() && deute(eingabe.value, filialen).naehe) eingabe.value = '';
          } catch {
            /* Orte noch nicht geladen — dann war es keine Ortssuche. */
          }
          vergissWahl();
          merkeFilter();
          zeichne();
        },
        (fehler) => {
          meldung = { text: fehler.code === 1 ? T.standort_verweigert : T.standort_fehler, fehler: true };
          zeichne();
        },
        { enableHighAccuracy: false, timeout: 15000, maximumAge: 300000 },
      );
    });

    /* --- Adressen: #filiale=<id>, #service=<key> -------------------------------- */
    function leseHash() {
      let h = '';
      try {
        h = decodeURIComponent(location.hash.slice(1));
      } catch {
        h = '';
      }
      if (h.startsWith('filiale=')) return { filiale: h.slice(8) };
      if (h.startsWith('service=')) return { service: h.slice(8) };
      return {};
    }

    // Oberkante des freien Bereichs: unter der klebenden Werkzeugleiste (ab
    // 64rem) bzw. dem Suchfeld, sonst unter dem Seitenkopf.
    function kante() {
      const kleber = [werkzeug, $('.filialfinder__suche')].find((k) => k && getComputedStyle(k).position === 'sticky');
      return kleber
        ? kleber.getBoundingClientRect().bottom
        : parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0;
    }
    const imBild = (ziel) => {
      const r = ziel.getBoundingClientRect();
      return r.height > 0 && r.bottom > kante() && r.top < innerHeight;
    };
    // Rollt nur, wenn das Ziel verdeckt oder außer Sicht ist.
    function insBild(ziel) {
      const r = ziel.getBoundingClientRect();
      if (r.top < kante() || r.bottom > innerHeight) ziel.scrollIntoView({ block: 'center', behavior: 'instant' });
    }

    function folge(fokussieren) {
      if (!filialen.length) return;
      const h = leseHash();
      const vorher = gewaehlt;
      if (h.service !== undefined) service = T.service[h.service] ? h.service : null;
      gewaehlt = h.filiale ?? null;
      if (gewaehlt && !vorher) {
        ausListe = fokussieren;
        // Die Kartenansicht merken — „Alle Filialen" kehrt dorthin zurück.
        const ansicht = karte.merke();
        vorDetail = ansicht.einpassung || ansicht.manuell ? { ...ansicht, schluessel: kartenSchluessel } : null;
        clearTimeout(kartenUhr);
      }
      if (!gewaehlt) ausListe = false;
      // Aus der großen Karte ins Detail: die Karte geht zu (App: closeMap).
      if (gewaehlt && modus === 'karte') {
        detailAusKarte = true;
        schliesseVoll(false);
      }
      // Zurück ohne gemerkte Ansicht (Einstieg per Link): Treffer einpassen.
      if (vorher && !gewaehlt && !vorDetail) kartenSchluessel = null;
      wurzel.dataset.ansicht = gewaehlt ? 'detail' : 'liste';
      zeichne({ detailNeu: true });
      if (gewaehlt) {
        const f = filialen.find((x) => x.id === gewaehlt);
        document.title = f ? fuelle(T.seitentitel, { name: f.name }) : basisTitel;
        if (f) karte.zuFiliale(f.id, { sofort: !fokussieren });
        else karte.passeEin([], { ganzesLand: true, sofort: !fokussieren });
        if (fokussieren) {
          if (!breit.matches) window.scrollTo({ top: 0, behavior: 'instant' });
          else {
            const oben = links.getBoundingClientRect().top;
            if (oben < kante() || oben > innerHeight / 2) links.scrollIntoView({ block: 'start', behavior: 'instant' });
          }
          detail.querySelector('#ff-detail-titel')?.focus({ preventScroll: true });
        }
        return;
      }
      document.title = basisTitel;
      const ausKarte = detailAusKarte;
      detailAusKarte = false;
      if (vorher && vorDetail) {
        const gemerkt = vorDetail;
        vorDetail = null;
        if (gemerkt.schluessel === kartenSchluessel) karte.stelleHer(gemerkt, !fokussieren || !breit.matches);
      }
      if (!fokussieren || !vorher) return;
      // Zurück zur Liste: an die alte Stelle. Fokus auf die Zeile — kam man
      // über einen Pin, auf die Karte (oder die „Karte"-Pille, wenn sie außer
      // Sicht ist); ohne Zeile (unbekannte Filiale) auf die Statuszeile.
      const gespeichert = listenScroll;
      listenScroll = null;
      if (gespeichert !== null) window.scrollTo({ top: gespeichert, behavior: 'instant' });
      wurzel.toggleAttribute('data-karte-im-bild', kartenSicht());
      const zeile = wurzel.querySelector(`[data-ff-fokus="zeile:${CSS.escape(vorher)}"]`);
      let ziel = zeile ?? statusZeile;
      if (ausKarte) {
        if (imBild(flaeche)) ziel = flaeche;
        else if (!breit.matches) ziel = $('[data-ff-pille]');
      }
      ziel.focus({ preventScroll: true });
      if (ziel === zeile) insBild(zeile);
    }
    window.addEventListener('hashchange', () => {
      if (zurueckLaeuft) return;
      folge(true);
    });

    // Rollposition bei Schritten im Finder (Liste ↔ #filiale=) bestimmt der
    // Finder selbst (listenScroll); die Wiederherstellung des Browsers käme
    // danach und spränge. Abgeschaltet wird sie erst beim ersten Schritt im
    // Finder und beim Verlassen der Seite wieder eingeschaltet.
    const rollModus = (wert) => {
      try {
        if ('scrollRestoration' in history) history.scrollRestoration = wert;
      } catch {
        /* nicht änderbar — dann rollt der Browser wie gewohnt */
      }
    };
    wurzel.addEventListener('click', (e) => {
      if (!e.target.closest('a[href^="#filiale="]')) return;
      rollModus('manual');
      if (!gewaehlt) {
        listenScroll = window.scrollY;
        detailAusKarte = modus === 'karte';
      }
    });
    window.addEventListener('pagehide', () => rollModus('auto'));

    // „Alle Filialen": kam man aus der Liste, ist das ein Schritt zurück;
    // sonst ein neuer Eintrag.
    detail.addEventListener('click', (e) => {
      const zurueck = e.target.closest('[data-ff-zurueck]');
      if (!zurueck) return;
      e.preventDefault();
      rollModus('manual');
      if (ausListe) {
        history.back();
        return;
      }
      history.pushState(history.state, '', zurueck.getAttribute('href'));
      folge(true);
    });

    breit.addEventListener('change', () => {
      if (breit.matches) schliesseVoll(false);
      kartenWahl = null;
      zeichne({ detailNeu: true });
    });

    // Öffnungsstatus folgt der Uhr, solange die Seite sichtbar ist.
    // Ohne „Jetzt geöffnet" ändern sich nur die Statuszeilen — die werden an
    // Ort und Stelle ersetzt, damit Fokus und Vorleser nicht springen.
    let uhr = null;
    function tick() {
      const tagVorher = jetzt.tag;
      jetzt = wienJetzt();
      if (nurOffen || jetzt.tag !== tagVorher) {
        zeichne();
        return;
      }
      aktualisiereStatus(meinFeld);
      aktualisiereStatus(liste);
      aktualisiereStatus(detail, gewaehlt);
      aktualisiereStatus(wahlFeld, kartenWahl);
      karte.status((f) => oeffnung(f)?.offen);
    }
    const starteUhr = () => {
      clearInterval(uhr);
      uhr = setInterval(tick, 60000);
    };
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        tick();
        starteUhr();
      } else clearInterval(uhr);
    });

    window.addEventListener('storage', (e) => {
      if (e.key !== SPEICHER) return;
      meinId = e.newValue;
      zeichne({ detailNeu: true });
    });

    /* --- Start ------------------------------------------------------------------ */
    function starte(daten) {
      filialen = daten.map((f) => ({
        ...f,
        suchtext: falteOrt(`${f.name} ${f.city} ${f.zip}`),
        strasse: falteOrt(f.street),
      }));
      zaehler = {};
      for (const f of filialen) for (const k of f.services) zaehler[k] = (zaehler[k] ?? 0) + 1;
      if (meinId && !meinStore()) meinId = null;
      karte.setzeFilialen(filialen);
      baueDialog();
      folge(false);
      starteUhr();
      stillOrten();
    }

    // Hat der Browser den Standort für diese Seite schon erlaubt (früherer
    // Knopfdruck), sortiert die Liste gleich nach Nähe — still: keine
    // Nachfrage, keine Statuszeile. Sonst bleibt es beim Knopf „Orten".
    async function stillOrten() {
      try {
        const recht = await navigator.permissions?.query({ name: 'geolocation' });
        if (recht?.state !== 'granted' || geraet) return;
        navigator.geolocation.getCurrentPosition(
          (pos) => {
            if (geraet || eingabe.value.trim()) return;
            geraet = { lat: pos.coords.latitude, lng: pos.coords.longitude };
            zeichne();
          },
          () => {},
          { enableHighAccuracy: false, timeout: 15000, maximumAge: 300000 },
        );
      } catch {
        /* Ohne Permissions-API: nur auf Knopfdruck. */
      }
    }
    fetch(wurzel.dataset.filialen)
      .then((antwort) => (antwort.ok ? antwort.json() : Promise.reject(new Error(antwort.status))))
      .then(starte, () => setzeStatus(T.ladefehler, true))
      .finally(() => wurzel.setAttribute('data-geladen', ''));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  // „Nach oben“: #top scrollt auch ohne Skript an den Seitenanfang. Mit
  // Skript bleibt der Hash unangetastet (Detailansichten im Erlebnis-Portal
  // hängen an #welt=…/#profil=…), und der Fokus kommt mit nach oben — sonst
  // bliebe er unten auf dem Link und der nächste Tab verließe die Seite.
  // body bekommt kurz tabindex -1 (ohne Ring laut critical.css); der nächste
  // Tab landet beim Sprunglink. scrollTo folgt scroll-behavior aus
  // critical.css, also auch der Einstellung „weniger Bewegung“.
  document.addEventListener('click', (event) => {
    const link = event.target instanceof Element && event.target.closest('[data-nach-oben]');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    window.scrollTo({ top: 0 });
    const body = document.body;
    if (!body.hasAttribute('tabindex')) {
      body.setAttribute('tabindex', '-1');
      body.addEventListener('blur', () => body.removeAttribute('tabindex'), { once: true });
    }
    body.focus({ preventScroll: true });
  });

  // Newsletter: Nach dem Absenden lädt die Seite mit #fuss-newsletter neu.
  // Der Sprung zum Anker setzt den Fokus kurz nach DOMContentLoaded zurück
  // (das Formular selbst ist nicht fokussierbar, der Browser fällt auf die
  // Seite zurück) — autofocus und ein früher focus() gingen dabei verloren.
  // Dank bzw. das fehlerhafte Feld bekommen den Fokus deshalb erst nach dem
  // Laden, damit Screenreader sie vorlesen; hat jemand bis dahin schon
  // woanders hin getabbt oder geklickt, bleibt der Fokus dort.
  if (location.hash === '#fuss-newsletter') {
    const fokussiere = () => {
      const aktiv = document.activeElement;
      if (aktiv && aktiv !== document.body) return;
      document.querySelector('#fuss-newsletter [autofocus]')?.focus({ preventScroll: true });
    };
    if (document.readyState === 'complete') fokussiere();
    else window.addEventListener('load', fokussiere, { once: true });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    if (!document.querySelector('[data-header]')) return;

    /* 1. Mega-Menü: eins offen, Hover-Absicht, Esc, Klick daneben. ------- */
    const ABSICHT = 120; // ms Zögern, bevor ein Panel per Maus auf- oder umschaltet
    const mitMaus = matchMedia('(hover: hover) and (pointer: fine)');
    const schmal = matchMedia('(max-width: 70rem)');
    const MENUE = '.desktop-mega';
    let oeffnenUhr;
    let schliessenUhr;

    const kopf = () => document.querySelector('[data-header]');
    const offene = () => document.querySelectorAll(`${MENUE}[open]`);
    const vermessen = () => {
      const k = kopf();
      if (k) k.style.setProperty('--menu-top', `${k.getBoundingClientRect().bottom}px`);
    };
    const alleZu = (ausser) =>
      offene().forEach((m) => {
        if (m !== ausser) m.open = false;
      });

    document.addEventListener(
      'toggle',
      (e) => {
        const m = e.target;
        if (!(m instanceof HTMLDetailsElement) || !m.matches(MENUE)) return;
        if (m.open) {
          vermessen();
          alleZu(m);
        } else {
          delete m.dataset.perHover;
        }
      },
      true,
    );

    document.addEventListener('pointerover', (e) => {
      if (e.pointerType !== 'mouse' || !mitMaus.matches) return;
      if (e.target.closest?.('.desktop-kopf__nav')) clearTimeout(schliessenUhr);
      const summary = e.target.closest?.(`${MENUE} > summary`);
      if (!summary) return;
      const m = summary.parentElement;
      clearTimeout(oeffnenUhr);
      if (m.open) return;
      oeffnenUhr = setTimeout(() => {
        vermessen();
        m.dataset.perHover = '';
        m.open = true;
      }, ABSICHT);
    });

    document.addEventListener('pointerout', (e) => {
      if (e.pointerType !== 'mouse') return;
      const summary = e.target.closest?.(`${MENUE} > summary`);
      if (summary && !summary.contains(e.relatedTarget)) clearTimeout(oeffnenUhr);
      const nav = e.target.closest?.('.desktop-kopf__nav');
      if (!nav || nav.contains(e.relatedTarget)) return;
      clearTimeout(schliessenUhr);
      // Wer per Tastatur im Panel steht (:focus-visible), behält es offen.
      schliessenUhr = setTimeout(
        () =>
          offene().forEach((m) => {
            if (!m.querySelector(':focus-visible')) m.open = false;
          }),
        ABSICHT * 2,
      );
    });

    document.addEventListener('click', (e) => {
      const summary = e.target.closest?.(`${MENUE} > summary`);
      if (summary) {
        clearTimeout(oeffnenUhr);
        const m = summary.parentElement;
        vermessen();
        // Per Maus schon aufgegangen: der Klick darf es nicht gleich wieder schließen.
        if (e.detail > 0 && m.open && 'perHover' in m.dataset) {
          e.preventDefault();
          delete m.dataset.perHover;
        }
        return;
      }
      if (!e.target.closest?.(MENUE)) alleZu();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      offene().forEach((m) => {
        const drin = m.contains(document.activeElement);
        m.open = false;
        if (drin) m.querySelector('summary')?.focus();
      });
    });

    // Tab aus dem Panel heraus schließt es (Klicks daneben regelt 'click').
    document.addEventListener('focusout', (e) => {
      const m = e.target.closest?.(MENUE);
      if (m?.open && e.relatedTarget && !m.contains(e.relatedTarget)) m.open = false;
    });

    const nachfuehren = () => {
      if (document.querySelector(`${MENUE}[open]`)) vermessen();
    };
    window.addEventListener('resize', nachfuehren, { passive: true });
    window.addEventListener('scroll', nachfuehren, { passive: true });
    schmal.addEventListener('change', () => alleZu());
    // Zurück aus dem bfcache: ein vor dem Klick per Hover geöffnetes Panel ist zu.
    window.addEventListener('pageshow', (e) => {
      if (e.persisted) alleZu();
    });

    /* 2. Warenkorb-Zahl im Namen des Knopfs (die Zahl selbst setzt
          assets/hervis.js über [data-warenkorb-anzahl]). ------------------ */
    const warenkorbName = () => {
      document.querySelectorAll('[data-warenkorb-knopf]').forEach((knopf) => {
        const zahl = knopf.querySelector('[data-warenkorb-anzahl]');
        const anzahl = parseInt(zahl?.textContent, 10) || 0;
        knopf.setAttribute('aria-label', knopf.dataset.labelVorlage.replace('%n', anzahl));
      });
    };
    const zahlBeobachter = new MutationObserver(warenkorbName);
    const zahlBeobachten = () =>
      document
        .querySelectorAll('[data-warenkorb-knopf] [data-warenkorb-anzahl]')
        .forEach((zahl) => zahlBeobachter.observe(zahl, { childList: true, characterData: true, subtree: true }));
    zahlBeobachten();

    /* 3. Merkliste — gespeichert auf diesem Gerät. -------------------------
          „hervis-shop-merkliste" = Handles (neueste zuletzt),
          „hervis-shop-merkliste-inhalte" = { handle: { title, image, url,
          vendor, preis } }. Herz-Knöpfe: [data-merken="<handle>"] mit
          data-title/-url/-image/-vendor/-preis; data-merken-modus="hinzu"
          nimmt nur auf, nie heraus. Nach jeder Änderung: hervis:merkliste.
          Angemeldet legt snippets/merkliste-abgleich.liquid zusätzlich die
          Listen der App ab („hervis-shop-listen" = [{ id, name, emoji,
          handles }]): Dann gilt die Merkliste als „Alle", und Chips filtern
          nach Liste. Entfernen in einer Liste nimmt nur dort heraus und merkt
          es sich für den Abgleich („hervis-shop-listen-aenderungen"); das
          Herz entfernt überall — wie in der App (heartRemove). */
    const SCHLUESSEL = 'hervis-shop-merkliste';
    const INHALTE = 'hervis-shop-merkliste-inhalte';
    const LISTEN = 'hervis-shop-listen';
    const AENDERUNGEN = 'hervis-shop-listen-aenderungen';
    const lesen = (schluessel, ersatz) => {
      try {
        const wert = JSON.parse(localStorage.getItem(schluessel));
        return wert ?? ersatz;
      } catch {
        return ersatz;
      }
    };
    const schreiben = (schluessel, wert) => {
      try {
        localStorage.setItem(schluessel, JSON.stringify(wert));
      } catch {}
    };
    const handles = () => {
      const liste = lesen(SCHLUESSEL, []);
      return Array.isArray(liste) ? liste.filter((h) => typeof h === 'string') : [];
    };
    const inhalte = () => {
      const wert = lesen(INHALTE, {});
      return wert && typeof wert === 'object' && !Array.isArray(wert) ? wert : {};
    };
    const listen = () => {
      const wert = lesen(LISTEN, []);
      return Array.isArray(wert) ? wert.filter((l) => l && typeof l.id === 'string' && Array.isArray(l.handles)) : [];
    };
    let gewaehlt = 'alle';
    const text = (wert) => (typeof wert === 'string' ? wert.trim() : '');
    // Nur Pfade dieses Shops, nur Bilder über http(s).
    const pfad = (url) => (typeof url === 'string' && url.startsWith('/') && !url.startsWith('//') ? url : '');
    const bild = (src) => {
      // Leer würde sonst zur Seiten-URL aufgelöst — ein kaputtes <img>.
      if (!text(src)) return '';
      try {
        const url = new URL(text(src), location.href);
        return url.protocol === 'https:' || url.protocol === 'http:' ? url.href : '';
      } catch {
        return '';
      }
    };
    // Was der Dialog zeigt: neueste zuerst, nur Einträge mit Inhalt.
    const eintraege = () => {
      const daten = inhalte();
      return handles()
        .reverse()
        .filter((h) => daten[h] && pfad(daten[h].url) && text(daten[h].title))
        .map((h) => ({ handle: h, ...daten[h] }));
    };

    function herzenAbgleichen() {
      const gemerkt = new Set(handles());
      document.querySelectorAll('[data-merken]').forEach((knopf) => {
        const h = knopf.dataset.merken || knopf.dataset.handle;
        knopf.setAttribute('aria-pressed', String(gemerkt.has(h)));
      });
    }

    function zaehlerAbgleichen(anzahl) {
      document.querySelectorAll('[data-merkliste-anzahl]').forEach((zahl) => {
        zahl.textContent = anzahl;
        zahl.hidden = anzahl === 0;
      });
      document.querySelectorAll('[data-merkliste-knopf]').forEach((knopf) => {
        knopf.setAttribute(
          'aria-label',
          anzahl ? knopf.dataset.labelVorlage.replace('%n', anzahl) : knopf.dataset.labelLeer,
        );
      });
      document.querySelectorAll('[data-merkliste-gesamt]').forEach((wert) => {
        wert.textContent = anzahl ? wert.dataset.vorlage.replace('%n', anzahl) : '';
        wert.hidden = anzahl === 0;
      });
    }

    /* Chips „Alle" + je Liste der App, mit Anzahl. Erst ab zwei Listen —
       mit nur „Favoriten" wäre „Alle" dasselbe noch einmal. */
    function listenZeichnen(alle) {
      const ort = document.querySelector('[data-merkliste-listen]');
      const alleListen = listen();
      if (!alleListen.some((l) => l.id === gewaehlt)) gewaehlt = 'alle';
      if (!ort) return alleListen;
      ort.hidden = alleListen.length < 2;
      if (ort.hidden) {
        gewaehlt = 'alle';
        ort.replaceChildren();
        return alleListen;
      }
      const da = new Set(alle.map((e) => e.handle));
      const chip = (id, beschriftung, anzahl) => {
        const knopf = document.createElement('button');
        knopf.type = 'button';
        knopf.className = 'chip';
        knopf.dataset.merklisteListe = id;
        knopf.setAttribute('aria-pressed', String(id === gewaehlt));
        const zahl = document.createElement('span');
        zahl.className = 'merkliste-blatt__listen-zahl';
        zahl.textContent = anzahl;
        knopf.append(beschriftung, ' ', zahl);
        return knopf;
      };
      ort.replaceChildren(
        chip('alle', ort.dataset.alle, alle.length),
        ...alleListen.map((l) =>
          chip(
            l.id,
            [text(l.emoji), text(l.name)].filter(Boolean).join(' '),
            l.handles.filter((h) => da.has(h)).length,
          ),
        ),
      );
      return alleListen;
    }

    function listeZeichnen() {
      const liste = document.querySelector('[data-wishlist-items]');
      const vorlage = document.querySelector('[data-merkliste-vorlage]');
      const leer = document.querySelector('[data-wishlist-empty]');
      const listeLeer = document.querySelector('[data-merkliste-liste-leer]');
      const alle = eintraege();
      zaehlerAbgleichen(alle.length);
      if (!liste || !vorlage) return;
      // Eine Liste gewählt: ihre Artikel in ihrer Reihenfolge (die der App).
      const alleListen = listenZeichnen(alle);
      let sichtbar = alle;
      if (gewaehlt !== 'alle') {
        const nachHandle = new Map(alle.map((e) => [e.handle, e]));
        const auswahl = alleListen.find((l) => l.id === gewaehlt);
        sichtbar = auswahl ? auswahl.handles.map((h) => nachHandle.get(h)).filter(Boolean) : alle;
      }
      if (listeLeer) listeLeer.hidden = !(alle.length && !sichtbar.length);
      const zeilen = sichtbar.map((eintrag) => {
        const zeile = vorlage.content.firstElementChild.cloneNode(true);
        const titel = text(eintrag.title);
        const url = pfad(eintrag.url);
        const bildLink = zeile.querySelector('.merkliste-zeile__bild');
        bildLink.href = url;
        const quelle = bild(eintrag.image);
        if (quelle) {
          const img = document.createElement('img');
          img.src = quelle;
          img.alt = '';
          img.loading = 'lazy';
          bildLink.append(img);
        }
        zeile.querySelector('.merkliste-zeile__marke').textContent = text(eintrag.vendor);
        const titelLink = zeile.querySelector('.merkliste-zeile__titel');
        titelLink.href = url;
        titelLink.textContent = titel;
        zeile.querySelector('.merkliste-zeile__preis').textContent = text(eintrag.preis);
        const weg = zeile.querySelector('.merkliste-zeile__weg');
        weg.dataset.wishlistRemove = eintrag.handle;
        weg.setAttribute('aria-label', liste.dataset.entfernen.replace('%t', titel));
        return zeile;
      });
      liste.replaceChildren(...zeilen);
      if (leer) leer.hidden = alle.length > 0;
    }

    const allesAbgleichen = () => {
      herzenAbgleichen();
      listeZeichnen();
    };
    const gemeldet = () => {
      allesAbgleichen();
      document.dispatchEvent(new CustomEvent('hervis:merkliste'));
    };

    document.addEventListener('click', (e) => {
      const herz = e.target.closest?.('[data-merken]');
      if (herz) {
        const h = herz.dataset.merken || herz.dataset.handle;
        if (!h) return;
        const liste = handles();
        const daten = inhalte();
        const drin = liste.includes(h);
        if (drin && herz.dataset.merkenModus !== 'hinzu') {
          schreiben(
            SCHLUESSEL,
            liste.filter((x) => x !== h),
          );
          delete daten[h];
        } else {
          if (!drin) liste.push(h);
          schreiben(SCHLUESSEL, liste);
          daten[h] = {
            title: text(herz.dataset.title),
            image: text(herz.dataset.image),
            url: pfad(herz.dataset.url),
            vendor: text(herz.dataset.vendor),
            preis: text(herz.dataset.preis),
          };
        }
        schreiben(INHALTE, daten);
        gemeldet();
        return;
      }

      const listenChip = e.target.closest?.('[data-merkliste-liste]');
      if (listenChip) {
        gewaehlt = listenChip.dataset.merklisteListe;
        listeZeichnen();
        // Die Chips sind neu gezeichnet — der Fokus bleibt auf dem gewählten.
        document.querySelector(`[data-merkliste-liste="${CSS.escape(gewaehlt)}"]`)?.focus();
        return;
      }

      const weg = e.target.closest?.('[data-wishlist-remove]');
      if (weg) {
        const h = weg.dataset.wishlistRemove;
        const knoepfe = [...document.querySelectorAll('[data-wishlist-remove]')];
        const stelle = knoepfe.indexOf(weg);
        const fokusNachher = () => {
          const rest = [...document.querySelectorAll('[data-wishlist-remove]')];
          const ziel = rest[Math.min(stelle, rest.length - 1)] || document.querySelector('[data-wishlist-empty] a');
          ziel?.focus();
        };
        // In einer Liste: nur aus dieser. Steht der Artikel noch in einer
        // anderen, bleibt er gemerkt (Herz gefüllt, wie in der App).
        if (gewaehlt !== 'alle') {
          const alleListen = listen();
          schreiben(
            LISTEN,
            alleListen.map((l) => (l.id === gewaehlt ? { ...l, handles: l.handles.filter((x) => x !== h) } : l)),
          );
          const offen = lesen(AENDERUNGEN, []);
          schreiben(AENDERUNGEN, [...(Array.isArray(offen) ? offen : []), { liste: gewaehlt, handle: h }]);
          if (alleListen.some((l) => l.id !== gewaehlt && l.handles.includes(h))) {
            gemeldet();
            fokusNachher();
            return;
          }
        }
        schreiben(
          SCHLUESSEL,
          handles().filter((x) => x !== h),
        );
        const daten = inhalte();
        delete daten[h];
        schreiben(INHALTE, daten);
        gemeldet();
        // Fokus bleibt in der Liste: nächste Zeile, sonst die vorige, sonst der Leer-Knopf.
        fokusNachher();
        return;
      }

      if (e.target.closest?.('[data-oeffnet="merkliste"]')) listeZeichnen();
    });

    document.addEventListener('hervis:inhalt', herzenAbgleichen);
    document.addEventListener('hervis:merkliste', allesAbgleichen);
    window.addEventListener('storage', (e) => {
      if (e.key === SCHLUESSEL || e.key === INHALTE || e.key === LISTEN) allesAbgleichen();
    });
    window.addEventListener('pageshow', (e) => {
      if (e.persisted) allesAbgleichen();
    });
    document.addEventListener('shopify:section:load', () => {
      allesAbgleichen();
      zahlBeobachten();
      warenkorbName();
    });
    allesAbgleichen();

    /* 9. Kopf rollt beim Runterscrollen weg, beim Hochscrollen kommt er zurück.
       Nie weg, solange ein Menü oder Dialog offen ist oder der Fokus im Kopf
       steht (Suche, Tastatur). CSS dazu oben bei „Klebender Block". -------- */
    {
      const wurzel = document.documentElement;
      const SCHWELLE = 8; // px Scrollweg, ab dem die Richtung zählt
      let letzteY = window.scrollY;
      let geplant = false;
      const block = () => kopf()?.closest('.shopify-section');
      const zeigen = () => {
        if (wurzel.dataset.kopf) delete wurzel.dataset.kopf;
      };
      const pruefen = () => {
        geplant = false;
        const y = window.scrollY;
        const b = block();
        const weg = y - letzteY;
        if (Math.abs(weg) < SCHWELLE) return;
        letzteY = y;
        if (!b || weg < 0 || y <= b.offsetHeight) return zeigen();
        if (offene().length || b.contains(document.activeElement) || document.querySelector('dialog[open]')) {
          return zeigen();
        }
        wurzel.dataset.kopf = 'weg';
      };
      window.addEventListener(
        'scroll',
        () => {
          if (geplant) return;
          geplant = true;
          requestAnimationFrame(pruefen);
        },
        { passive: true },
      );
      document.addEventListener('focusin', (e) => {
        if (block()?.contains(e.target)) zeigen();
      });
    }

    /* 10. Handy-Kopfzeile (Runde 4). Zurück: kam man von dieser Seite des
       Shops, wie die App einen Schritt zurück (history.back), sonst — und
       ohne JS — der Link zur Elternseite. Lupe (Startseite): blendet die
       Pille ein und setzt den Cursor hinein; der Fokus öffnet die Suche. -- */
    document.addEventListener('click', (e) => {
      const zurueck = e.target.closest?.('[data-zurueck]');
      if (zurueck) {
        if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        let hier = false;
        try {
          hier = !!document.referrer && new URL(document.referrer).origin === location.origin;
        } catch {}
        if (hier && history.length > 1) {
          e.preventDefault();
          history.back();
        }
        return;
      }
      const lupe = e.target.closest?.('[data-kopf-lupe]');
      if (lupe) {
        const k = lupe.closest('[data-header]');
        const feld = k?.querySelector('#kopf-suche');
        if (!k || !feld) return;
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        k.dataset.lupe = '';
        feld.focus();
        delete k.dataset.lupe;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kontakt"] && !Shopify.designMode) return;
  try {
    
  (() => {
    /* Pflichtfelder im Browser prüfen und die Meldungen auf Deutsch zeigen
       (die Texte stehen als data-fehler-* am Feld). Erst beim Absenden, dann
       verschwindet eine Meldung, sobald das Feld stimmt. */
    const form = document.querySelector('.kontakt__formular');
    if (!form) return;
    form.noValidate = true;
    const felder = [...form.querySelectorAll('[data-pruefen]')];
    const icon = form.querySelector('[data-fehler-icon]')?.innerHTML ?? '';

    /* Nach dem Absenden lädt Shopify die Seite mit #contact_form neu. Bei
       einem Sprungziel ignoriert der Browser autofocus, und der Anker landet
       unter der Kopfzeile — darum Dank oder Fehler selbst fokussieren und
       in die Mitte holen. */
    const meldungNachLaden = form.querySelector('.kontakt__danke, :scope > .feld__fehler, [aria-invalid="true"]');
    if (meldungNachLaden) {
      const hinfuehren = () => {
        meldungNachLaden.focus({ preventScroll: true });
        meldungNachLaden.scrollIntoView({ block: 'center' });
      };
      if (document.readyState === 'complete') requestAnimationFrame(hinfuehren);
      else addEventListener('load', () => requestAnimationFrame(hinfuehren), { once: true });
    }

    function meldung(feld) {
      if (feld.required && !feld.value.trim()) return feld.dataset.fehlerLeer;
      if (!feld.validity.valid) return feld.dataset.fehlerUngueltig || feld.dataset.fehlerLeer;
      return '';
    }

    function zeigen(feld, text) {
      const ziel = document.getElementById(`${feld.id}-fehler`);
      if (!ziel) return;
      if (text) {
        ziel.innerHTML = icon;
        ziel.append(text);
        ziel.hidden = false;
        feld.setAttribute('aria-invalid', 'true');
        feld.setAttribute('aria-describedby', ziel.id);
      } else {
        ziel.hidden = true;
        ziel.textContent = '';
        feld.removeAttribute('aria-invalid');
        feld.removeAttribute('aria-describedby');
      }
    }

    /* capture + stopImmediatePropagation: Shopifys hCaptcha hängt eigene
       submit-Listener an Formular und document, die defaultPrevented nicht
       beachten — sie würden das Formular trotz Fehler abschicken (oder die
       Captcha-Abfrage über die Meldungen legen). Ist alles richtig, läuft
       das Ereignis ungestört zu ihnen weiter. */
    form.addEventListener(
      'submit',
      (event) => {
        let erstes = null;
        for (const feld of felder) {
          const text = meldung(feld);
          zeigen(feld, text);
          if (text && !erstes) erstes = feld;
        }
        if (!erstes) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        /* focus() allein scrollt das Feld an die Oberkante — unter die
           klebende Kopfzeile. scrollIntoView beachtet scroll-padding und
           die reduzierte Bewegung (scroll-behavior). */
        erstes.focus({ preventScroll: true });
        (erstes.closest('.feld') ?? erstes).scrollIntoView({ block: 'center' });
      },
      { capture: true },
    );

    for (const feld of felder) {
      feld.addEventListener('input', () => {
        if (feld.getAttribute('aria-invalid') === 'true' && !meldung(feld)) zeigen(feld, '');
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["konto"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // „Mitgliedskarte holen": nur, solange der Pflichtteil des Onboardings
    // fehlt (sections/willkommen.liquid). Ohne Backend bleibt die Zeile weg.
    const zeile = document.querySelector('[data-einrichten]');
    const api = window.hervisApi;
    if (!zeile || !api) return;
    api
      .verfuegbar()
      .then((ok) => (ok ? api.lesen('/api/account/profile360') : null))
      .then((antwort) => {
        if (antwort && !antwort.profile?.onboarding?.requiredDoneAt) zeile.hidden = false;
      })
      .catch(() => {});
  })();

  (() => {
    // Cookie-Einstellungen: Shopifys Banner direkt in den Einstellungen öffnen.
    // Ohne die Banner-API bleibt der Link „#shopifyReshowConsentBanner", auf
    // den Shopifys Skript selbst hört.
    if (!document.querySelector('[data-cookie-einstellungen]')) return;
    document.addEventListener('click', (event) => {
      const link = event.target.closest('[data-cookie-einstellungen]');
      const banner = window.privacyBanner;
      if (!link || !banner || typeof banner.showPreferences !== 'function') return;
      event.preventDefault();
      banner.showPreferences();
    });
  })();

  (() => {
    // Antrag gesendet (Fund #20/#21): Shopify springt per #antrag-… zum
    // Formular; der Sprung zum Ziel nimmt den Fokus von autofocus wieder weg.
    // Darum nach dem Laden noch einmal auf die Bestätigung, damit
    // Screenreader sie vorlesen (sie steht schon im Bild: preventScroll).
    const erfolg = document.querySelector('.konto-antrag__erfolg');
    if (!erfolg) return;
    const fokus = () => requestAnimationFrame(() => erfolg.focus({ preventScroll: true }));
    if (document.readyState === 'complete') fokus();
    else window.addEventListener('load', fokus, { once: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["laufband"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const instances = new Map();
    function init(root) {
      root.querySelectorAll('[data-laufband]').forEach((el) => {
        if (instances.has(el)) return;
        const track = el.querySelector('.laufband__spur');
        const segment = track.firstElementChild;
        const original = el.querySelector('[data-laufband-original]');
        const viewport = el.querySelector('.laufband__fenster');
        const media = matchMedia('(prefers-reduced-motion: reduce)');
        let lastCount = 0;
        function copy(node) {
          const clone = node.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.inert = true;
          clone.dataset.laufbandKopie = '';
          [clone, ...clone.querySelectorAll('*')].forEach((n) => {
            n.removeAttribute('data-laufband-original');
            n.removeAttribute('data-shopify-editor-block');
          });
          return clone;
        }
        function measure() {
          if (!el.isConnected || media.matches || el.dataset.still === 'true') return;
          const width = original.getBoundingClientRect().width;
          if (!width) return;
          const count = Math.max(1, Math.ceil(viewport.clientWidth / width));
          if (lastCount === count) return;
          lastCount = count;
          segment.replaceChildren(original);
          for (let i = 1; i < count; i++) segment.append(copy(original));
          track.replaceChildren(segment, copy(segment));
          el.style.setProperty('--laufband-kopien', count);
          el.dataset.ready = 'true';
        }
        // Eigener Pause-Knopf; die Wahl gilt seitenübergreifend.
        const pause = el.querySelector('[data-laufband-pause]');
        const SCHLUESSEL = 'hervis:laufband-pause';
        const setzePause = (an) => {
          el.dataset.paused = String(an);
          pause.setAttribute('aria-pressed', String(an));
        };
        if (pause && el.dataset.still !== 'true') {
          pause.hidden = false;
          try {
            setzePause(localStorage.getItem(SCHLUESSEL) === '1');
          } catch {}
          pause.addEventListener('click', () => {
            const an = pause.getAttribute('aria-pressed') !== 'true';
            setzePause(an);
            try {
              localStorage.setItem(SCHLUESSEL, an ? '1' : '0');
            } catch {}
          });
        }
        const observer = new ResizeObserver(measure);
        observer.observe(viewport);
        observer.observe(original);
        media.addEventListener('change', measure);
        document.fonts.ready.then(measure);
        measure();
        instances.set(el, () => {
          observer.disconnect();
          media.removeEventListener('change', measure);
        });
      });
    }
    init(document);
    document.addEventListener('shopify:section:load', (e) => init(e.target));
    document.addEventListener('shopify:section:unload', (e) => {
      instances.forEach((cleanup, el) => {
        if (e.target.contains(el)) {
          cleanup();
          instances.delete(el);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marken-index"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const wurzel = document.querySelector('[data-marken-index]');
    if (!wurzel) return;
    const rahmen = wurzel.querySelector('[data-marken-filter]');
    const feld = wurzel.querySelector('[data-marken-feld]');
    const status = wurzel.querySelector('[data-marken-status]');
    const leer = wurzel.querySelector('[data-marken-leer]');
    if (!rahmen || !feld || !status || !leer) return;
    rahmen.hidden = false;

    // Wie die App: Groß/klein und Akzente egal, „Löffler" findet „loffler".
    const falten = (text) =>
      text
        .normalize('NFKD')
        .replace(/[̀-ͯ]/g, '')
        .replace(/ß/g, 'ss')
        .replace(/[^a-z0-9]/gi, '')
        .toLowerCase();
    // Treffer wie in der Kopfsuche: der ganze Name oder ein Wort darin beginnt
    // mit dem Begriff („on" findet O´Neill, nicht Champion oder Salomon).
    const zeilen = [...wurzel.querySelectorAll('[data-marke]')].map((link) => {
      const name = link.dataset.marke || '';
      return {
        li: link.closest('li'),
        schluessel: [falten(name), ...name.split(/[\s\-\/&]+/).map(falten)].filter(Boolean),
      };
    });
    const gruppen = [...wurzel.querySelectorAll('[data-marken-gruppe]')];
    const spruenge = new Map(
      [...wurzel.querySelectorAll('[data-marken-sprung]')].map((a) => [a.dataset.markenSprung, a]),
    );
    let warte = 0;

    function filtern() {
      const q = falten(feld.value);
      let treffer = 0;
      for (const z of zeilen) {
        const passt = !q || z.schluessel.some((w) => w.startsWith(q));
        z.li.hidden = !passt;
        if (passt) treffer += 1;
      }
      for (const gruppe of gruppen) {
        const sichtbar = !!gruppe.querySelector('li:not([hidden])');
        gruppe.hidden = !sichtbar;
        const sprung = spruenge.get(gruppe.dataset.markenGruppe);
        if (sprung) {
          if (sichtbar) {
            sprung.removeAttribute('aria-disabled');
            sprung.setAttribute('href', '#' + gruppe.id);
            sprung.removeAttribute('role');
          } else {
            sprung.setAttribute('aria-disabled', 'true');
            sprung.setAttribute('role', 'link');
            sprung.removeAttribute('href');
          }
        }
      }
      wurzel.toggleAttribute('data-filter-aktiv', !!q);
      leer.hidden = treffer > 0;
      clearTimeout(warte);
      // Erst nach einer Tipp-Pause ansagen, nicht bei jedem Buchstaben.
      warte = setTimeout(() => {
        if (!q) status.textContent = '';
        else if (!treffer) status.textContent = status.dataset.keine;
        else if (treffer === 1) status.textContent = status.dataset.eine;
        else status.textContent = status.dataset.mehrere.replace('%n', treffer);
      }, 400);
    }
    feld.addEventListener('input', filtern);
    feld.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && feld.value) {
        e.preventDefault();
        feld.value = '';
        filtern();
      }
    });
    // Zurück-Navigation kann den Feldinhalt wiederherstellen.
    if (feld.value) filtern();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const seite = document.querySelector('[data-produktseite]');
    if (!seite) return;
    const form = seite.querySelector('[data-produkt-form]');
    if (!form) return;

    const d = seite.dataset;
    const format = new Intl.NumberFormat('de-AT', { style: 'currency', currency: d.waehrung || 'EUR' });
    const preis = (cent) => format.format(cent / 100);
    const knoepfe = [...seite.querySelectorAll('[data-kaufen]')];
    const idFeld = form.querySelector('[data-varianten-id]');
    // Mit JavaScript trägt das versteckte Feld die Variante (ohne JS das Select).
    if (idFeld) idFeld.name = 'id';
    const herz = seite.querySelector('.pdp-aktion--herz');
    const fehler = seite.querySelector('[data-kaufen-fehler]');
    const leisteFehler = seite.querySelector('[data-kaufen-fehler-leiste]');
    const schmal = window.matchMedia('(max-width: 48rem)');
    const status = seite.querySelector('[data-kaufen-status]');
    const galerie = seite.querySelector('[data-galerie]');
    let bestpreise = {};
    try {
      bestpreise = JSON.parse(form.querySelector('[data-bestpreise]')?.textContent || '{}');
    } catch {
      bestpreise = {};
    }

    const HALTEZEIT = 2500; // so lange steht „✓ Zum Warenkorb“ und führt dorthin (App: 2,5 s)
    const FEHLERZEIT = 6000; // so lange steht ein Fehler über der Kaufleiste
    // Coming soon / Sperrgut: nie bestellbar, die Knöpfe behalten ihren Zustand.
    const sperre = Boolean(d.kaufSperre);
    let verfuegbar = !sperre && knoepfe.length > 0 && !knoepfe[0].disabled;
    let fertigBis = 0;
    let fertigUhr;
    let fehlerUhr;

    // Fehler stehen nur an EINER Stelle (sonst würden sie doppelt angesagt):
    // am Telefon über der Kaufleiste, sonst unter dem großen Knopf.
    const fehlerLeeren = () => {
      clearTimeout(fehlerUhr);
      [fehler, leisteFehler].forEach((el) => {
        if (el) el.textContent = '';
      });
    };
    const fehlerZeigen = (text) => {
      fehlerLeeren();
      const ziel = schmal.matches && leisteFehler ? leisteFehler : fehler;
      if (!ziel) return;
      ziel.textContent = text;
      fehlerUhr = setTimeout(fehlerLeeren, FEHLERZEIT);
    };

    const knopfText = (text) =>
      knoepfe.forEach((k) => {
        const t = k.querySelector('[data-kaufen-text]');
        if (t) t.textContent = text;
      });

    const knopfZustand = () => {
      if (sperre) return;
      clearTimeout(fertigUhr);
      fertigBis = 0;
      knoepfe.forEach((k) => {
        k.disabled = !verfuegbar;
        k.removeAttribute('data-fertig');
      });
      knopfText(verfuegbar ? d.textKaufen : d.textLeer);
    };

    // Variante gewählt (snippets/produkt-optionen.liquid)
    seite.addEventListener('produkt:variante', (event) => {
      const { variante, farbe, farbe_neu: farbeNeu } = event.detail || {};
      fehlerLeeren();
      verfuegbar = !sperre && Boolean(variante && variante.available);
      if (variante) {
        idFeld.value = variante.id;
        const wert = preis(variante.price);
        seite.querySelector('[data-preis-wert]').textContent = wert;
        const leiste = seite.querySelector('[data-preis-leiste]');
        if (leiste) leiste.textContent = wert;
        // Die Merkliste speichert den Preis der gewählten Variante.
        if (herz) herz.dataset.preis = wert;

        const reduziert = variante.compare_at_price && variante.compare_at_price > variante.price;
        const alt = seite.querySelector('[data-preis-alt]');
        const statt = seite.querySelector('[data-preis-statt]');
        alt.hidden = !reduziert;
        statt.hidden = !reduziert;
        if (reduziert) {
          alt.textContent = preis(variante.compare_at_price);
          statt.textContent = d.textStatt.replace('[preis]', preis(variante.compare_at_price));
        }
        const sale = seite.querySelector('[data-preis-sale]');
        if (sale) sale.hidden = !reduziert;
        const best = seite.querySelector('[data-preis-bestpreis]');
        const tief = reduziert ? bestpreise[variante.id] : null;
        best.hidden = !tief;
        if (tief) best.textContent = d.textBestpreis.replace('[preis]', preis(tief));

        // Artikelnummer und EAN gehören zur Größe (Produktdetails).
        [
          ['[data-artikelnummer]', variante.sku],
          ['[data-ean]', variante.barcode],
        ].forEach(([wahl, wert]) => {
          const feld = seite.querySelector(wahl);
          if (!feld) return;
          feld.textContent = wert || '';
          feld.parentElement.hidden = !wert;
        });

        const url = new URL(window.location.href);
        url.searchParams.set('variant', variante.id);
        window.history.replaceState(window.history.state, '', url);
      }
      knopfZustand();
      if (farbeNeu && galerie) {
        galerie.dispatchEvent(new CustomEvent('galerie:farbe', { detail: { farbe } }));
      }
    });

    // In den Warenkorb, ohne die Seite zu verlassen
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (sperre) return;
      if (Date.now() < fertigBis) {
        window.location.href = d.warenkorb;
        return;
      }
      if (!verfuegbar || form.dataset.laedt) return;
      form.dataset.laedt = 'true';
      knoepfe.forEach((k) => k.setAttribute('aria-busy', 'true'));
      fehlerLeeren();

      const daten = new FormData(form);
      [...daten.keys()].forEach((schluessel) => {
        if (/^option\d+$/.test(schluessel)) daten.delete(schluessel);
      });

      try {
        const antwort = await fetch(d.hinzufuegen, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: daten,
        });
        if (!antwort.ok) {
          // 422: Shopify hat nicht genug Bestand für noch ein Stück.
          fehlerZeigen(antwort.status === 422 ? d.textFehlerBestand : d.textFehler);
          return;
        }

        knoepfe.forEach((k) => k.setAttribute('data-fertig', ''));
        knopfText(d.textFertig);
        if (status) status.textContent = d.textStatus;
        fertigBis = Date.now() + HALTEZEIT;
        clearTimeout(fertigUhr);
        fertigUhr = setTimeout(() => {
          knopfZustand();
          if (status) status.textContent = '';
        }, HALTEZEIT);

        let anzahl;
        try {
          const warenkorb = await fetch(d.warenkorbJs, { headers: { Accept: 'application/json' } });
          if (warenkorb.ok) anzahl = (await warenkorb.json()).item_count;
        } catch {
          /* Zähler fragt hervis.js dann selbst nach. */
        }
        document.dispatchEvent(
          new CustomEvent('hervis:warenkorb', Number.isFinite(anzahl) ? { detail: { item_count: anzahl } } : {}),
        );
      } catch {
        fehlerZeigen(d.textFehler);
      } finally {
        delete form.dataset.laedt;
        knoepfe.forEach((k) => k.removeAttribute('aria-busy'));
      }
    });

    // Teilen: System-Teilen, sonst Link kopieren
    const teilen = seite.querySelector('[data-teilen]');
    const teilenStatus = seite.querySelector('[data-teilen-status]');
    let teilenUhr;
    teilen?.addEventListener('click', async () => {
      const url = window.location.href;
      if (navigator.share) {
        try {
          await navigator.share({ title: teilen.dataset.teilenTitel || document.title, url });
        } catch {
          /* abgebrochen */
        }
        return;
      }
      try {
        await navigator.clipboard.writeText(url);
        teilenStatus.textContent = d.textKopiert;
        clearTimeout(teilenUhr);
        teilenUhr = setTimeout(() => (teilenStatus.textContent = ''), HALTEZEIT);
      } catch {
        /* Zwischenablage gesperrt */
      }
    });

    // „Größentabelle" an den Größen und „Lieferung & Versand" beim Preis:
    // öffnen das Fach weiter unten, rollen hin und setzen den Fokus auf seinen
    // Titel. Ohne JS springt der Anker nur hin.
    seite.addEventListener('click', (event) => {
      const link = event.target.closest('a[data-oeffne-detail]');
      if (!link) return;
      const fach = document.getElementById(link.getAttribute('href').slice(1));
      if (!(fach instanceof HTMLDetailsElement)) return;
      event.preventDefault();
      fach.open = true;
      // Ruhig bei reduzierter Bewegung oder Theme-Bewegungsstärke 0 (Regel 5).
      const staerke = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--motion'));
      const ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches || staerke === 0;
      fach.scrollIntoView({ block: 'start', behavior: ruhig ? 'auto' : 'smooth' });
      fach.querySelector('summary')?.focus({ preventScroll: true });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["produkt-empfehlungen"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const huellen = document.querySelectorAll('[data-empfehlungen][data-url]');
    if (!huellen.length) return;

    const laden = async (huelle) => {
      try {
        const antwort = await fetch(huelle.dataset.url);
        if (!antwort.ok) return;
        const html = await antwort.text();
        const neu = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-empfehlungen]');
        if (!neu || !neu.innerHTML.trim()) return;
        huelle.innerHTML = neu.innerHTML;
        document.dispatchEvent(new CustomEvent('hervis:inhalt'));
      } catch {
        /* Ohne Empfehlungen bleibt die Hülle leer. */
      }
    };

    if (!('IntersectionObserver' in window)) {
      huellen.forEach(laden);
      return;
    }
    const beobachter = new IntersectionObserver(
      (eintraege) => {
        eintraege.forEach((eintrag) => {
          if (!eintrag.isIntersecting) return;
          beobachter.unobserve(eintrag.target);
          laden(eintrag.target);
        });
      },
      { rootMargin: '0px 0px 600px 0px' },
    );
    huellen.forEach((huelle) => beobachter.observe(huelle));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["retoure"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const EMAIL = /^\S+@\S+\.\S+$/;
    // Grund (window.hervisApi.retoure) → Text im Formular.
    const TEXT = {
      nicht_gefunden: 'tNichtGefunden',
      nicht_versendet: 'tNichtVersendet',
      zu_oft: 'tZuOft',
      nicht_verfuegbar: 'tNichtVerfuegbar',
      fehler: 'tFehler',
    };

    document.querySelectorAll('[data-retoure-form]').forEach((form) => {
      const email = form.querySelector('[data-retoure-email]');
      const nummer = form.querySelector('[data-retoure-nummer]');
      const knopf = form.querySelector('[data-retoure-knopf]');
      const meldung = form.querySelector('[data-retoure-meldung-text]');
      const kontakt = form.querySelector('[data-retoure-kontakt]');

      // Mit JavaScript: Formular statt des reinen Kundenservice-Wegs.
      form.hidden = false;
      form.parentElement.querySelector('[data-retoure-ohne-js]')?.setAttribute('hidden', '');

      const fehler = (feld, art, text) => {
        const zeile = form.querySelector(`[data-retoure-fehler="${art}"]`);
        zeile.querySelector('span').textContent = text || '';
        zeile.hidden = !text;
        if (text) feld.setAttribute('aria-invalid', 'true');
        else feld.removeAttribute('aria-invalid');
      };
      const melden = (text, mitKontakt = false) => {
        meldung.textContent = text || '';
        kontakt.hidden = !mitKontakt;
      };

      // Keine Adresse hat ein Leerzeichen (wie /email in der App).
      email.addEventListener('input', () => {
        const ohne = email.value.replace(/\s/g, '');
        if (ohne !== email.value) email.value = ohne;
        fehler(email, 'email', '');
        melden('');
      });
      nummer.addEventListener('input', () => {
        fehler(nummer, 'nummer', '');
        melden('');
      });
      // Erst urteilen, wenn das Feld verlassen wurde — und nur über die Form.
      email.addEventListener('blur', () => {
        const wert = email.value.trim();
        if (wert && !EMAIL.test(wert)) fehler(email, 'email', form.dataset.tEmail);
      });

      form.addEventListener('submit', async (ereignis) => {
        ereignis.preventDefault();
        if (knopf.disabled) return;
        const mail = email.value.trim();
        // „#1101" aus der Bestätigungsmail und „1101" sind dieselbe Bestellung.
        const nr = nummer.value.replace(/\s/g, '').replace(/^#+/, '');

        if (!mail || !EMAIL.test(mail)) {
          fehler(email, 'email', mail ? form.dataset.tEmail : form.dataset.tEmailLeer);
          email.focus();
          return;
        }
        if (!nr) {
          fehler(nummer, 'nummer', form.dataset.tNummer);
          nummer.focus();
          return;
        }

        const api = window.hervisApi;
        if (!api?.retoure) {
          melden(form.dataset.tNichtVerfuegbar, true);
          return;
        }
        knopf.disabled = true;
        form.setAttribute('aria-busy', 'true');
        melden(form.dataset.tLaeuft);
        const ergebnis = await api.retoure({ email: mail, orderNumber: nr });
        if (ergebnis.typ === 'ok') {
          // Im selben Tab: ein vorab geöffnetes Fenster bliebe bei jedem
          // Fehler leer stehen. Zurück geht es mit „Zurück“.
          location.assign(ergebnis.url);
          return;
        }
        knopf.disabled = false;
        form.removeAttribute('aria-busy');
        const schluessel = TEXT[ergebnis.typ] || 'tFehler';
        melden(form.dataset[schluessel], ergebnis.typ === 'nicht_verfuegbar');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["willkommen"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const wurzel = document.querySelector('[data-willkommen]');
    if (!wurzel) return;

    let T = {};
    try {
      T = JSON.parse(wurzel.querySelector('[data-willkommen-texte]').textContent);
    } catch {}
    const t = (k, werte = {}) => (T[k] || '').replace(/%(\w+)%/g, (_, n) => werte[n] ?? '');

    const q = new URLSearchParams(location.search);
    const vorschau = wurzel.dataset.vorschauErlaubt === 'true' && q.get('vorschau') === '1';
    if (wurzel.dataset.angemeldet !== 'true' && !vorschau) return;

    const speicher = {
      lesen(k) {
        try {
          return JSON.parse(sessionStorage.getItem(k));
        } catch {
          return null;
        }
      },
      setzen(k, v) {
        try {
          if (v == null) sessionStorage.removeItem(k);
          else sessionStorage.setItem(k, JSON.stringify(v));
        } catch {}
      },
    };
    const K = {
      weiter: 'hervis:willkommen:weiter',
      umweg: 'hervis:willkommen:umweg',
      // Mit sections/adressen.liquid geteilt: der stille Umweg hat in dieser
      // Sitzung nicht geklappt — dann ohne Customer Account API weiter.
      ohne: 'hervis:konto:ohne-editor',
    };

    /* Wohin danach: nur Pfade dieses Shops (dieselbe Prüfung wie die
       Anmeldeseite), nie wieder hierher (sonst Schleife). Über den stillen
       Umweg reist es in sessionStorage. */
    const sicher = (p) =>
      typeof p === 'string' &&
      p.startsWith('/') &&
      !p.startsWith('//') &&
      !p.includes('\\') &&
      !p.includes('view=willkommen');
    const roh = q.get('weiter') ?? speicher.lesen(K.weiter);
    const weiter = sicher(roh) ? roh : wurzel.dataset.kontoUrl;
    speicher.setzen(K.weiter, weiter);

    const $ = (sel, in_ = wurzel) => in_.querySelector(sel);
    const schrittEl = (name) => $(`[data-schritt="${name}"]`);
    const meldung = $('[data-meldung]');
    const melden = (text) => {
      meldung.textContent = '';
      if (text) requestAnimationFrame(() => (meldung.textContent = text));
    };

    /* ------------------------------------------- Profil 360 (wie die App) */

    const leeresProfil = () => ({
      v: 1,
      shopFor: null,
      country: null,
      deliveryCountry: null,
      worlds: [],
      rejectedWorlds: [],
      heightCm: null,
      weightKg: null,
      shoeSizeEu: null,
      sports: {},
      answered: [],
      skipped: [],
      declined: [],
      rewarded: [],
      onboarding: { version: 0, requiredDoneAt: null, completedAt: null },
      updatedAt: new Date(0).toISOString(),
    });
    const istProfil = (p) => p && typeof p === 'object' && !Array.isArray(p);
    /* Fremde Felder bleiben, fehlende kommen dazu — der Push ist ein Voll-Replace. */
    const normal = (p) => {
      const leer = leeresProfil();
      const r = { ...leer, ...p, onboarding: { ...leer.onboarding, ...(istProfil(p.onboarding) ? p.onboarding : {}) } };
      for (const k of ['answered', 'skipped', 'declined', 'rewarded']) if (!Array.isArray(r[k])) r[k] = [];
      return r;
    };
    const mit = (liste, id) => (liste.includes(id) ? liste : [...liste, id]);
    const ohne = (liste, id) => liste.filter((x) => x !== id);
    const offen = (p, id) => !p.answered.includes(id) && !p.declined.includes(id);
    const beantwortet = (p, id) => ({
      ...p,
      answered: mit(p.answered, id),
      skipped: ohne(p.skipped, id),
      declined: ohne(p.declined, id),
    });
    const uebersprungen = (p, id) => (offen(p, id) ? { ...p, skipped: mit(p.skipped, id) } : p);
    const belohnt = (p, id) => ({ ...p, rewarded: mit(p.rewarded, id) });
    const gestempelt = (p, feld) =>
      p.onboarding[feld] ? p : { ...p, onboarding: { ...p.onboarding, [feld]: new Date().toISOString() } };

    const api = window.hervisApi;
    let profil = leeresProfil();
    let kette = Promise.resolve();
    /* Lesen, ändern, ganz zurückschreiben — eins nach dem anderen. Frisch
       gelesen, damit nichts überschrieben wird, was die App inzwischen
       geschrieben hat. Fehler wirft der einzelne Lauf, die Kette läuft weiter. */
    const aendern = (fn) => {
      const lauf = kette
        .catch(() => {})
        .then(async () => {
          if (vorschau) return (profil = fn(profil));
          const frisch = await api.lesen('/api/account/profile360').catch(() => null);
          const basis = istProfil(frisch?.profile) ? normal(frisch.profile) : profil;
          const neu = { ...fn(basis), updatedAt: new Date().toISOString() };
          const antwort = await api.schreiben('/api/account/profile360', { profile: neu });
          profil = istProfil(antwort?.profile) ? normal(antwort.profile) : neu;
          return profil;
        });
      kette = lauf;
      return lauf;
    };
    const verlassen = async () => {
      await kette.catch(() => {});
      speicher.setzen(K.weiter, null);
      location.replace(weiter);
    };

    /* ------------------------------------- Customer Account API (Name, Adresse) */

    let konto = null;
    const Q = {
      name: 'mutation HervisName($input: CustomerUpdateInput!) { customerUpdate(input: $input) { customer { firstName lastName } userErrors { field message code } } }',
      adresse:
        'mutation HervisAdresseNeu($address: CustomerAddressInput!, $defaultAddress: Boolean) { customerAddressCreate(address: $address, defaultAddress: $defaultAddress) { customerAddress { id } userErrors { field message code } } }',
    };
    const pruefen = (fehler) => {
      if (fehler?.length) throw Object.assign(new Error(fehler[0].message || 'api'), { code: fehler[0].code });
    };

    /* ---------------------------------------------------------------- Plan */

    let name = { vor: wurzel.dataset.vorname || '', nach: wurzel.dataset.nachname || '' };
    let kontoFelder = {};
    let fragtName = false;
    let fragtAnrede = false;
    let plan = [];

    const planen = () => {
      const p = profil;
      fragtName = vorschau || (!name.vor && !!konto);
      fragtAnrede = vorschau || (!kontoFelder.salutation && offen(p, 'salutation'));
      // Ein Firmenkonto sammelt keine Punkte (lib/roles.ts hasLoyalty) — keine Karte.
      const karte = !['brand', 'hervis'].includes(kontoFelder.accountType);
      const adresse = vorschau || (!!konto && Number(wurzel.dataset.adressen || 0) === 0);
      plan = [];
      if ((fragtName || fragtAnrede) && (vorschau || offen(p, 'identity'))) plan.push('identitaet');
      if (vorschau || (!kontoFelder.handle && offen(p, 'handle'))) plan.push('handle');
      if (adresse && (vorschau || offen(p, 'delivery_address'))) plan.push('adresse');
      if (vorschau || offen(p, 'newsletter')) plan.push('newsletter');
      if (karte && (vorschau || offen(p, 'card'))) plan.push('karte');
      if (vorschau || offen(p, 'quiz_offer')) plan.push('angebot');
    };

    /* -------------------------------------------------------------- Ablauf */

    let stelle = -1;
    const fortschritt = $('[data-fortschritt]');

    const zeigen = (schritt) => {
      $('[data-laden]').hidden = true;
      $('[data-kopf]').hidden = false;
      for (const el of wurzel.querySelectorAll('[data-schritt]')) el.hidden = el.dataset.schritt !== schritt;
      const el = schrittEl(schritt);
      el.classList.remove('ist-neu');
      void el.offsetWidth;
      el.classList.add('ist-neu');
      [...fortschritt.children].forEach((li, i) => li.classList.toggle('ist-dran', i <= stelle));
      $('[data-zaehler]', el).textContent = t('fortschritt', { n: stelle + 1, gesamt: plan.length }) + ' ';
      vorbereiten[schritt]?.(el);
      $('[data-titel]', el).focus({ preventScroll: true });
      window.scrollTo({ top: 0 });
    };
    const weiterSchritt = () => {
      stelle += 1;
      if (stelle < plan.length) return zeigen(plan[stelle]);
      aendern((p) => gestempelt(p, 'requiredDoneAt')).catch(() => {});
      verlassen();
    };

    const fehlerZeigen = (el, text, feld) => {
      $('[data-fehler]', el).textContent = text || '';
      for (const f of el.querySelectorAll('[aria-invalid]')) f.removeAttribute('aria-invalid');
      if (feld) {
        feld.setAttribute('aria-invalid', 'true');
        feld.focus();
      }
    };
    const beschaeftigt = (el, an) => {
      if (an) el.setAttribute('aria-busy', 'true');
      else el.removeAttribute('aria-busy');
    };

    const vorbereiten = {};

    /* 1 · Anrede + Name ---------------------------------------------------- */
    const identitaet = schrittEl('identitaet');
    const NAME_MAX = 50;
    // Anrede → Zielgruppe der Suche, wie SHOP_FOR_BY_SALUTATION der App.
    const ZIELGRUPPE = { frau: 'Damen', herr: 'Herren', divers: null, keine: null };
    const identitaetGueltig = () => {
      const f = identitaet.elements;
      const anrede = !fragtAnrede || !!identitaet.querySelector('input[name="salutation"]:checked');
      const vor = f.firstName.value.trim();
      const nach = f.lastName.value.trim();
      return anrede && (!fragtName || (vor && nach && vor.length <= NAME_MAX && nach.length <= NAME_MAX));
    };
    vorbereiten.identitaet = () => {
      $('[data-titel-text]', identitaet).textContent = fragtName ? t('titel_name') : t('titel_anrede');
      $('[data-anrede]', identitaet).hidden = !fragtAnrede;
      $('[data-namensfelder]', identitaet).hidden = !fragtName;
      $('[data-nur-weiter]', identitaet).hidden = fragtName;
      identitaet.elements.firstName.value ||= name.vor;
      identitaet.elements.lastName.value ||= name.nach;
      identitaet.classList.toggle('ist-gueltig', identitaetGueltig());
    };
    identitaet.addEventListener('input', () => {
      identitaet.classList.toggle('ist-gueltig', identitaetGueltig());
      if ($('[data-fehler]', identitaet).textContent) fehlerZeigen(identitaet, '');
    });
    // Die Wahl kommt zuerst, dann der Cursor in den Vornamen (identity-step.tsx).
    identitaet.addEventListener('change', (e) => {
      if (e.target.name === 'salutation' && fragtName && !identitaet.elements.firstName.value) {
        identitaet.elements.firstName.focus();
      }
    });
    identitaet.elements.firstName.addEventListener('keydown', (e) => {
      if (e.key !== 'Enter') return;
      e.preventDefault();
      identitaet.elements.lastName.focus();
    });
    identitaet.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (identitaet.getAttribute('aria-busy') === 'true') return;
      const f = identitaet.elements;
      const wahl = identitaet.querySelector('input[name="salutation"]:checked')?.value ?? null;
      const vor = f.firstName.value.trim();
      const nach = f.lastName.value.trim();
      if (fragtAnrede && !wahl)
        return fehlerZeigen(identitaet, t('fehler_anrede'), identitaet.querySelector('input[name="salutation"]'));
      if (fragtName) {
        if (!vor) return fehlerZeigen(identitaet, t('fehler_name'), f.firstName);
        if (!nach) return fehlerZeigen(identitaet, t('fehler_name'), f.lastName);
        if (vor.length > NAME_MAX) return fehlerZeigen(identitaet, t('fehler_name_lang'), f.firstName);
        if (nach.length > NAME_MAX) return fehlerZeigen(identitaet, t('fehler_name_lang'), f.lastName);
      }
      fehlerZeigen(identitaet, '');
      beschaeftigt(identitaet, true);
      try {
        // Der Name blockiert (ohne ihn legt BSI kein Mitglied an) …
        if (fragtName) {
          if (!vorschau) {
            const d = await konto.gql(Q.name, { input: { firstName: vor, lastName: nach } });
            pruefen(d.customerUpdate.userErrors);
          }
          name = { vor, nach };
        }
      } catch (fehler) {
        beschaeftigt(identitaet, false);
        return fehlerZeigen(identitaet, fehler?.sitzung ? t('fehler_sitzung') : t('fehler_speichern'));
      }
      // … die Anrede nie: sie lässt sich unter „Meine Daten" nachtragen.
      let anrede = false;
      if (fragtAnrede && wahl === 'keine') anrede = true;
      else if (fragtAnrede && wahl) {
        try {
          if (!vorschau) await api.schreiben('/api/account/profile', { salutation: wahl });
          anrede = true;
        } catch {
          melden(t('anrede_fehler'));
        }
      }
      await aendern((p) => {
        let r = p;
        if (anrede) r = { ...beantwortet(r, 'salutation'), shopFor: ZIELGRUPPE[wahl] ?? null };
        if (name.vor) r = beantwortet(beantwortet(r, 'name'), 'identity');
        return r;
      }).catch(() => {});
      beschaeftigt(identitaet, false);
      weiterSchritt();
    });

    /* 2 · Benutzername ------------------------------------------------------ */
    // Regel und Vorschlag wie lib/profile-api.ts und lib/handle-suggest.ts der App.
    const HANDLE_MIN = 3;
    const HANDLE_MAX = 20;
    const HANDLE_RE = /^[a-z0-9._]+$/;
    const RAND = /^[._]+|[._]+$/g;
    const handleNormal = (roh) => roh.trim().replace(/^@+/, '').toLowerCase();
    const handleProblem = (h) => {
      if (!h) return null;
      if (h.length < HANDLE_MIN) return t('handle_kurz', { n: HANDLE_MIN });
      if (h.length > HANDLE_MAX) return t('handle_lang', { n: HANDLE_MAX });
      if (!HANDLE_RE.test(h)) return t('handle_zeichen');
      if (/^[._]|[._]$/.test(h)) return t('handle_rand');
      return null;
    };
    const handleGueltig = (h) => h.length > 0 && !handleProblem(h);
    const teil = (roh) =>
      roh
        .normalize('NFC')
        .toLowerCase()
        .replace(/ä/g, 'ae')
        .replace(/ö/g, 'oe')
        .replace(/ü/g, 'ue')
        .replace(/ß/g, 'ss')
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .replace(/ø/g, 'o')
        .replace(/æ/g, 'ae')
        .replace(/œ/g, 'oe')
        .replace(/ł/g, 'l')
        .replace(/[đð]/g, 'd')
        .replace(/þ/g, 'th')
        .replace(/[\s\-‐‑–—'’`´]+/g, '.')
        .replace(/[^a-z0-9._]/g, '')
        .replace(/([._])[._]+/g, '$1')
        .replace(RAND, '');
    const kuerzen = (h, n) => h.slice(0, Math.max(0, n)).replace(RAND, '');
    const verbinden = (a, b, sep) => (a && b ? `${a}${sep}${b}` : a || b);
    const bauen = (f, l, sep) => {
      const voll = verbinden(f, l, sep);
      if (voll.length <= HANDLE_MAX) return voll;
      const kurz = f && l ? verbinden(f.slice(0, 1), l, sep) : voll;
      return kurz.length <= HANDLE_MAX ? kurz : kuerzen(voll, HANDLE_MAX);
    };
    const handleVorschlaege = (vor, nach, max = 6) => {
      const aus = [];
      const dazu = (h) => {
        if (aus.length < max && handleGueltig(h) && !aus.includes(h)) aus.push(h);
      };
      const f = teil(vor);
      const l = teil(nach);
      const basis = handleGueltig(bauen(f, l, '.')) ? bauen(f, l, '.') : 'sportler';
      dazu(basis);
      if (f && l) {
        dazu(bauen(f, l, '_'));
        dazu(kuerzen(verbinden(f.slice(0, 1), l, '.'), HANDLE_MAX));
      }
      for (let n = 2; aus.length < max && n < 1000; n++) dazu(kuerzen(basis, HANDLE_MAX - String(n).length) + n);
      return aus;
    };
    /* 'available' | 'taken' | 'unknown' — ohne Antwort entscheidet das Speichern. */
    const handlePruefen = async (h) => {
      if (vorschau) return 'available';
      try {
        const d = await api.lesen('/api/account/handle', { handle: h });
        return d?.available === true ? 'available' : d?.available === false ? 'taken' : 'unknown';
      } catch {
        return 'unknown';
      }
    };

    const handle = schrittEl('handle');
    const handleFeld = handle.elements.handle;
    const status = $('[data-status]', handle);
    const vorschlagsLeiste = $('[data-vorschlaege]', handle);
    let handleStand = 'idle';
    let handleGeprueft = null;
    let pruefTimer = 0;

    const handleZeigen = () => {
      const h = handleNormal(handleFeld.value);
      const problem = handleProblem(h);
      let text = t('handle_regel');
      let ton = '';
      if (problem) [text, ton] = [problem, 'warn'];
      else if (h && handleStand === 'checking') text = t('handle_pruefen');
      else if (h && handleStand === 'available') [text, ton] = [t('handle_frei'), 'ok'];
      else if (h && handleStand === 'taken') [text, ton] = [t('handle_vergeben'), 'warn'];
      $('[data-status-text]', status).textContent = text;
      status.dataset.ton = ton;
      if (problem || handleStand === 'taken') handleFeld.setAttribute('aria-invalid', 'true');
      else handleFeld.removeAttribute('aria-invalid');
      handle.classList.toggle('ist-gueltig', handleGueltig(h) && handleStand !== 'taken' && handleStand !== 'checking');

      // Bei „vergeben" bis zu drei freie Alternativen aus dem Namen — nie
      // ersetzt der Schritt eine eigene Eingabe ungefragt.
      const alternativen =
        handleStand === 'taken'
          ? handleVorschlaege(name.vor, name.nach, 6)
              .filter((a) => a !== h)
              .slice(0, 3)
          : [];
      vorschlagsLeiste.replaceChildren(
        ...alternativen.map((a) => {
          const knopf = document.createElement('button');
          knopf.type = 'button';
          knopf.className = 'willkommen__wahl';
          knopf.dataset.vorschlag = a;
          knopf.textContent = `@${a}`;
          return knopf;
        }),
      );
      vorschlagsLeiste.hidden = alternativen.length === 0;
    };
    const handleAnstossen = () => {
      clearTimeout(pruefTimer);
      const h = handleNormal(handleFeld.value);
      if (!handleGueltig(h)) {
        handleStand = 'idle';
        return handleZeigen();
      }
      if (handleGeprueft === h) return handleZeigen();
      handleStand = 'checking';
      handleZeigen();
      pruefTimer = setTimeout(async () => {
        const ergebnis = await handlePruefen(h);
        if (handleNormal(handleFeld.value) !== h) return;
        handleGeprueft = h;
        handleStand = ergebnis === 'unknown' ? 'idle' : ergebnis;
        handleZeigen();
      }, 450);
    };

    vorbereiten.handle = () => {
      const initialen = [name.vor, name.nach]
        .map((n) => n.trim().charAt(0))
        .join('')
        .toUpperCase();
      $('[data-initialen]', handle).textContent = initialen || '@';
      if (handleFeld.value) return handleAnstossen();
      // Der Vorschlag: erster freier Kandidat; ohne Antwort der erste ungeprüft.
      handleZeigen();
      (async () => {
        const kandidaten = handleVorschlaege(name.vor, name.nach);
        for (const k of kandidaten) {
          const ergebnis = await handlePruefen(k);
          if (handleFeld.value) return;
          if (ergebnis === 'taken') continue;
          handleFeld.value = k;
          handleGeprueft = ergebnis === 'available' ? k : null;
          handleStand = ergebnis === 'available' ? 'available' : 'idle';
          return handleZeigen();
        }
      })();
    };
    handleFeld.addEventListener('input', () => {
      // Kleinschreibung und ohne „@", wie die App — die Schreibmarke bleibt stehen.
      const pos = handleFeld.selectionStart;
      const sauber = handleFeld.value.toLowerCase().replace(/^@+/, '');
      if (sauber !== handleFeld.value) {
        const weg = handleFeld.value.length - sauber.length;
        handleFeld.value = sauber;
        handleFeld.setSelectionRange(Math.max(0, pos - weg), Math.max(0, pos - weg));
      }
      fehlerZeigen(handle, '');
      handleAnstossen();
    });
    vorschlagsLeiste.addEventListener('click', (e) => {
      const knopf = e.target.closest('[data-vorschlag]');
      if (!knopf) return;
      handleFeld.value = knopf.dataset.vorschlag;
      handleFeld.focus();
      handleAnstossen();
    });
    handle.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (handle.getAttribute('aria-busy') === 'true') return;
      const h = handleNormal(handleFeld.value);
      if (!handleGueltig(h) || handleStand === 'taken' || handleStand === 'checking') {
        handleZeigen();
        return handleFeld.focus();
      }
      beschaeftigt(handle, true);
      try {
        if (!vorschau) await api.schreiben('/api/account/profile', { handle: h });
      } catch (fehler) {
        beschaeftigt(handle, false);
        if (fehler?.status === 409 || fehler?.code === 'handle_taken') {
          handleGeprueft = h;
          handleStand = 'taken';
          handleZeigen();
          return handleFeld.focus();
        }
        if (fehler?.code === 'invalid_handle') return fehlerZeigen(handle, t('handle_ungueltig'), handleFeld);
        // Netz oder Backend hakt: nicht blockieren, die App fragt nach.
        melden(t('handle_fehler'));
        aendern((p) => uebersprungen(p, 'handle')).catch(() => {});
        return weiterSchritt();
      }
      await aendern((p) => beantwortet(p, 'handle')).catch(() => {});
      beschaeftigt(handle, false);
      weiterSchritt();
    });

    /* 3 · Lieferadresse ---------------------------------------------------- */
    const adresse = schrittEl('adresse');
    adresse.addEventListener('input', () => {
      if ($('[data-fehler]', adresse).textContent) fehlerZeigen(adresse, '');
    });
    adresse.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (adresse.getAttribute('aria-busy') === 'true') return;
      const f = adresse.elements;
      const land = f.territoryCode.value === 'DE' ? 'DE' : 'AT';
      const strasse = f.address1.value.trim();
      const plz = f.zip.value.replace(/\s/g, '');
      const ort = f.city.value.trim();
      if (!strasse) return fehlerZeigen(adresse, t('fehler_strasse'), f.address1);
      if (!plz) return fehlerZeigen(adresse, t('fehler_plz'), f.zip);
      if (land === 'AT' && !/^\d{4}$/.test(plz)) return fehlerZeigen(adresse, t('fehler_plz_at'), f.zip);
      if (land === 'DE' && !/^\d{5}$/.test(plz)) return fehlerZeigen(adresse, t('fehler_plz_de'), f.zip);
      if (!ort) return fehlerZeigen(adresse, t('fehler_ort'), f.city);
      fehlerZeigen(adresse, '');
      beschaeftigt(adresse, true);
      try {
        if (!vorschau) {
          const eingabe = { address1: strasse, zip: plz, city: ort, territoryCode: land };
          if (name.vor) eingabe.firstName = name.vor;
          if (name.nach) eingabe.lastName = name.nach;
          const d = await konto.gql(Q.adresse, { address: eingabe, defaultAddress: true });
          pruefen(d.customerAddressCreate.userErrors);
        }
      } catch (fehler) {
        beschaeftigt(adresse, false);
        return fehlerZeigen(
          adresse,
          fehler?.sitzung ? t('fehler_sitzung') : fehler?.code ? t('fehler_adresse') : t('fehler_speichern'),
        );
      }
      await aendern((p) => ({ ...beantwortet(p, 'delivery_address'), deliveryCountry: land })).catch(() => {});
      beschaeftigt(adresse, false);
      weiterSchritt();
    });
    $('[data-ueberspringen]', adresse).addEventListener('click', () => {
      aendern((p) => uebersprungen(p, 'delivery_address')).catch(() => {});
      weiterSchritt();
    });

    /* 4a · Newsletter ------------------------------------------------------- */
    // Fassung des Einwilligungstexts — dieselbe Kennung wie die App
    // (lib/profile-api.ts NEWSLETTER_TEXT_VERSION) und „Benachrichtigungen".
    const NEWSLETTER_TEXTFASSUNG = 'app-newsletter-2026-09-30';
    const newsletter = schrittEl('newsletter');
    newsletter.addEventListener('click', async (e) => {
      const knopf = e.target.closest('[data-antwort]');
      if (!knopf || newsletter.getAttribute('aria-busy') === 'true') return;
      const an = knopf.dataset.antwort === 'ja';
      beschaeftigt(newsletter, true);
      try {
        // „Nein" ist ein Widerruf, kein Nichtstun: dieselbe Route mit blocked.
        if (!vorschau) {
          await api.schreiben('/api/account/consents', {
            consent: {
              topic: 'newsletter',
              channel: 'email',
              status: an ? 'pending' : 'blocked',
              textVersion: NEWSLETTER_TEXTFASSUNG,
            },
          });
        }
        await aendern((p) => beantwortet(p, 'newsletter')).catch(() => {});
        melden(an ? t('newsletter_bestaetigen') : '');
      } catch {
        // Nicht gespeichert = nicht beantwortet, für beide Antworten.
        melden(an ? t('newsletter_fehler_ja') : t('newsletter_fehler_nein'));
        aendern((p) => uebersprungen(p, 'newsletter')).catch(() => {});
      }
      beschaeftigt(newsletter, false);
      weiterSchritt();
    });

    /* 5 · Mitgliedskarte ---------------------------------------------------- */
    const karte = schrittEl('karte');
    vorbereiten.karte = () => {
      const zeile = $('[data-karte-name]', karte);
      if (zeile) zeile.textContent = [name.vor, name.nach].filter(Boolean).join(' ');
      // Willkommensbonus: einmal je Konto, sobald die Karte aufliegt. Gebucht
      // wird im Backend (UC-14), hier steht nur die Marke im Profil.
      if (!profil.rewarded.includes('welcome')) aendern((p) => belohnt(p, 'welcome')).catch(() => {});
    };
    $('[data-weiter]', karte).addEventListener('click', () => {
      // Hier endet der Pflichtteil (finishCard der App).
      aendern((p) => beantwortet(gestempelt(p, 'requiredDoneAt'), 'card')).catch(() => {});
      weiterSchritt();
    });

    /* 6 · Angebot ------------------------------------------------------------ */
    const angebot = schrittEl('angebot');
    vorbereiten.angebot = () => {
      // Ohne Karte (Firmenkonto) endet der Pflichtteil vor dem Angebot.
      if (!profil.onboarding.requiredDoneAt) aendern((p) => gestempelt(p, 'requiredDoneAt')).catch(() => {});
    };
    const entschieden = () => aendern((p) => beantwortet(gestempelt(p, 'completedAt'), 'quiz_offer')).catch(() => {});
    $('[data-app]', angebot).addEventListener('click', () => {
      entschieden();
      document.dispatchEvent(
        new CustomEvent('hervis:app-einladung', {
          detail: { pfad: '/onboarding?mode=quiz', titel: t('angebot_thema'), hinweis: t('angebot_hinweis') },
        }),
      );
    });
    $('[data-fertig]', angebot).addEventListener('click', async () => {
      beschaeftigt(angebot, true);
      await entschieden();
      verlassen();
    });

    /* „Später" oben: ohne Stempel zum Ziel — beim nächsten Login wieder hier. */
    const spaeter = $('[data-spaeter]');
    spaeter.href = weiter;
    spaeter.addEventListener('click', (e) => {
      e.preventDefault();
      verlassen();
    });

    /* ---------------------------------------------------------------- Start */

    const starten = async () => {
      if (vorschau) {
        melden(t('vorschau'));
        planen();
      } else {
        if (!api || !(await api.verfuegbar())) return verlassen();

        // Mit Client-ID: Name und Adresse über die Customer Account API.
        let zurueck = null;
        if (wurzel.dataset.kontoClient && window.hervisKonto && !speicher.lesen(K.ohne)) {
          konto = window.hervisKonto({
            client: wurzel.dataset.kontoClient,
            shop: wurzel.dataset.shop,
            kunde: wurzel.dataset.kunde,
            email: wurzel.dataset.email,
            rueck: location.origin + wurzel.dataset.rueck,
          });
          try {
            zurueck = await konto.rueckkehr();
          } catch {
            speicher.setzen(K.ohne, true);
            konto = null;
          }
        }

        let p360;
        try {
          [kontoFelder, p360] = await Promise.all([
            api.lesen('/api/account/profile'),
            api.lesen('/api/account/profile360'),
          ]);
        } catch {
          return verlassen();
        }
        kontoFelder = istProfil(kontoFelder) ? kontoFelder : {};
        profil = istProfil(p360?.profile) ? normal(p360.profile) : leeresProfil();
        if (profil.onboarding.requiredDoneAt) return verlassen();
        planen();

        // Braucht der Plan die Customer Account API, aber es gibt kein Token:
        // einmal der stille Umweg (verlässt die Seite), sonst ohne sie.
        const braucht = (fragtName && plan.includes('identitaet')) || plan.includes('adresse');
        if (konto && braucht && !konto.tokenGueltig() && !(await konto.erneuern())) {
          const zuletzt = Number(speicher.lesen(K.umweg)) || 0;
          if (!zurueck && Date.now() - zuletzt > 60000) {
            speicher.setzen(K.umweg, Date.now());
            return konto.anmelden({ schritt: 'start' });
          }
          speicher.setzen(K.ohne, true);
          konto = null;
          planen();
        }
      }

      if (!plan.length) {
        await aendern((p) => gestempelt(p, 'requiredDoneAt')).catch(() => {});
        return verlassen();
      }
      fortschritt.replaceChildren(...plan.map(() => document.createElement('li')));
      weiterSchritt();
    };
    // Nach jedem Login steht diese Seite im Weg — sie darf nie hängen bleiben.
    starten().catch(() => verlassen());
  })();

  } catch(e) { console.error(e); }
})();
})();
